'use strict';

var React = require('react');
var events = require('events');
var require$$2$1 = require('react/jsx-runtime');
var react = require('@emotion/react');

function _interopNamespaceDefault(e) {
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
				var args = [null];
				args.push.apply(args, arguments);
				var Ctor = Function.bind.apply(f, args);
				return new Ctor();
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var propTypes = {exports: {}};

var reactIs$1 = {exports: {}};

var reactIs_production_min$1 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$1;

function requireReactIs_production_min$1 () {
	if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
	hasRequiredReactIs_production_min$1 = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min$1.AsyncMode=l;reactIs_production_min$1.ConcurrentMode=m;reactIs_production_min$1.ContextConsumer=k;reactIs_production_min$1.ContextProvider=h;reactIs_production_min$1.Element=c;reactIs_production_min$1.ForwardRef=n;reactIs_production_min$1.Fragment=e;reactIs_production_min$1.Lazy=t;reactIs_production_min$1.Memo=r;reactIs_production_min$1.Portal=d;
	reactIs_production_min$1.Profiler=g;reactIs_production_min$1.StrictMode=f;reactIs_production_min$1.Suspense=p;reactIs_production_min$1.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min$1.isConcurrentMode=A;reactIs_production_min$1.isContextConsumer=function(a){return z(a)===k};reactIs_production_min$1.isContextProvider=function(a){return z(a)===h};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min$1.isForwardRef=function(a){return z(a)===n};reactIs_production_min$1.isFragment=function(a){return z(a)===e};reactIs_production_min$1.isLazy=function(a){return z(a)===t};
	reactIs_production_min$1.isMemo=function(a){return z(a)===r};reactIs_production_min$1.isPortal=function(a){return z(a)===d};reactIs_production_min$1.isProfiler=function(a){return z(a)===g};reactIs_production_min$1.isStrictMode=function(a){return z(a)===f};reactIs_production_min$1.isSuspense=function(a){return z(a)===p};
	reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min$1.typeOf=z;
	return reactIs_production_min$1;
}

var reactIs_development$1 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$1;

function requireReactIs_development$1 () {
	if (hasRequiredReactIs_development$1) return reactIs_development$1;
	hasRequiredReactIs_development$1 = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development$1.AsyncMode = AsyncMode;
	reactIs_development$1.ConcurrentMode = ConcurrentMode;
	reactIs_development$1.ContextConsumer = ContextConsumer;
	reactIs_development$1.ContextProvider = ContextProvider;
	reactIs_development$1.Element = Element;
	reactIs_development$1.ForwardRef = ForwardRef;
	reactIs_development$1.Fragment = Fragment;
	reactIs_development$1.Lazy = Lazy;
	reactIs_development$1.Memo = Memo;
	reactIs_development$1.Portal = Portal;
	reactIs_development$1.Profiler = Profiler;
	reactIs_development$1.StrictMode = StrictMode;
	reactIs_development$1.Suspense = Suspense;
	reactIs_development$1.isAsyncMode = isAsyncMode;
	reactIs_development$1.isConcurrentMode = isConcurrentMode;
	reactIs_development$1.isContextConsumer = isContextConsumer;
	reactIs_development$1.isContextProvider = isContextProvider;
	reactIs_development$1.isElement = isElement;
	reactIs_development$1.isForwardRef = isForwardRef;
	reactIs_development$1.isFragment = isFragment;
	reactIs_development$1.isLazy = isLazy;
	reactIs_development$1.isMemo = isMemo;
	reactIs_development$1.isPortal = isPortal;
	reactIs_development$1.isProfiler = isProfiler;
	reactIs_development$1.isStrictMode = isStrictMode;
	reactIs_development$1.isSuspense = isSuspense;
	reactIs_development$1.isValidElementType = isValidElementType;
	reactIs_development$1.typeOf = typeOf;
	  })();
	}
	return reactIs_development$1;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs$1.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs$1.exports = requireReactIs_production_min$1();
	} else {
	  reactIs$1.exports = requireReactIs_development$1();
	}
	return reactIs$1.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes.exports;
var PropTypes = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e)){var o=e.length;for(t=0;t<o;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);}else for(f in e)e[f]&&(n&&(n+=" "),n+=f);return n}function clsx(){for(var e,t,f=0,n="",o=arguments.length;f<o;f++)(e=arguments[f])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

function composeClasses(slots, getUtilityClass, classes = undefined) {
  const output = {};
  Object.keys(slots).forEach(
  // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
  // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
  slot => {
    output[slot] = slots[slot].reduce((acc, key) => {
      if (key) {
        const utilityClass = getUtilityClass(key);
        if (utilityClass !== '') {
          acc.push(utilityClass);
        }
        if (classes && classes[key]) {
          acc.push(classes[key]);
        }
      }
      return acc;
    }, []).join(' ');
  });
  return output;
}

/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage$1(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe if we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
  /* eslint-disable prefer-template */
  let url = 'https://mui.com/production-error/?code=' + code;
  for (let i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }
  return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

var formatMuiErrorMessage = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: formatMuiErrorMessage$1
});

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize$1(string) {
  if (typeof string !== 'string') {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: \`capitalize(string)\` expects a string argument.` : formatMuiErrorMessage$1(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var capitalize = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: capitalize$1
});

/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param {object} defaultProps
 * @param {object} props
 * @returns {object} resolved props
 */
function resolveProps(defaultProps, props) {
  const output = _extends$1({}, props);
  Object.keys(defaultProps).forEach(propName => {
    if (propName.toString().match(/^(components|slots)$/)) {
      output[propName] = _extends$1({}, defaultProps[propName], output[propName]);
    } else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
      const defaultSlotProps = defaultProps[propName] || {};
      const slotProps = props[propName];
      output[propName] = {};
      if (!slotProps || !Object.keys(slotProps)) {
        // Reduce the iteration if the slot props is empty
        output[propName] = defaultSlotProps;
      } else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) {
        // Reduce the iteration if the default slot props is empty
        output[propName] = slotProps;
      } else {
        output[propName] = _extends$1({}, slotProps);
        Object.keys(defaultSlotProps).forEach(slotPropName => {
          output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
        });
      }
    } else if (output[propName] === undefined) {
      output[propName] = defaultProps[propName];
    }
  });
  return output;
}

function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }
  return resolveProps(theme.components[name].defaultProps, props);
}

// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function isPlainObject(item) {
  if (typeof item !== 'object' || item === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(item);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
  if (!isPlainObject(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach(key => {
    output[key] = deepClone(source[key]);
  });
  return output;
}
function deepmerge$1(target, source, options = {
  clone: true
}) {
  const output = options.clone ? _extends$1({}, target) : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(key => {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }
      if (isPlainObject(source[key]) && key in target && isPlainObject(target[key])) {
        // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge$1(target[key], source[key], options);
      } else if (options.clone) {
        output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}

var deepmerge = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: deepmerge$1,
  isPlainObject: isPlainObject
});

const _excluded$a = ["values", "unit", "step"];
const sortBreakpointsValues = values => {
  const breakpointsAsArray = Object.keys(values).map(key => ({
    key,
    val: values[key]
  })) || [];
  // Sort in ascending order
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return _extends$1({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
};

// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
  const {
      // The breakpoint **start** at this value.
      // For instance with the first breakpoint xs: [xs, sm).
      values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
      },
      unit = 'px',
      step = 5
    } = breakpoints,
    other = _objectWithoutPropertiesLoose(breakpoints, _excluded$a);
  const sortedValues = sortBreakpointsValues(values);
  const keys = Object.keys(sortedValues);
  function up(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    // handle first and last key separately, for better readability
    const keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
      return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }
    return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
  }
  return _extends$1({
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}

const shape = {
  borderRadius: 4
};
var shape$1 = shape;

const responsivePropType = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
var responsivePropType$1 = responsivePropType;

function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return deepmerge$1(acc, item, {
    clone: false // No need to clone deep, it's way faster.
  });
}

// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const values = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536 // large screen
};
const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: key => `@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }
  if (typeof propValue === 'object') {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      // key is breakpoint
      if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;
  const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style);
}

function getPath(obj, path, checkVars = true) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  // Check if CSS variables are used
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split('.').reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path.split('.').reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value;
  if (typeof themeMapping === 'function') {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (transform) {
    value = transform(value, userValue, themeMapping);
  }
  return value;
}
function style$1(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform
  } = options;

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};
    const styleFromPropValue = propValueFinal => {
      let value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : capitalize$1(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, propValue, styleFromPropValue);
  };
  fn.propTypes = process.env.NODE_ENV !== 'production' ? {
    [prop]: responsivePropType$1
  } : {};
  fn.filterProps = [prop];
  return fn;
}

function memoize$1(fn) {
  const cache = {};
  return arg => {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  };
}

const properties = {
  m: 'margin',
  p: 'padding'
};
const directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
const aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
};

// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const getCssProperties = memoize$1(prop => {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  const [a, b] = prop.split('');
  const property = properties[a];
  const direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(dir => property + dir) : [property + direction];
});
const marginKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginInline', 'marginInlineStart', 'marginInlineEnd', 'marginBlock', 'marginBlockStart', 'marginBlockEnd'];
const paddingKeys = ['p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY', 'paddingInline', 'paddingInlineStart', 'paddingInlineEnd', 'paddingBlock', 'paddingBlockStart', 'paddingBlockEnd'];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;
  const themeSpacing = (_getPath = getPath(theme, themeKey, false)) != null ? _getPath : defaultValue;
  if (typeof themeSpacing === 'number') {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }
      if (process.env.NODE_ENV !== 'production') {
        if (typeof abs !== 'number') {
          console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${abs}.`);
        }
      }
      return themeSpacing * abs;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }
      if (process.env.NODE_ENV !== 'production') {
        if (!Number.isInteger(abs)) {
          console.error([`MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.` + `You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`].join('\n'));
        } else if (abs > themeSpacing.length - 1) {
          console.error([`MUI: The value provided (${abs}) overflows.`, `The supported values are: ${JSON.stringify(themeSpacing)}.`, `${abs} > ${themeSpacing.length - 1}, you need to add the missing values.`].join('\n'));
        }
      }
      return themeSpacing[abs];
    };
  }
  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }
  if (process.env.NODE_ENV !== 'production') {
    console.error([`MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`, 'It should be a number, an array or a function.'].join('\n'));
  }
  return () => undefined;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }
  const abs = Math.abs(propValue);
  const transformed = transformer(abs);
  if (propValue >= 0) {
    return transformed;
  }
  if (typeof transformed === 'number') {
    return -transformed;
  }
  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
  return propValue => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue(transformer, propValue);
    return acc;
  }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
  // Using a hash computation over an array iteration could be faster, but with only 28 items,
  // it's doesn't worth the bundle size.
  if (keys.indexOf(prop) === -1) {
    return null;
  }
  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return handleBreakpoints(props, propValue, styleFromPropValue);
}
function style(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map(prop => resolveCssProperty(props, keys, prop, transformer)).reduce(merge, {});
}
function margin(props) {
  return style(props, marginKeys);
}
margin.propTypes = process.env.NODE_ENV !== 'production' ? marginKeys.reduce((obj, key) => {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};
margin.filterProps = marginKeys;
function padding(props) {
  return style(props, paddingKeys);
}
padding.propTypes = process.env.NODE_ENV !== 'production' ? paddingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};
padding.filterProps = paddingKeys;
process.env.NODE_ENV !== 'production' ? spacingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType$1;
  return obj;
}, {}) : {};

// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.

function createSpacing(spacingInput = 8) {
  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  }

  // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
  // Smaller components, such as icons, can align to a 4dp grid.
  // https://m2.material.io/design/layout/understanding-layout.html
  const transform = createUnarySpacing({
    spacing: spacingInput
  });
  const spacing = (...argsInput) => {
    if (process.env.NODE_ENV !== 'production') {
      if (!(argsInput.length <= 4)) {
        console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);
      }
    }
    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map(argument => {
      const output = transform(argument);
      return typeof output === 'number' ? `${output}px` : output;
    }).join(' ');
  };
  spacing.mui = true;
  return spacing;
}

function compose(...styles) {
  const handlers = styles.reduce((acc, style) => {
    style.filterProps.forEach(prop => {
      acc[prop] = style;
    });
    return acc;
  }, {});

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return merge(acc, handlers[prop](props));
      }
      return acc;
    }, {});
  };
  fn.propTypes = process.env.NODE_ENV !== 'production' ? styles.reduce((acc, style) => Object.assign(acc, style.propTypes), {}) : {};
  fn.filterProps = styles.reduce((acc, style) => acc.concat(style.filterProps), []);
  return fn;
}

function borderTransform(value) {
  if (typeof value !== 'number') {
    return value;
  }
  return `${value}px solid`;
}
function createBorderStyle(prop, transform) {
  return style$1({
    prop,
    themeKey: 'borders',
    transform
  });
}
const border$1 = createBorderStyle('border', borderTransform);
const borderTop = createBorderStyle('borderTop', borderTransform);
const borderRight = createBorderStyle('borderRight', borderTransform);
const borderBottom = createBorderStyle('borderBottom', borderTransform);
const borderLeft = createBorderStyle('borderLeft', borderTransform);
const borderColor = createBorderStyle('borderColor');
const borderTopColor = createBorderStyle('borderTopColor');
const borderRightColor = createBorderStyle('borderRightColor');
const borderBottomColor = createBorderStyle('borderBottomColor');
const borderLeftColor = createBorderStyle('borderLeftColor');
const outline = createBorderStyle('outline', borderTransform);
const outlineColor = createBorderStyle('outlineColor');

// false positive
// eslint-disable-next-line react/function-component-definition
const borderRadius = props => {
  if (props.borderRadius !== undefined && props.borderRadius !== null) {
    const transformer = createUnaryUnit(props.theme, 'shape.borderRadius', 4, 'borderRadius');
    const styleFromPropValue = propValue => ({
      borderRadius: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borderRadius.propTypes = process.env.NODE_ENV !== 'production' ? {
  borderRadius: responsivePropType$1
} : {};
borderRadius.filterProps = ['borderRadius'];
compose(border$1, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);

// false positive
// eslint-disable-next-line react/function-component-definition
const gap = props => {
  if (props.gap !== undefined && props.gap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8, 'gap');
    const styleFromPropValue = propValue => ({
      gap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.gap, styleFromPropValue);
  }
  return null;
};
gap.propTypes = process.env.NODE_ENV !== 'production' ? {
  gap: responsivePropType$1
} : {};
gap.filterProps = ['gap'];

// false positive
// eslint-disable-next-line react/function-component-definition
const columnGap = props => {
  if (props.columnGap !== undefined && props.columnGap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8, 'columnGap');
    const styleFromPropValue = propValue => ({
      columnGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
columnGap.propTypes = process.env.NODE_ENV !== 'production' ? {
  columnGap: responsivePropType$1
} : {};
columnGap.filterProps = ['columnGap'];

// false positive
// eslint-disable-next-line react/function-component-definition
const rowGap = props => {
  if (props.rowGap !== undefined && props.rowGap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8, 'rowGap');
    const styleFromPropValue = propValue => ({
      rowGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
rowGap.propTypes = process.env.NODE_ENV !== 'production' ? {
  rowGap: responsivePropType$1
} : {};
rowGap.filterProps = ['rowGap'];
const gridColumn = style$1({
  prop: 'gridColumn'
});
const gridRow = style$1({
  prop: 'gridRow'
});
const gridAutoFlow = style$1({
  prop: 'gridAutoFlow'
});
const gridAutoColumns = style$1({
  prop: 'gridAutoColumns'
});
const gridAutoRows = style$1({
  prop: 'gridAutoRows'
});
const gridTemplateColumns = style$1({
  prop: 'gridTemplateColumns'
});
const gridTemplateRows = style$1({
  prop: 'gridTemplateRows'
});
const gridTemplateAreas = style$1({
  prop: 'gridTemplateAreas'
});
const gridArea = style$1({
  prop: 'gridArea'
});
compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);

function paletteTransform(value, userValue) {
  if (userValue === 'grey') {
    return userValue;
  }
  return value;
}
const color = style$1({
  prop: 'color',
  themeKey: 'palette',
  transform: paletteTransform
});
const bgcolor = style$1({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
const backgroundColor = style$1({
  prop: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
compose(color, bgcolor, backgroundColor);

function sizingTransform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = style$1({
  prop: 'width',
  transform: sizingTransform
});
const maxWidth = props => {
  if (props.maxWidth !== undefined && props.maxWidth !== null) {
    const styleFromPropValue = propValue => {
      var _props$theme, _props$theme2;
      const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || values[propValue];
      if (!breakpoint) {
        return {
          maxWidth: sizingTransform(propValue)
        };
      }
      if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') {
        return {
          maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
        };
      }
      return {
        maxWidth: breakpoint
      };
    };
    return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = ['maxWidth'];
const minWidth = style$1({
  prop: 'minWidth',
  transform: sizingTransform
});
const height = style$1({
  prop: 'height',
  transform: sizingTransform
});
const maxHeight = style$1({
  prop: 'maxHeight',
  transform: sizingTransform
});
const minHeight = style$1({
  prop: 'minHeight',
  transform: sizingTransform
});
style$1({
  prop: 'size',
  cssProperty: 'width',
  transform: sizingTransform
});
style$1({
  prop: 'size',
  cssProperty: 'height',
  transform: sizingTransform
});
const boxSizing = style$1({
  prop: 'boxSizing'
});
compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);

const defaultSxConfig = {
  // borders
  border: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderTop: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderRight: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderBottom: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderLeft: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderColor: {
    themeKey: 'palette'
  },
  borderTopColor: {
    themeKey: 'palette'
  },
  borderRightColor: {
    themeKey: 'palette'
  },
  borderBottomColor: {
    themeKey: 'palette'
  },
  borderLeftColor: {
    themeKey: 'palette'
  },
  outline: {
    themeKey: 'borders',
    transform: borderTransform
  },
  outlineColor: {
    themeKey: 'palette'
  },
  borderRadius: {
    themeKey: 'shape.borderRadius',
    style: borderRadius
  },
  // palette
  color: {
    themeKey: 'palette',
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: 'palette',
    cssProperty: 'backgroundColor',
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: 'palette',
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding
  },
  pt: {
    style: padding
  },
  pr: {
    style: padding
  },
  pb: {
    style: padding
  },
  pl: {
    style: padding
  },
  px: {
    style: padding
  },
  py: {
    style: padding
  },
  padding: {
    style: padding
  },
  paddingTop: {
    style: padding
  },
  paddingRight: {
    style: padding
  },
  paddingBottom: {
    style: padding
  },
  paddingLeft: {
    style: padding
  },
  paddingX: {
    style: padding
  },
  paddingY: {
    style: padding
  },
  paddingInline: {
    style: padding
  },
  paddingInlineStart: {
    style: padding
  },
  paddingInlineEnd: {
    style: padding
  },
  paddingBlock: {
    style: padding
  },
  paddingBlockStart: {
    style: padding
  },
  paddingBlockEnd: {
    style: padding
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: false,
    transform: value => ({
      '@media print': {
        display: value
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: 'zIndex'
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: 'shadows'
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: 'typography'
  },
  fontSize: {
    themeKey: 'typography'
  },
  fontStyle: {
    themeKey: 'typography'
  },
  fontWeight: {
    themeKey: 'typography'
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: false,
    themeKey: 'typography'
  }
};
var defaultSxConfig$1 = defaultSxConfig;

function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every(object => union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
  return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
function unstable_createStyleFunctionSx() {
  function getThemeValue(prop, val, theme, config) {
    const props = {
      [prop]: val,
      theme
    };
    const options = config[prop];
    if (!options) {
      return {
        [prop]: val
      };
    }
    const {
      cssProperty = prop,
      themeKey,
      transform,
      style
    } = options;
    if (val == null) {
      return null;
    }

    // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
    if (themeKey === 'typography' && val === 'inherit') {
      return {
        [prop]: val
      };
    }
    const themeMapping = getPath(theme, themeKey) || {};
    if (style) {
      return style(props);
    }
    const styleFromPropValue = propValueFinal => {
      let value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : capitalize$1(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, val, styleFromPropValue);
  }
  function styleFunctionSx(props) {
    var _theme$unstable_sxCon;
    const {
      sx,
      theme = {}
    } = props || {};
    if (!sx) {
      return null; // Emotion & styled-components will neglect null
    }
    const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : defaultSxConfig$1;

    /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */
    function traverse(sxInput) {
      let sxObject = sxInput;
      if (typeof sxInput === 'function') {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== 'object') {
        // value
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      const emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css = emptyBreakpoints;
      Object.keys(sxObject).forEach(styleKey => {
        const value = callIfFn(sxObject[styleKey], theme);
        if (value !== null && value !== undefined) {
          if (typeof value === 'object') {
            if (config[styleKey]) {
              css = merge(css, getThemeValue(styleKey, value, theme, config));
            } else {
              const breakpointsValues = handleBreakpoints({
                theme
              }, value, x => ({
                [styleKey]: x
              }));
              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css[styleKey] = styleFunctionSx({
                  sx: value,
                  theme
                });
              } else {
                css = merge(css, breakpointsValues);
              }
            }
          } else {
            css = merge(css, getThemeValue(styleKey, value, theme, config));
          }
        }
      });
      return removeUnusedBreakpoints(breakpointsKeys, css);
    }
    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }
  return styleFunctionSx;
}
const styleFunctionSx$1 = unstable_createStyleFunctionSx();
styleFunctionSx$1.filterProps = ['sx'];
var styleFunctionSx$2 = styleFunctionSx$1;

/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */
function applyStyles(key, styles) {
  // @ts-expect-error this is 'any' type
  const theme = this;
  if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
    // If CssVarsProvider is used as a provider,
    // returns '* :where([data-mui-color-scheme="light|dark"]) &'
    const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
    return {
      [selector]: styles
    };
  }
  if (theme.palette.mode === key) {
    return styles;
  }
  return {};
}

const _excluded$9 = ["breakpoints", "palette", "spacing", "shape"];
function createTheme$2(options = {}, ...args) {
  const {
      breakpoints: breakpointsInput = {},
      palette: paletteInput = {},
      spacing: spacingInput,
      shape: shapeInput = {}
    } = options,
    other = _objectWithoutPropertiesLoose(options, _excluded$9);
  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing = createSpacing(spacingInput);
  let muiTheme = deepmerge$1({
    breakpoints,
    direction: 'ltr',
    components: {},
    // Inject component definitions.
    palette: _extends$1({
      mode: 'light'
    }, paletteInput),
    spacing,
    shape: _extends$1({}, shape$1, shapeInput)
  }, other);
  muiTheme.applyStyles = applyStyles;
  muiTheme = args.reduce((acc, argument) => deepmerge$1(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = _extends$1({}, defaultSxConfig$1, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx$2({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}

var createTheme$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: createTheme$2,
  private_createBreakpoints: createBreakpoints,
  unstable_applyStyles: applyStyles
});

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

var isBrowser$3 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$3 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$3 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$3 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error(noComponentSelectorMessage);
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var isBrowser$2 = typeof document !== 'undefined';

var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = React__namespace['useInsertion' + 'Effect'] ? React__namespace['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser$2 ? syncFallback : useInsertionEffect || syncFallback;

var testOmitPropsOnStringTag = isPropValid;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var isBrowser$1 = typeof document !== 'undefined';

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  if (!isBrowser$1 && rules !== undefined) {
    var _ref2;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/React__namespace.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var createStyled$2 = function createStyled(tag, options) {
  if (process.env.NODE_ENV !== 'production') {
    if (tag === undefined) {
      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
    }
  }

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (process.env.NODE_ENV !== 'production' && args[0][0] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (process.env.NODE_ENV !== 'production' && args[0][i] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = react.withEmotionCache(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = React__namespace.useContext(react.ThemeContext);
      }

      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/React__namespace.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && process.env.NODE_ENV !== 'production') {
          return 'NO_COMPONENT_SELECTOR';
        } // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, _extends$1({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};

var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = createStyled$2.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (process.env.NODE_ENV !== 'production') {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (process.env.NODE_ENV !== 'production') {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? charat(characters, --position) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < length ? charat(characters, position++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && charat(characters, length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset: if (ampersand == -1) characters = replace(characters, /\f/g, '');
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: element.value = element.props.join(',');
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? element.parent.children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace(value, ':', ':' + WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return WEBKIT + value + MS + value + value;
  }

  return value;
}

var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;

    case KEYFRAMES:
      return serialize([copy(element, {
        value: replace(element.value, '@', '@' + WEBKIT)
      })], callback);

    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize([copy(element, {
              props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize([copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var isBrowser = typeof document !== 'undefined';
var getServerStylisCache = isBrowser ? undefined : weakMemoize(function () {
  return memoize(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (process.env.NODE_ENV !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if (isBrowser && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  if (isBrowser) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (process.env.NODE_ENV !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  if (isBrowser) {
    var currentSheet;
    var finalizingPlugins = [stringify, process.env.NODE_ENV !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify];

    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    }; // $FlowFixMe


    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

let cache;
if (typeof document === 'object') {
  cache = createCache({
    key: 'css',
    prepend: true
  });
}
function StyledEngineProvider(props) {
  const {
    injectFirst,
    children
  } = props;
  return injectFirst && cache ? /*#__PURE__*/require$$2$1.jsx(react.CacheProvider, {
    value: cache,
    children: children
  }) : children;
}
process.env.NODE_ENV !== "production" ? StyledEngineProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: PropTypes.bool
} : void 0;

function isEmpty$1(obj) {
  return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function GlobalStyles(props) {
  const {
    styles,
    defaultTheme = {}
  } = props;
  const globalStyles = typeof styles === 'function' ? themeInput => styles(isEmpty$1(themeInput) ? defaultTheme : themeInput) : styles;
  return /*#__PURE__*/require$$2$1.jsx(react.Global, {
    styles: globalStyles
  });
}
process.env.NODE_ENV !== "production" ? GlobalStyles.propTypes = {
  defaultTheme: PropTypes.object,
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object, PropTypes.func])
} : void 0;

/**
 * @mui/styled-engine v5.15.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function styled$2(tag, options) {
  const stylesFactory = newStyled(tag, options);
  if (process.env.NODE_ENV !== 'production') {
    return (...styles) => {
      const component = typeof tag === 'string' ? `"${tag}"` : 'component';
      if (styles.length === 0) {
        console.error([`MUI: Seems like you called \`styled(${component})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join('\n'));
      } else if (styles.some(style => style === undefined)) {
        console.error(`MUI: the styled(${component})(...args) API requires all its args to be defined.`);
      }
      return stylesFactory(...styles);
    };
  }
  return stylesFactory;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const internal_processStyles = (tag, processor) => {
  // Emotion attaches all the styles as `__emotion_styles`.
  // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
};

var styledEngine = /*#__PURE__*/Object.freeze({
  __proto__: null,
  GlobalStyles: GlobalStyles,
  StyledEngineProvider: StyledEngineProvider,
  ThemeContext: react.ThemeContext,
  css: react.css,
  default: styled$2,
  internal_processStyles: internal_processStyles,
  keyframes: react.keyframes
});

function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme$2(defaultTheme = null) {
  const contextTheme = React__namespace.useContext(react.ThemeContext);
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}

const systemDefaultTheme$1 = createTheme$2();
function useTheme$1(defaultTheme = systemDefaultTheme$1) {
  return useTheme$2(defaultTheme);
}

function useThemeProps$1({
  props,
  name,
  defaultTheme,
  themeId
}) {
  let theme = useTheme$1(defaultTheme);
  if (themeId) {
    theme = theme[themeId] || theme;
  }
  const mergedProps = getThemeProps({
    theme,
    name,
    props
  });
  return mergedProps;
}

const _excluded$8 = ["sx"];
const splitProps = props => {
  var _props$theme$unstable, _props$theme;
  const result = {
    systemProps: {},
    otherProps: {}
  };
  const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : defaultSxConfig$1;
  Object.keys(props).forEach(prop => {
    if (config[prop]) {
      result.systemProps[prop] = props[prop];
    } else {
      result.otherProps[prop] = props[prop];
    }
  });
  return result;
};
function extendSxProp(props) {
  const {
      sx: inSx
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$8);
  const {
    systemProps,
    otherProps
  } = splitProps(other);
  let finalSx;
  if (Array.isArray(inSx)) {
    finalSx = [systemProps, ...inSx];
  } else if (typeof inSx === 'function') {
    finalSx = (...args) => {
      const result = inSx(...args);
      if (!isPlainObject(result)) {
        return systemProps;
      }
      return _extends$1({}, systemProps, result);
    };
  } else {
    finalSx = _extends$1({}, systemProps, inSx);
  }
  return _extends$1({}, otherProps, {
    sx: finalSx
  });
}

var styleFunctionSx = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: styleFunctionSx$2,
  extendSxProp: extendSxProp,
  unstable_createStyleFunctionSx: unstable_createStyleFunctionSx,
  unstable_defaultSxConfig: defaultSxConfig$1
});

const defaultGenerator = componentName => componentName;
const createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },
    generate(componentName) {
      return generate(componentName);
    },
    reset() {
      generate = defaultGenerator;
    }
  };
};
const ClassNameGenerator = createClassNameGenerator();
var ClassNameGenerator$1 = ClassNameGenerator;

const globalStateClasses = {
  active: 'active',
  checked: 'checked',
  completed: 'completed',
  disabled: 'disabled',
  error: 'error',
  expanded: 'expanded',
  focused: 'focused',
  focusVisible: 'focusVisible',
  open: 'open',
  readOnly: 'readOnly',
  required: 'required',
  selected: 'selected'
};
function generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
  const globalStateClass = globalStateClasses[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${ClassNameGenerator$1.generate(componentName)}-${slot}`;
}

function createMixins(breakpoints, mixins) {
  return _extends$1({
    toolbar: {
      minHeight: 56,
      [breakpoints.up('xs')]: {
        '@media (orientation: landscape)': {
          minHeight: 48
        }
      },
      [breakpoints.up('sm')]: {
        minHeight: 64
      }
    }
  }, mixins);
}

var colorManipulator = {};

var interopRequireDefault = {exports: {}};

(function (module) {
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (interopRequireDefault));

var interopRequireDefaultExports = interopRequireDefault.exports;

var require$$1$1 = /*@__PURE__*/getAugmentedNamespace(formatMuiErrorMessage);

function clamp$1(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
  return Math.max(min, Math.min(val, max));
}

var clamp = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: clamp$1
});

var require$$2 = /*@__PURE__*/getAugmentedNamespace(clamp);

var _interopRequireDefault$4 = interopRequireDefaultExports;
Object.defineProperty(colorManipulator, "__esModule", {
  value: true
});
colorManipulator.alpha = alpha;
colorManipulator.blend = blend;
colorManipulator.colorChannel = void 0;
var darken_1 = colorManipulator.darken = darken;
colorManipulator.decomposeColor = decomposeColor;
colorManipulator.emphasize = emphasize;
var getContrastRatio_1 = colorManipulator.getContrastRatio = getContrastRatio;
colorManipulator.getLuminance = getLuminance;
colorManipulator.hexToRgb = hexToRgb;
colorManipulator.hslToRgb = hslToRgb;
var lighten_1 = colorManipulator.lighten = lighten;
colorManipulator.private_safeAlpha = private_safeAlpha;
colorManipulator.private_safeColorChannel = void 0;
colorManipulator.private_safeDarken = private_safeDarken;
colorManipulator.private_safeEmphasize = private_safeEmphasize;
colorManipulator.private_safeLighten = private_safeLighten;
colorManipulator.recomposeColor = recomposeColor;
colorManipulator.rgbToHex = rgbToHex;
var _formatMuiErrorMessage2 = _interopRequireDefault$4(require$$1$1);
var _clamp = _interopRequireDefault$4(require$$2);
/* eslint-disable @typescript-eslint/naming-convention */

/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clampWrapper(value, min = 0, max = 1) {
  if (process.env.NODE_ENV !== 'production') {
    if (value < min || value > max) {
      console.error(`MUI: The value provided ${value} is out of range [${min}, ${max}].`);
    }
  }
  return (0, _clamp.default)(value, min, max);
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */
function hexToRgb(color) {
  color = color.slice(1);
  const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
  let colors = color.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map(n => n + n);
  }
  return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index) => {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', ')})` : '';
}
function intToHex(int) {
  const hex = int.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */
function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }
  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }
  const marker = color.indexOf('(');
  const type = color.substring(0, marker);
  if (['rgb', 'rgba', 'hsl', 'hsla', 'color'].indexOf(type) === -1) {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${color}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, _formatMuiErrorMessage2.default)(9, color));
  }
  let values = color.substring(marker + 1, color.length - 1);
  let colorSpace;
  if (type === 'color') {
    values = values.split(' ');
    colorSpace = values.shift();
    if (values.length === 4 && values[3].charAt(0) === '/') {
      values[3] = values[3].slice(1);
    }
    if (['srgb', 'display-p3', 'a98-rgb', 'prophoto-rgb', 'rec-2020'].indexOf(colorSpace) === -1) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${colorSpace}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, _formatMuiErrorMessage2.default)(10, colorSpace));
    }
  } else {
    values = values.split(',');
  }
  values = values.map(value => parseFloat(value));
  return {
    type,
    values,
    colorSpace
  };
}

/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */
const colorChannel = color => {
  const decomposedColor = decomposeColor(color);
  return decomposedColor.values.slice(0, 3).map((val, idx) => decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
colorManipulator.colorChannel = colorChannel;
const private_safeColorChannel = (color, warning) => {
  try {
    return colorChannel(color);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
};

/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
colorManipulator.private_safeColorChannel = private_safeColorChannel;
function recomposeColor(color) {
  const {
    type,
    colorSpace
  } = color;
  let {
    values
  } = color;
  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i) => i < 3 ? parseInt(n, 10) : n);
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = `${values[1]}%`;
    values[2] = `${values[2]}%`;
  }
  if (type.indexOf('color') !== -1) {
    values = `${colorSpace} ${values.join(' ')}`;
  } else {
    values = `${values.join(', ')}`;
  }
  return `${type}(${values})`;
}

/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */
function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }
  const {
    values
  } = decomposeColor(color);
  return `#${values.map((n, i) => intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}

/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */
function hslToRgb(color) {
  color = decomposeColor(color);
  const {
    values
  } = color;
  const h = values[0];
  const s = values[1] / 100;
  const l = values[2] / 100;
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  let type = 'rgb';
  const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }
  return recomposeColor({
    type,
    values: rgb
  });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);
  let rgb = color.type === 'hsl' || color.type === 'hsla' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(val => {
    if (color.type !== 'color') {
      val /= 255; // normalized
    }
    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  });

  // Truncate at 3 digits
  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */
function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}

/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function alpha(color, value) {
  color = decomposeColor(color);
  value = clampWrapper(value);
  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  if (color.type === 'color') {
    color.values[3] = `/${value}`;
  } else {
    color.values[3] = value;
  }
  return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
  try {
    return alpha(color, value);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
}

/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clampWrapper(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
  try {
    return darken(color, coefficient);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
}

/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clampWrapper(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  } else if (color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (1 - color.values[i]) * coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
  try {
    return lighten(color, coefficient);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
}

/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color, coefficient = 0.15) {
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
  try {
    return emphasize(color, coefficient);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
}

/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */
function blend(background, overlay, opacity, gamma = 1.0) {
  const blendChannel = (b, o) => Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
  const backgroundColor = decomposeColor(background);
  const overlayColor = decomposeColor(overlay);
  const rgb = [blendChannel(backgroundColor.values[0], overlayColor.values[0]), blendChannel(backgroundColor.values[1], overlayColor.values[1]), blendChannel(backgroundColor.values[2], overlayColor.values[2])];
  return recomposeColor({
    type: 'rgb',
    values: rgb
  });
}

const common = {
  black: '#000',
  white: '#fff'
};
var common$1 = common;

const grey$1 = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#f5f5f5',
  A200: '#eeeeee',
  A400: '#bdbdbd',
  A700: '#616161'
};
var grey$2 = grey$1;

const purple$1 = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};
var purple$2 = purple$1;

const red$1 = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var red$2 = red$1;

const orange$1 = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
var orange$2 = orange$1;

const blue$1 = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
var blue$2 = blue$1;

const lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};
var lightBlue$1 = lightBlue;

const green$1 = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
var green$2 = green$1;

const _excluded$7 = ["mode", "contrastThreshold", "tonalOffset"];
const light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.6)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common$1.white,
    default: common$1.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
const dark = {
  text: {
    primary: common$1.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#121212',
    default: '#121212'
  },
  action: {
    active: common$1.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
  const tonalOffsetLight = tonalOffset.light || tonalOffset;
  const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = lighten_1(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = darken_1(intent.main, tonalOffsetDark);
    }
  }
}
function getDefaultPrimary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: blue$2[200],
      light: blue$2[50],
      dark: blue$2[400]
    };
  }
  return {
    main: blue$2[700],
    light: blue$2[400],
    dark: blue$2[800]
  };
}
function getDefaultSecondary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: purple$2[200],
      light: purple$2[50],
      dark: purple$2[400]
    };
  }
  return {
    main: purple$2[500],
    light: purple$2[300],
    dark: purple$2[700]
  };
}
function getDefaultError(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: red$2[500],
      light: red$2[300],
      dark: red$2[700]
    };
  }
  return {
    main: red$2[700],
    light: red$2[400],
    dark: red$2[800]
  };
}
function getDefaultInfo(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: lightBlue$1[400],
      light: lightBlue$1[300],
      dark: lightBlue$1[700]
    };
  }
  return {
    main: lightBlue$1[700],
    light: lightBlue$1[500],
    dark: lightBlue$1[900]
  };
}
function getDefaultSuccess(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: green$2[400],
      light: green$2[300],
      dark: green$2[700]
    };
  }
  return {
    main: green$2[800],
    light: green$2[500],
    dark: green$2[900]
  };
}
function getDefaultWarning(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: orange$2[400],
      light: orange$2[300],
      dark: orange$2[700]
    };
  }
  return {
    main: '#ed6c02',
    // closest to orange[800] that pass 3:1.
    light: orange$2[500],
    dark: orange$2[900]
  };
}
function createPalette(palette) {
  const {
      mode = 'light',
      contrastThreshold = 3,
      tonalOffset = 0.2
    } = palette,
    other = _objectWithoutPropertiesLoose(palette, _excluded$7);
  const primary = palette.primary || getDefaultPrimary(mode);
  const secondary = palette.secondary || getDefaultSecondary(mode);
  const error = palette.error || getDefaultError(mode);
  const info = palette.info || getDefaultInfo(mode);
  const success = palette.success || getDefaultSuccess(mode);
  const warning = palette.warning || getDefaultWarning(mode);

  // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
  function getContrastText(background) {
    const contrastText = getContrastRatio_1(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
    if (process.env.NODE_ENV !== 'production') {
      const contrast = getContrastRatio_1(background, contrastText);
      if (contrast < 3) {
        console.error([`MUI: The contrast ratio of ${contrast}:1 for ${contrastText} on ${background}`, 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }
    return contrastText;
  }
  const augmentColor = ({
    color,
    name,
    mainShade = 500,
    lightShade = 300,
    darkShade = 700
  }) => {
    color = _extends$1({}, color);
    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }
    if (!color.hasOwnProperty('main')) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${name ? ` (${name})` : ''} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${mainShade}\` property.` : formatMuiErrorMessage$1(11, name ? ` (${name})` : '', mainShade));
    }
    if (typeof color.main !== 'string') {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${name ? ` (${name})` : ''} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(color.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : formatMuiErrorMessage$1(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
    }
    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);
    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }
    return color;
  };
  const modes = {
    dark,
    light
  };
  if (process.env.NODE_ENV !== 'production') {
    if (!modes[mode]) {
      console.error(`MUI: The palette mode \`${mode}\` is not supported.`);
    }
  }
  const paletteOutput = deepmerge$1(_extends$1({
    // A collection of common colors.
    common: _extends$1({}, common$1),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor({
      color: primary,
      name: 'primary'
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor({
      color: secondary,
      name: 'secondary',
      mainShade: 'A400',
      lightShade: 'A200',
      darkShade: 'A700'
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor({
      color: error,
      name: 'error'
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor({
      color: warning,
      name: 'warning'
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor({
      color: info,
      name: 'info'
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor({
      color: success,
      name: 'success'
    }),
    // The grey colors.
    grey: grey$2,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText,
    // Generate a rich color object.
    augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset
  }, modes[mode]), other);
  return paletteOutput;
}

const _excluded$6 = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function round(value) {
  return Math.round(value * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: 'uppercase'
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';

/**
 * @see @link{https://m2.material.io/design/typography/the-type-system.html}
 * @see @link{https://m2.material.io/design/typography/understanding-typography.html}
 */
function createTypography(palette, typography) {
  const _ref = typeof typography === 'function' ? typography(palette) : typography,
    {
      fontFamily = defaultFontFamily,
      // The default font size of the Material Specification.
      fontSize = 14,
      // px
      fontWeightLight = 300,
      fontWeightRegular = 400,
      fontWeightMedium = 500,
      fontWeightBold = 700,
      // Tell MUI what's the font-size on the html element.
      // 16px is the default font-size used by browsers.
      htmlFontSize = 16,
      // Apply the CSS properties to all the variants.
      allVariants,
      pxToRem: pxToRem2
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  if (process.env.NODE_ENV !== 'production') {
    if (typeof fontSize !== 'number') {
      console.error('MUI: `fontSize` is required to be a number.');
    }
    if (typeof htmlFontSize !== 'number') {
      console.error('MUI: `htmlFontSize` is required to be a number.');
    }
  }
  const coef = fontSize / 14;
  const pxToRem = pxToRem2 || (size => `${size / htmlFontSize * coef}rem`);
  const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing) => _extends$1({
    fontFamily,
    fontWeight,
    fontSize: pxToRem(size),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight
  }, fontFamily === defaultFontFamily ? {
    letterSpacing: `${round(letterSpacing / size)}em`
  } : {}, casing, allVariants);
  const variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: 'inherit',
      fontWeight: 'inherit',
      fontSize: 'inherit',
      lineHeight: 'inherit',
      letterSpacing: 'inherit'
    }
  };
  return deepmerge$1(_extends$1({
    htmlFontSize,
    pxToRem,
    fontFamily,
    fontSize,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep
  });
}

const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px) {
  return [`${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(',');
}

// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var shadows$1 = shadows;

const _excluded$5 = ["duration", "easing", "delay"];
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};

// Follow https://m2.material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(milliseconds) {
  return `${Math.round(milliseconds)}ms`;
}
function getAutoHeightDuration(height) {
  if (!height) {
    return 0;
  }
  const constant = height / 36;

  // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
  return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function createTransitions(inputTransitions) {
  const mergedEasing = _extends$1({}, easing, inputTransitions.easing);
  const mergedDuration = _extends$1({}, duration, inputTransitions.duration);
  const create = (props = ['all'], options = {}) => {
    const {
        duration: durationOption = mergedDuration.standard,
        easing: easingOption = mergedEasing.easeInOut,
        delay = 0
      } = options,
      other = _objectWithoutPropertiesLoose(options, _excluded$5);
    if (process.env.NODE_ENV !== 'production') {
      const isString = value => typeof value === 'string';
      // IE11 support, replace with Number.isNaN
      // eslint-disable-next-line no-restricted-globals
      const isNumber = value => !isNaN(parseFloat(value));
      if (!isString(props) && !Array.isArray(props)) {
        console.error('MUI: Argument "props" must be a string or Array.');
      }
      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error(`MUI: Argument "duration" must be a number or a string but found ${durationOption}.`);
      }
      if (!isString(easingOption)) {
        console.error('MUI: Argument "easing" must be a string.');
      }
      if (!isNumber(delay) && !isString(delay)) {
        console.error('MUI: Argument "delay" must be a number or a string.');
      }
      if (typeof options !== 'object') {
        console.error(['MUI: Secong argument of transition.create must be an object.', "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join('\n'));
      }
      if (Object.keys(other).length !== 0) {
        console.error(`MUI: Unrecognized argument(s) [${Object.keys(other).join(',')}].`);
      }
    }
    return (Array.isArray(props) ? props : [props]).map(animatedProp => `${animatedProp} ${typeof durationOption === 'string' ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : formatMs(delay)}`).join(',');
  };
  return _extends$1({
    getAutoHeightDuration,
    create
  }, inputTransitions, {
    easing: mergedEasing,
    duration: mergedDuration
  });
}

// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const zIndex = {
  mobileStepper: 1000,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var zIndex$1 = zIndex;

const _excluded$4 = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function createTheme(options = {}, ...args) {
  const {
      mixins: mixinsInput = {},
      palette: paletteInput = {},
      transitions: transitionsInput = {},
      typography: typographyInput = {}
    } = options,
    other = _objectWithoutPropertiesLoose(options, _excluded$4);
  if (options.vars) {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: \`vars\` is a private field used for CSS variables support.
Please use another name.` : formatMuiErrorMessage$1(18));
  }
  const palette = createPalette(paletteInput);
  const systemTheme = createTheme$2(options);
  let muiTheme = deepmerge$1(systemTheme, {
    mixins: createMixins(systemTheme.breakpoints, mixinsInput),
    palette,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows$1.slice(),
    typography: createTypography(palette, typographyInput),
    transitions: createTransitions(transitionsInput),
    zIndex: _extends$1({}, zIndex$1)
  });
  muiTheme = deepmerge$1(muiTheme, other);
  muiTheme = args.reduce((acc, argument) => deepmerge$1(acc, argument), muiTheme);
  if (process.env.NODE_ENV !== 'production') {
    // TODO v6: Refactor to use globalStateClassesMapping from @mui/utils once `readOnly` state class is used in Rating component.
    const stateClasses = ['active', 'checked', 'completed', 'disabled', 'error', 'expanded', 'focused', 'focusVisible', 'required', 'selected'];
    const traverse = (node, component) => {
      let key;

      // eslint-disable-next-line guard-for-in, no-restricted-syntax
      for (key in node) {
        const child = node[key];
        if (stateClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            const stateClass = generateUtilityClass('', key);
            console.error([`MUI: The \`${component}\` component increases ` + `the CSS specificity of the \`${key}\` internal state.`, 'You can not override it like this: ', JSON.stringify(node, null, 2), '', `Instead, you need to use the '&.${stateClass}' syntax:`, JSON.stringify({
              root: {
                [`&.${stateClass}`]: child
              }
            }, null, 2), '', 'https://mui.com/r/state-classes-guide'].join('\n'));
          }
          // Remove the style to prevent global conflicts.
          node[key] = {};
        }
      }
    };
    Object.keys(muiTheme.components).forEach(component => {
      const styleOverrides = muiTheme.components[component].styleOverrides;
      if (styleOverrides && component.indexOf('Mui') === 0) {
        traverse(styleOverrides, component);
      }
    });
  }
  muiTheme.unstable_sxConfig = _extends$1({}, defaultSxConfig$1, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx$2({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}

const defaultTheme = createTheme();
var defaultTheme$1 = defaultTheme;

var THEME_ID = '$$material';

function useThemeProps({
  props,
  name
}) {
  return useThemeProps$1({
    props,
    name,
    defaultTheme: defaultTheme$1,
    themeId: THEME_ID
  });
}

var createStyled$1 = {};

var _extends = {exports: {}};

var hasRequired_extends;

function require_extends () {
	if (hasRequired_extends) return _extends.exports;
	hasRequired_extends = 1;
	(function (module) {
		function _extends() {
		  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
		    for (var i = 1; i < arguments.length; i++) {
		      var source = arguments[i];
		      for (var key in source) {
		        if (Object.prototype.hasOwnProperty.call(source, key)) {
		          target[key] = source[key];
		        }
		      }
		    }
		    return target;
		  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
		  return _extends.apply(this, arguments);
		}
		module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (_extends));
	return _extends.exports;
}

var objectWithoutPropertiesLoose = {exports: {}};

var hasRequiredObjectWithoutPropertiesLoose;

function requireObjectWithoutPropertiesLoose () {
	if (hasRequiredObjectWithoutPropertiesLoose) return objectWithoutPropertiesLoose.exports;
	hasRequiredObjectWithoutPropertiesLoose = 1;
	(function (module) {
		function _objectWithoutPropertiesLoose(source, excluded) {
		  if (source == null) return {};
		  var target = {};
		  var sourceKeys = Object.keys(source);
		  var key, i;
		  for (i = 0; i < sourceKeys.length; i++) {
		    key = sourceKeys[i];
		    if (excluded.indexOf(key) >= 0) continue;
		    target[key] = source[key];
		  }
		  return target;
		}
		module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports; 
	} (objectWithoutPropertiesLoose));
	return objectWithoutPropertiesLoose.exports;
}

var require$$1 = /*@__PURE__*/getAugmentedNamespace(styledEngine);

var require$$4 = /*@__PURE__*/getAugmentedNamespace(deepmerge);

var require$$5 = /*@__PURE__*/getAugmentedNamespace(capitalize);

var reactIs = {exports: {}};

var reactIs_production_min = {};

/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
	function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}reactIs_production_min.ContextConsumer=h;reactIs_production_min.ContextProvider=g;reactIs_production_min.Element=b;reactIs_production_min.ForwardRef=l;reactIs_production_min.Fragment=d;reactIs_production_min.Lazy=q;reactIs_production_min.Memo=p;reactIs_production_min.Portal=c;reactIs_production_min.Profiler=f;reactIs_production_min.StrictMode=e;reactIs_production_min.Suspense=m;
	reactIs_production_min.SuspenseList=n;reactIs_production_min.isAsyncMode=function(){return !1};reactIs_production_min.isConcurrentMode=function(){return !1};reactIs_production_min.isContextConsumer=function(a){return v(a)===h};reactIs_production_min.isContextProvider=function(a){return v(a)===g};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};reactIs_production_min.isForwardRef=function(a){return v(a)===l};reactIs_production_min.isFragment=function(a){return v(a)===d};reactIs_production_min.isLazy=function(a){return v(a)===q};reactIs_production_min.isMemo=function(a){return v(a)===p};
	reactIs_production_min.isPortal=function(a){return v(a)===c};reactIs_production_min.isProfiler=function(a){return v(a)===f};reactIs_production_min.isStrictMode=function(a){return v(a)===e};reactIs_production_min.isSuspense=function(a){return v(a)===m};reactIs_production_min.isSuspenseList=function(a){return v(a)===n};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};reactIs_production_min.typeOf=v;
	return reactIs_production_min;
}

var reactIs_development = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types.
	var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	var REACT_SERVER_CONTEXT_TYPE = Symbol.for('react.server_context');
	var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	var REACT_MEMO_TYPE = Symbol.for('react.memo');
	var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');

	// -----------------------------------------------------------------------------

	var enableScopeAPI = false; // Experimental Create Event Handle API.
	var enableCacheElement = false;
	var enableTransitionTracing = false; // No known bugs, but needs performance testing

	var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
	// stuff. Intended to enable React core members to more easily debug scheduling
	// issues in DEV builds.

	var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

	var REACT_MODULE_REFERENCE;

	{
	  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
	}

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
	    // types supported by any Flight configuration anywhere since
	    // we don't know which Flight build this will end up being used
	    // with.
	    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
	      return true;
	    }
	  }

	  return false;
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	          case REACT_SUSPENSE_LIST_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_SERVER_CONTEXT_TYPE:
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	}
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false;
	var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isConcurrentMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
	      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}
	function isSuspenseList(object) {
	  return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
	}

	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.SuspenseList = SuspenseList;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isSuspenseList = isSuspenseList;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = requireReactIs_production_min();
} else {
  reactIs.exports = requireReactIs_development();
}

var reactIsExports = reactIs.exports;

// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  const match = `${fn}`.match(fnNameMatchRegex);
  const name = match && match[1];
  return name || '';
}
function getFunctionComponentName(Component, fallback = '') {
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
  const functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}

/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE11 support
 */
function getDisplayName$1(Component) {
  if (Component == null) {
    return undefined;
  }
  if (typeof Component === 'string') {
    return Component;
  }
  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
  if (typeof Component === 'object') {
    switch (Component.$$typeof) {
      case reactIsExports.ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');
      case reactIsExports.Memo:
        return getWrappedName(Component, Component.type, 'memo');
      default:
        return undefined;
    }
  }
  return undefined;
}

var getDisplayName = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: getDisplayName$1,
  getFunctionName: getFunctionName
});

var require$$6 = /*@__PURE__*/getAugmentedNamespace(getDisplayName);

var require$$7 = /*@__PURE__*/getAugmentedNamespace(createTheme$1);

var require$$8 = /*@__PURE__*/getAugmentedNamespace(styleFunctionSx);

var _interopRequireDefault$3 = interopRequireDefaultExports;
Object.defineProperty(createStyled$1, "__esModule", {
  value: true
});
var _default = createStyled$1.default = createStyled;
createStyled$1.shouldForwardProp = shouldForwardProp;
createStyled$1.systemDefaultTheme = void 0;
var _extends2 = _interopRequireDefault$3(require_extends());
var _objectWithoutPropertiesLoose2 = _interopRequireDefault$3(requireObjectWithoutPropertiesLoose());
var _styledEngine = _interopRequireWildcard(require$$1);
var _deepmerge = require$$4;
var _capitalize = _interopRequireDefault$3(require$$5);
var _getDisplayName = _interopRequireDefault$3(require$$6);
var _createTheme = _interopRequireDefault$3(require$$7);
var _styleFunctionSx = _interopRequireDefault$3(require$$8);
const _excluded$3 = ["ownerState"],
  _excluded2 = ["variants"],
  _excluded3 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
/* eslint-disable no-underscore-dangle */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
  return typeof tag === 'string' &&
  // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}

// Update /system/styled/#api in case if this changes
function shouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const systemDefaultTheme = createStyled$1.systemDefaultTheme = (0, _createTheme.default)();
const lowercaseFirstLetter = string => {
  if (!string) {
    return string;
  }
  return string.charAt(0).toLowerCase() + string.slice(1);
};
function resolveTheme({
  defaultTheme,
  theme,
  themeId
}) {
  return isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function defaultOverridesResolver(slot) {
  if (!slot) {
    return null;
  }
  return (props, styles) => styles[slot];
}
function processStyleArg(callableStyle, _ref) {
  let {
      ownerState
    } = _ref,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded$3);
  const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, _extends2.default)({
    ownerState
  }, props)) : callableStyle;
  if (Array.isArray(resolvedStylesArg)) {
    return resolvedStylesArg.flatMap(resolvedStyle => processStyleArg(resolvedStyle, (0, _extends2.default)({
      ownerState
    }, props)));
  }
  if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
    const {
        variants = []
      } = resolvedStylesArg,
      otherStyles = (0, _objectWithoutPropertiesLoose2.default)(resolvedStylesArg, _excluded2);
    let result = otherStyles;
    variants.forEach(variant => {
      let isMatch = true;
      if (typeof variant.props === 'function') {
        isMatch = variant.props((0, _extends2.default)({
          ownerState
        }, props, ownerState));
      } else {
        Object.keys(variant.props).forEach(key => {
          if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) {
            isMatch = false;
          }
        });
      }
      if (isMatch) {
        if (!Array.isArray(result)) {
          result = [result];
        }
        result.push(typeof variant.style === 'function' ? variant.style((0, _extends2.default)({
          ownerState
        }, props, ownerState)) : variant.style);
      }
    });
    return result;
  }
  return resolvedStylesArg;
}
function createStyled(input = {}) {
  const {
    themeId,
    defaultTheme = systemDefaultTheme,
    rootShouldForwardProp = shouldForwardProp,
    slotShouldForwardProp = shouldForwardProp
  } = input;
  const systemSx = props => {
    return (0, _styleFunctionSx.default)((0, _extends2.default)({}, props, {
      theme: resolveTheme((0, _extends2.default)({}, props, {
        defaultTheme,
        themeId
      }))
    }));
  };
  systemSx.__mui_systemSx = true;
  return (tag, inputOptions = {}) => {
    // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
    (0, _styledEngine.internal_processStyles)(tag, styles => styles.filter(style => !(style != null && style.__mui_systemSx)));
    const {
        name: componentName,
        slot: componentSlot,
        skipVariantsResolver: inputSkipVariantsResolver,
        skipSx: inputSkipSx,
        // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot))
      } = inputOptions,
      options = (0, _objectWithoutPropertiesLoose2.default)(inputOptions, _excluded3);

    // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
    const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver :
    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
    const skipSx = inputSkipSx || false;
    let label;
    if (process.env.NODE_ENV !== 'production') {
      if (componentName) {
        // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        label = `${componentName}-${lowercaseFirstLetter(componentSlot || 'Root')}`;
      }
    }
    let shouldForwardPropOption = shouldForwardProp;

    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    if (componentSlot === 'Root' || componentSlot === 'root') {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      // any other slot specified
      shouldForwardPropOption = slotShouldForwardProp;
    } else if (isStringTag(tag)) {
      // for string (html) tag, preserve the behavior in emotion & styled-components.
      shouldForwardPropOption = undefined;
    }
    const defaultStyledResolver = (0, _styledEngine.default)(tag, (0, _extends2.default)({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));
    const transformStyleArg = stylesArg => {
      // On the server Emotion doesn't use React.forwardRef for creating components, so the created
      // component stays as a function. This condition makes sure that we do not interpolate functions
      // which are basically components used as a selectors.
      if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, _deepmerge.isPlainObject)(stylesArg)) {
        return props => processStyleArg(stylesArg, (0, _extends2.default)({}, props, {
          theme: resolveTheme({
            theme: props.theme,
            defaultTheme,
            themeId
          })
        }));
      }
      return stylesArg;
    };
    const muiStyledResolver = (styleArg, ...expressions) => {
      let transformedStyleArg = transformStyleArg(styleArg);
      const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = resolveTheme((0, _extends2.default)({}, props, {
            defaultTheme,
            themeId
          }));
          if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) {
            return null;
          }
          const styleOverrides = theme.components[componentName].styleOverrides;
          const resolvedStyleOverrides = {};
          // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
          Object.entries(styleOverrides).forEach(([slotKey, slotStyle]) => {
            resolvedStyleOverrides[slotKey] = processStyleArg(slotStyle, (0, _extends2.default)({}, props, {
              theme
            }));
          });
          return overridesResolver(props, resolvedStyleOverrides);
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push(props => {
          var _theme$components;
          const theme = resolveTheme((0, _extends2.default)({}, props, {
            defaultTheme,
            themeId
          }));
          const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
          return processStyleArg({
            variants: themeVariants
          }, (0, _extends2.default)({}, props, {
            theme
          }));
        });
      }
      if (!skipSx) {
        expressionsWithDefaultTheme.push(systemSx);
      }
      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill('');
        // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
        transformedStyleArg = [...styleArg, ...placeholders];
        transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
      }
      const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
      if (process.env.NODE_ENV !== 'production') {
        let displayName;
        if (componentName) {
          displayName = `${componentName}${(0, _capitalize.default)(componentSlot || '')}`;
        }
        if (displayName === undefined) {
          displayName = `Styled(${(0, _getDisplayName.default)(tag)})`;
        }
        Component.displayName = displayName;
      }
      if (tag.muiName) {
        Component.muiName = tag.muiName;
      }
      return Component;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
}

// copied from @mui/system/createStyled
function slotShouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}

const rootShouldForwardProp = prop => slotShouldForwardProp(prop) && prop !== 'classes';
var rootShouldForwardProp$1 = rootShouldForwardProp;

const styled = _default({
  themeId: THEME_ID,
  defaultTheme: defaultTheme$1,
  rootShouldForwardProp: rootShouldForwardProp$1
});
var styled$1 = styled;

function generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
  const result = {};
  slots.forEach(slot => {
    result[slot] = generateUtilityClass(componentName, slot, globalStatePrefix);
  });
  return result;
}

function getSvgIconUtilityClass(slot) {
  return generateUtilityClass('MuiSvgIcon', slot);
}
generateUtilityClasses('MuiSvgIcon', ['root', 'colorPrimary', 'colorSecondary', 'colorAction', 'colorError', 'colorDisabled', 'fontSizeInherit', 'fontSizeSmall', 'fontSizeMedium', 'fontSizeLarge']);

const _excluded$2 = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"];
const useUtilityClasses = ownerState => {
  const {
    color,
    fontSize,
    classes
  } = ownerState;
  const slots = {
    root: ['root', color !== 'inherit' && `color${capitalize$1(color)}`, `fontSize${capitalize$1(fontSize)}`]
  };
  return composeClasses(slots, getSvgIconUtilityClass, classes);
};
const SvgIconRoot = styled$1('svg', {
  name: 'MuiSvgIcon',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'inherit' && styles[`color${capitalize$1(ownerState.color)}`], styles[`fontSize${capitalize$1(ownerState.fontSize)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
  return {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
    flexShrink: 0,
    transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
      duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
    }),
    fontSize: {
      inherit: 'inherit',
      small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
      medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
      large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
    }[ownerState.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : {
      action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
      disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
      inherit: undefined
    }[ownerState.color]
  };
});
const SvgIcon$1 = /*#__PURE__*/React__namespace.forwardRef(function SvgIcon(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiSvgIcon'
  });
  const {
      children,
      className,
      color = 'inherit',
      component = 'svg',
      fontSize = 'medium',
      htmlColor,
      inheritViewBox = false,
      titleAccess,
      viewBox = '0 0 24 24'
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$2);
  const hasSvgAsChild = /*#__PURE__*/React__namespace.isValidElement(children) && children.type === 'svg';
  const ownerState = _extends$1({}, props, {
    color,
    component,
    fontSize,
    instanceFontSize: inProps.fontSize,
    inheritViewBox,
    viewBox,
    hasSvgAsChild
  });
  const more = {};
  if (!inheritViewBox) {
    more.viewBox = viewBox;
  }
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/require$$2$1.jsxs(SvgIconRoot, _extends$1({
    as: component,
    className: clsx(classes.root, className),
    focusable: "false",
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, more, other, hasSvgAsChild && children.props, {
    ownerState: ownerState,
    children: [hasSvgAsChild ? children.props.children : children, titleAccess ? /*#__PURE__*/require$$2$1.jsx("title", {
      children: titleAccess
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" ? SvgIcon$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['inherit', 'action', 'disabled', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['inherit', 'large', 'medium', 'small']), PropTypes.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: PropTypes.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: PropTypes.string
} : void 0;
SvgIcon$1.muiName = 'SvgIcon';
var SvgIcon$2 = SvgIcon$1;

const eventEmitter = new events.EventEmitter();

const useThemeName = () => {
    const [themeName, setThemeName] = React.useState(process.env.REACT_APP_THEME_NAME || 'Fortress');
    const handleThemeNameChange = React.useCallback((themeName) => {
        setThemeName(themeName);
    }, []);
    React.useEffect(() => {
        if (process.env.STORYBOOK_IS_RUNNING === 'true') {
            eventEmitter.setMaxListeners(100);
            eventEmitter.addListener('FORTRESS_CL_THEME', handleThemeNameChange);
        }
        return () => {
            eventEmitter.removeListener('FORTRESS_CL_THEME', handleThemeNameChange);
        };
    }, [handleThemeNameChange]);
    return [themeName, handleThemeNameChange];
};

/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */
const useEnhancedEffect = typeof window !== 'undefined' ? React__namespace.useLayoutEffect : React__namespace.useEffect;
var useEnhancedEffect$1 = useEnhancedEffect;

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.

const specialProperty = 'exact-prop: \u200b';
function exactProp(propTypes) {
  if (process.env.NODE_ENV === 'production') {
    return propTypes;
  }
  return _extends$1({}, propTypes, {
    [specialProperty]: props => {
      const unsupportedProps = Object.keys(props).filter(prop => !propTypes.hasOwnProperty(prop));
      if (unsupportedProps.length > 0) {
        return new Error(`The following props are not supported: ${unsupportedProps.map(prop => `\`${prop}\``).join(', ')}. Please remove them.`);
      }
      return null;
    }
  });
}

/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */
function createChainedFunction(...funcs) {
  return funcs.reduce((acc, func) => {
    if (func == null) {
      return acc;
    }
    return function chainedFunction(...args) {
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, () => {});
}

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func, wait = 166) {
  let timeout;
  function debounced(...args) {
    const later = () => {
      // @ts-ignore
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }
  debounced.clear = () => {
    clearTimeout(timeout);
  };
  return debounced;
}

function deprecatedPropType(validator, reason) {
  if (process.env.NODE_ENV === 'production') {
    return () => null;
  }
  return (props, propName, componentName, location, propFullName) => {
    const componentNameSafe = componentName || '<<anonymous>>';
    const propFullNameSafe = propFullName || propName;
    if (typeof props[propName] !== 'undefined') {
      return new Error(`The ${location} \`${propFullNameSafe}\` of ` + `\`${componentNameSafe}\` is deprecated. ${reason}`);
    }
    return null;
  };
}

function isMuiElement(element, muiNames) {
  var _muiName, _element$type;
  return /*#__PURE__*/React__namespace.isValidElement(element) && muiNames.indexOf( // For server components `muiName` is avaialble in element.type._payload.value.muiName
  // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
  // eslint-disable-next-line no-underscore-dangle
  (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

function ownerWindow(node) {
  const doc = ownerDocument(node);
  return doc.defaultView || window;
}

function requirePropFactory(componentNameInError, Component) {
  if (process.env.NODE_ENV === 'production') {
    return () => null;
  }

  // eslint-disable-next-line react/forbid-foreign-prop-types
  const prevPropTypes = Component ? _extends$1({}, Component.propTypes) : null;
  const requireProp = requiredProp => (props, propName, componentName, location, propFullName, ...args) => {
    const propFullNameSafe = propFullName || propName;
    const defaultTypeChecker = prevPropTypes == null ? void 0 : prevPropTypes[propFullNameSafe];
    if (defaultTypeChecker) {
      const typeCheckerResult = defaultTypeChecker(props, propName, componentName, location, propFullName, ...args);
      if (typeCheckerResult) {
        return typeCheckerResult;
      }
    }
    if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
      return new Error(`The prop \`${propFullNameSafe}\` of ` + `\`${componentNameInError}\` can only be used together with the \`${requiredProp}\` prop.`);
    }
    return null;
  };
  return requireProp;
}

/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

let globalId = 0;
function useGlobalId(idOverride) {
  const [defaultId, setDefaultId] = React__namespace.useState(idOverride);
  const id = idOverride || defaultId;
  React__namespace.useEffect(() => {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the incrementing value for client-side rendering only.
      // We can't use it server-side.
      // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
      globalId += 1;
      setDefaultId(`mui-${globalId}`);
    }
  }, [defaultId]);
  return id;
}

// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseId = React__namespace['useId'.toString()];
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */
function useId(idOverride) {
  if (maybeReactUseId !== undefined) {
    const reactId = maybeReactUseId();
    return idOverride != null ? idOverride : reactId;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
  return useGlobalId(idOverride);
}

function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }
  const propFullNameSafe = propFullName || propName;
  if (typeof props[propName] !== 'undefined') {
    return new Error(`The prop \`${propFullNameSafe}\` is not supported. Please remove it.`);
  }
  return null;
}

function useControlled({
  controlled,
  default: defaultProp,
  name,
  state = 'value'
}) {
  // isControlled is ignored in the hook dependency lists as it should never change.
  const {
    current: isControlled
  } = React__namespace.useRef(controlled !== undefined);
  const [valueState, setValue] = React__namespace.useState(defaultProp);
  const value = isControlled ? controlled : valueState;
  if (process.env.NODE_ENV !== 'production') {
    React__namespace.useEffect(() => {
      if (isControlled !== (controlled !== undefined)) {
        console.error([`MUI: A component is changing the ${isControlled ? '' : 'un'}controlled ${state} state of ${name} to be ${isControlled ? 'un' : ''}controlled.`, 'Elements should not switch from uncontrolled to controlled (or vice versa).', `Decide between using a controlled or uncontrolled ${name} ` + 'element for the lifetime of the component.', "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [state, name, controlled]);
    const {
      current: defaultValue
    } = React__namespace.useRef(defaultProp);
    React__namespace.useEffect(() => {
      if (!isControlled && defaultValue !== defaultProp) {
        console.error([`MUI: A component is changing the default ${state} state of an uncontrolled ${name} after being initialized. ` + `To suppress this warning opt to use a controlled ${name}.`].join('\n'));
      }
    }, [JSON.stringify(defaultProp)]);
  }
  const setValueIfUncontrolled = React__namespace.useCallback(newValue => {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */

function useEventCallback(fn) {
  const ref = React__namespace.useRef(fn);
  useEnhancedEffect$1(() => {
    ref.current = fn;
  });
  return React__namespace.useRef((...args) =>
  // @ts-expect-error hide `this`
  (0, ref.current)(...args)).current;
}

function useForkRef(...refs) {
  /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */
  return React__namespace.useMemo(() => {
    if (refs.every(ref => ref == null)) {
      return null;
    }
    return instance => {
      refs.forEach(ref => {
        setRef(ref, instance);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}

class Timeout {
  constructor() {
    this.currentId = null;
    this.clear = () => {
      if (this.currentId !== null) {
        clearTimeout(this.currentId);
        this.currentId = null;
      }
    };
    this.disposeEffect = () => {
      return this.clear;
    };
  }
  static create() {
    return new Timeout();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(delay, fn) {
    this.clear();
    this.currentId = setTimeout(() => {
      this.currentId = null;
      fn();
    }, delay);
  }
}

let hadKeyboardEvent = true;
let hadFocusVisibleRecently = false;
const hadFocusVisibleRecentlyTimeout = new Timeout();
const inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};

/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */
function focusTriggersKeyboardModality(node) {
  const {
    type,
    tagName
  } = node;
  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }
  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }
  if (node.isContentEditable) {
    return true;
  }
  return false;
}

/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */
function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }
  hadKeyboardEvent = true;
}

/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */
function handlePointerDown() {
  hadKeyboardEvent = false;
}
function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}
function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}
function isFocusVisible(event) {
  const {
    target
  } = event;
  try {
    return target.matches(':focus-visible');
  } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
  }

  // No need for validFocusTarget check. The user does that by attaching it to
  // focusable events only.
  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
function useIsFocusVisible() {
  const ref = React__namespace.useCallback(node => {
    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);
  const isFocusVisibleRef = React__namespace.useRef(false);

  /**
   * Should be called if a blur event is fired
   */
  function handleBlurVisible() {
    // checking against potential state variable does not suffice if we focus and blur synchronously.
    // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
    // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
    // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
    // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
    if (isFocusVisibleRef.current) {
      // To detect a tab/window switch, we look for a blur event followed
      // rapidly by a visibility change.
      // If we don't see a visibility change within 100ms, it's probably a
      // regular focus change.
      hadFocusVisibleRecently = true;
      hadFocusVisibleRecentlyTimeout.start(100, () => {
        hadFocusVisibleRecently = false;
      });
      isFocusVisibleRef.current = false;
      return true;
    }
    return false;
  }

  /**
   * Should be called if a blur event is fired
   */
  function handleFocusVisible(event) {
    if (isFocusVisible(event)) {
      isFocusVisibleRef.current = true;
      return true;
    }
    return false;
  }
  return {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref
  };
}

const ThemeContext = /*#__PURE__*/React__namespace.createContext(null);
if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'ThemeContext';
}
var ThemeContext$1 = ThemeContext;

function useTheme() {
  const theme = React__namespace.useContext(ThemeContext$1);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__namespace.useDebugValue(theme);
  }
  return theme;
}

const hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    const mergedTheme = localTheme(outerTheme);
    if (process.env.NODE_ENV !== 'production') {
      if (!mergedTheme) {
        console.error(['MUI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
      }
    }
    return mergedTheme;
  }
  return _extends$1({}, outerTheme, localTheme);
}

/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */
function ThemeProvider$2(props) {
  const {
    children,
    theme: localTheme
  } = props;
  const outerTheme = useTheme();
  if (process.env.NODE_ENV !== 'production') {
    if (outerTheme === null && typeof localTheme === 'function') {
      console.error(['MUI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }
  const theme = React__namespace.useMemo(() => {
    const output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
    if (output != null) {
      output[nested] = outerTheme !== null;
    }
    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/require$$2$1.jsx(ThemeContext$1.Provider, {
    value: theme,
    children: children
  });
}
process.env.NODE_ENV !== "production" ? ThemeProvider$2.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? ThemeProvider$2.propTypes = exactProp(ThemeProvider$2.propTypes) : void 0;
}

const _excluded$1 = ["value"];
const RtlContext = /*#__PURE__*/React__namespace.createContext();
function RtlProvider(_ref) {
  let {
      value
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  return /*#__PURE__*/require$$2$1.jsx(RtlContext.Provider, _extends$1({
    value: value != null ? value : true
  }, props));
}
process.env.NODE_ENV !== "production" ? RtlProvider.propTypes = {
  children: PropTypes.node,
  value: PropTypes.bool
} : void 0;

const EMPTY_THEME = {};
function useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
  return React__namespace.useMemo(() => {
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    if (typeof localTheme === 'function') {
      const mergedTheme = localTheme(resolvedTheme);
      const result = themeId ? _extends$1({}, upperTheme, {
        [themeId]: mergedTheme
      }) : mergedTheme;
      // must return a function for the private theme to NOT merge with the upper theme.
      // see the test case "use provided theme from a callback" in ThemeProvider.test.js
      if (isPrivate) {
        return () => result;
      }
      return result;
    }
    return themeId ? _extends$1({}, upperTheme, {
      [themeId]: localTheme
    }) : _extends$1({}, upperTheme, localTheme);
  }, [themeId, upperTheme, localTheme, isPrivate]);
}

/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */
function ThemeProvider$1(props) {
  const {
    children,
    theme: localTheme,
    themeId
  } = props;
  const upperTheme = useTheme$2(EMPTY_THEME);
  const upperPrivateTheme = useTheme() || EMPTY_THEME;
  if (process.env.NODE_ENV !== 'production') {
    if (upperTheme === null && typeof localTheme === 'function' || themeId && upperTheme && !upperTheme[themeId] && typeof localTheme === 'function') {
      console.error(['MUI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }
  const engineTheme = useThemeScoping(themeId, upperTheme, localTheme);
  const privateTheme = useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
  const rtlValue = engineTheme.direction === 'rtl';
  return /*#__PURE__*/require$$2$1.jsx(ThemeProvider$2, {
    theme: privateTheme,
    children: /*#__PURE__*/require$$2$1.jsx(react.ThemeContext.Provider, {
      value: engineTheme,
      children: /*#__PURE__*/require$$2$1.jsx(RtlProvider, {
        value: rtlValue,
        children: children
      })
    })
  });
}
process.env.NODE_ENV !== "production" ? ThemeProvider$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: PropTypes.string
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? ThemeProvider$1.propTypes = exactProp(ThemeProvider$1.propTypes) : void 0;
}

const _excluded = ["theme"];
function ThemeProvider(_ref) {
  let {
      theme: themeInput
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const scopedTheme = themeInput[THEME_ID];
  return /*#__PURE__*/require$$2$1.jsx(ThemeProvider$1, _extends$1({}, props, {
    themeId: scopedTheme ? THEME_ID : undefined,
    theme: scopedTheme || themeInput
  }));
}
process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
} : void 0;

function createSvgIcon$1(path, displayName) {
  function Component(props, ref) {
    return /*#__PURE__*/require$$2$1.jsx(SvgIcon$2, _extends$1({
      "data-testid": `${displayName}Icon`,
      ref: ref
    }, props, {
      children: path
    }));
  }
  if (process.env.NODE_ENV !== 'production') {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = `${displayName}Icon`;
  }
  Component.muiName = SvgIcon$2.muiName;
  return /*#__PURE__*/React__namespace.memo( /*#__PURE__*/React__namespace.forwardRef(Component));
}

// TODO: remove this export once ClassNameGenerator is stable
// eslint-disable-next-line @typescript-eslint/naming-convention
const unstable_ClassNameGenerator = {
  configure: generator => {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(['MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.', '', "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", '', 'The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401', '', 'The updated documentation: https://mui.com/guides/classname-generator/'].join('\n'));
    }
    ClassNameGenerator$1.configure(generator);
  }
};

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  capitalize: capitalize$1,
  createChainedFunction: createChainedFunction,
  createSvgIcon: createSvgIcon$1,
  debounce: debounce,
  deprecatedPropType: deprecatedPropType,
  isMuiElement: isMuiElement,
  ownerDocument: ownerDocument,
  ownerWindow: ownerWindow,
  requirePropFactory: requirePropFactory,
  setRef: setRef,
  unstable_ClassNameGenerator: unstable_ClassNameGenerator,
  unstable_useEnhancedEffect: useEnhancedEffect$1,
  unstable_useId: useId,
  unsupportedProp: unsupportedProp,
  useControlled: useControlled,
  useEventCallback: useEventCallback,
  useForkRef: useForkRef,
  useIsFocusVisible: useIsFocusVisible
});

const white = '#FFFFFF';
const blue = {
    darker: '#203089',
    dark: '#2136E1',
    main: '#4D73FF',
    light: '#98BEFF',
    lighter: '#EBF5FF',
};
const purple = {
    dark: '#4E2092',
    main: '#7734E7',
    light: '#C5B7FB',
    lighter: '#F5F3FF',
};
const green = {
    dark: '#296113',
    main: '#4CBB17',
    light: '#96F066',
    lighter: '#F1FEE7',
};
const lightGreen = {
    main: green.main, // success
};
const red = {
    dark: '#B10303',
    main: '#D70000',
    light: '#FF5757',
    lighter: '#FFF0F0',
    heart: '#D83329',
};
const orange = {
    dark: '#5D25B2',
    main: '#7734E7',
    light: '#C5B7FB',
    lighter: '#F5F3FF',
};
const yellow = {
    main: '#F0A524',
    light: '#FBE8CA',
};
const grey = {
    dark: '#000000',
    main: '#6A6A6A',
    light: '#B4B4B4',
    lighter: '#D1D1D1',
};
const lightGrey = {
    dark: '#4E4E4E',
    main: '#9A9A9A',
    light: '#B4B4B4',
    lighterAlt: '#F0F0F0',
    lighter: '#F8F8F8',
};
const warning = {
    dark: '#BB5502',
    main: '#E27C00',
    light: '#FFA500',
    lighter: '#FFFCEA',
};
const divider = grey.lighter;
const black = '#000000';
const inputBorder = '#dfdfdf';
const border = {
    main: lightGrey.main,
    light: lightGrey.light,
    disabled: grey.lighter,
};
({
    header: blue.main,
    defaultEven: white,
    defaultOdd: lightGrey.lighter,
    highlightEven: '#F8F7FB',
    highlightOdd: '#F8FCFF',
    urgent: red.lighter,
    warning: orange.lighter,
    ready: green.lighter,
    footer: blue.lighter,
});
const palette$1 = {
    dark: {
        blue: blue.dark,
        purple: purple.dark,
        green: green.dark,
        red: red.dark,
        orange: orange.dark,
        grey: grey.dark,
        lightGrey: lightGrey.dark,
        warning: warning.dark,
    },
    main: {
        blue: blue.main,
        purple: purple.main,
        green: green.main,
        lightGreen: lightGreen.main,
        red: red.main,
        orange: orange.main,
        grey: grey.main,
        lightGrey: lightGrey.main,
        yellow: yellow.main,
        warning: warning.main,
    },
    light: {
        blue: blue.light,
        purple: purple.light,
        green: green.light,
        red: red.light,
        orange: orange.light,
        grey: grey.light,
        lightGrey: lightGrey.light,
        yellow: yellow.light,
        warning: warning.light,
        lightGreyAlt: lightGrey.lighterAlt,
    },
    lighter: {
        blue: blue.lighter,
        purple: purple.lighter,
        green: green.lighter,
        red: red.lighter,
        orange: orange.lighter,
        grey: grey.lighter,
        lightGrey: lightGrey.lighter,
        warning: warning.lighter,
    },
    divider,
    border,
};

var _a$1, _b$1, _c$1;
const fontFamily = ['Roboto', 'sans-serif', '"Helvetica Neue"', 'Arial'].join(',');
const baseTheme = createTheme({
    palette: {
        // @ts-ignore
        primary: blue,
        // @ts-ignore
        secondary: purple,
        // @ts-ignore
        success: green,
        // @ts-ignore
        error: red,
        // @ts-ignore
        warning,
        // @ts-ignore
        divider,
        background: {
            alt: lightGrey.lighter,
            altDarker: lightGrey.lighterAlt,
        },
        action: {
            readOnly: lightGrey.lighter,
            hover: lightGrey.lighter,
            disabled: grey.lighter,
        },
        text: {
            primary: black,
            secondary: grey.main,
        },
    },
});
const typography = {
    fontFamily,
    fontSize: 16,
    h1: {
        fontFamily: 'Roboto',
        fontSize: '28px',
        fontWeight: 400,
        lineHeight: '36px',
        color: black,
    },
    h2: {
        fontFamily: 'Roboto',
        fontSize: '24px',
        fontWeight: 400,
        lineHeight: '32px',
        color: black,
    },
    h3: {
        fontFamily: 'Roboto',
        fontSize: '22px',
        fontWeight: 400,
        lineHeight: '28px',
        color: black,
    },
    h3Alt: {
        fontFamily: 'Roboto',
        fontSize: '22px',
        fontWeight: 500,
        textTransform: 'uppercase',
        lineHeight: '28px',
        color: blue.main,
    },
    h4: {
        fontFamily: 'Roboto',
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: '0.15px',
        color: black,
    },
    h5: {
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '20px',
        color: black,
    },
    h6: {
        fontFamily: 'Roboto',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '14px',
        color: grey.main,
    },
    body1: {
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: 400,
        letterSpacing: '0.25px',
        lineHeight: '20px',
        color: black,
    },
    body2: {
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: 500,
        letterSpacing: '0.1px',
        lineHeight: '20px',
        color: black,
    },
    formSubheading: {
        fontFamily: 'Roboto',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '0.15px',
        color: black,
    },
    inputLabel: {
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0.1px',
        color: black,
    },
    label: {
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0.1px',
        color: black,
    },
    button: {
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: 500,
        letterSpacing: '0.1px',
        lineHeight: '20px',
        textTransform: 'none',
        color: black,
    },
    tableText: {
        fontFamily: 'Roboto',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '16px',
        letterSpacing: '0.4px',
        color: black,
    },
    tableLink: {
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '16px',
        letterSpacing: '0.4px',
        color: blue.main,
        transition: 'color 100ms ease-in-out',
        cursor: 'pointer',
    },
    textLink: {
        fontFamily: 'Roboto',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0.1px',
        color: blue.main,
        cursor: 'pointer',
        transition: 'color 100ms ease-in-out',
    },
    helper: {
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: 400,
        letterSpacing: '0.4px',
        lineHeight: '16px',
        color: black,
    },
    helperSmall: {
        fontFamily: 'Roboto',
        fontSize: '12px',
        fontWeight: 400,
        letterSpacing: '-0.0059em',
        lineHeight: '15px',
        color: black,
    },
    helperTiny: {
        fontFamily: 'Roboto',
        fontSize: '0.625rem',
        fontWeight: 400,
        letterSpacing: '0.0036875rem',
        lineHeight: '0.784375rem',
        color: black,
    },
    caption: {
        fontFamily: 'Roboto',
        fontSize: '12px',
        fontWeight: 400,
        letterSpacing: '0.4px',
        lineHeight: '16px',
        color: lightGrey.main,
    },
    reputationMgmtColumnLabel: {
        fontFamily: 'Roboto',
        fontSize: '12px',
        fontWeight: 500,
        whiteSpace: 'nowrap',
        lineHeight: '15.06px',
        letterSpacing: '-0.59%',
        color: blue.main,
    },
    reputationMgmtBodyText: {
        fontFamily: 'Roboto',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '15px',
        letterSpacing: '0em',
        textAlign: 'left',
        color: black,
    },
    // Version 2
    titleMedium: {
        fontFamily: 'Roboto',
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: '0.15px',
        color: black,
    },
    labelLarge: {
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0.1px',
        color: black,
    },
    labelMedium: {
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '16px',
        letterSpacing: '0.5px',
        color: black,
        wordWrap: 'break-word',
    },
    labelSmall: {
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: '11px',
        lineHeight: '16px',
        letterSpacing: '0.5px',
        color: black,
    },
    bodyLarge: {
        fontFamily: 'Roboto',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '24px',
        letterSpacing: '0.15px',
        color: black,
    },
    bodyMedium: {
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: 400,
        letterSpacing: '0.25px',
        lineHeight: '20px',
        color: black,
    },
    bodySmall: {
        fontFamily: 'Roboto',
        fontSize: '12px',
        fontWeight: 400,
        letterSpacing: '0.4px',
        lineHeight: '16px',
        color: black,
    },
};
const components = {
    // DEPRECATED
    MuiTextField: {
        defaultProps: {
            variant: 'outlined',
            InputLabelProps: { shrink: true },
            InputProps: { notched: false },
        },
    },
    //
    MuiAccordion: {
        defaultProps: {
            elevation: 0,
        },
        styleOverrides: {
            root: {
                borderTop: '1px solid',
                borderBottom: '1px solid',
                borderColor: divider,
            },
        },
    },
    MuiAlert: {
        defaultProps: {
            severity: 'info',
            componentsProps: {
                closeButton: {
                    size: 'medium',
                },
            },
        },
        styleOverrides: {
            root: ({ ownerState, theme }) => {
                var _a;
                return (Object.assign({ alignItems: 'center', '.MuiAlert-icon': {
                        color: theme.palette.common.white,
                        padding: '10px 0',
                    }, '.MuiAlert-message': Object.assign(Object.assign({}, typography.bodySmall), { color: theme.palette.common.white, padding: '10px 0' }), '.MuiAlert-action': {
                        color: theme.palette.common.white,
                        padding: '0 0 0 16px',
                        '.MuiIconButton-root': {
                            color: theme.palette.common.white,
                            '.MuiSvgIcon-root': {
                                opacity: 0.9,
                            },
                        },
                    } }, (((_a = ownerState.severity) === null || _a === void 0 ? void 0 : _a.length) && {
                    backgroundColor: theme.palette[ownerState.severity].main,
                })));
            },
        },
    },
    MuiAppBar: {
        styleOverrides: {
            root: { minHeight: 40, height: 40 },
        },
    },
    MuiAvatar: {
        defaultProps: {
            // @ts-ignore
            size: 'medium',
        },
        styleOverrides: {
            root: ({ ownerState }) => (Object.assign(Object.assign(Object.assign({}, (ownerState.size === 'small' && {
                width: 32,
                height: 32,
            })), (ownerState.size === 'medium' && {
                width: 40,
                height: 40,
            })), (ownerState.size === 'large' && {
                width: 56,
                height: 56,
            }))),
        },
    },
    MuiCard: {
        styleOverrides: {
            root: ({ ownerState, theme: { palette, transitions: { create, duration, easing }, }, }) => (Object.assign({ boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.0898154)', borderRadius: '2px', borderWidth: '1px', borderColor: 'transparent', borderStyle: 'solid', transition: create('border-color', {
                    duration: duration.short,
                    easing: easing.easeInOut,
                }) }, ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.disabled)
                ? {
                    backgroundColor: `${palette.action.hover} !important`,
                    boxShadow: 'none',
                }
                : {}))),
        },
    },
    MuiCheckbox: {
        styleOverrides: {
            root: {
                padding: 0,
            },
        },
    },
    MuiDialog: {
        styleOverrides: {
            paper: {
                position: 'absolute',
                top: 0,
                marginTop: 40,
                minWidth: 300,
                maxWidth: 800,
            },
        },
    },
    MuiDialogTitle: {
        defaultProps: {
            variant: 'h4',
        },
        styleOverrides: {
            root: Object.assign(Object.assign({}, typography.h4), { padding: '24px 56px 24px 24px', display: 'flex', alignItems: 'stretch' }),
        },
    },
    MuiDialogContent: {
        styleOverrides: {
            root: {
                fontFamily: (_a$1 = typography.body1) === null || _a$1 === void 0 ? void 0 : _a$1.fontFamily,
                padding: '8px 24px',
            },
        },
    },
    MuiDialogActions: {
        styleOverrides: {
            root: {
                padding: 24,
            },
        },
    },
    MuiInputLabel: {
        defaultProps: {
            shrink: true,
            variant: 'outlined',
        },
        styleOverrides: {
            root: ({ ownerState, theme }) => {
                return Object.assign(Object.assign(Object.assign({}, typography.inputLabel), { transform: 'unset', position: 'unset' }), (ownerState.readOnly
                    ? {
                        '&.Mui-focused': {
                            color: theme.palette.text.primary,
                        },
                    }
                    : {}));
            },
        },
    },
    MuiFormControl: {
        defaultProps: {
            variant: 'outlined',
            fullWidth: true,
        },
        styleOverrides: {
            root: {
                marginTop: '0px !important',
            },
        },
    },
    MuiFormLabel: {
        styleOverrides: {
            root: Object.assign(Object.assign({}, typography.inputLabel), { marginBottom: 4 }),
            asterisk: {
                display: 'none',
            },
        },
    },
    MuiFormControlLabel: {
        styleOverrides: {
            root: Object.assign(Object.assign({}, typography.inputLabel), { marginLeft: '0px !important', fontWeight: 400 }),
        },
    },
    MuiOutlinedInput: {
        defaultProps: {
            notched: false,
            fullWidth: true,
        },
        styleOverrides: {
            root: {
                padding: 0,
                backgroundColor: white,
                boxShadow: 'inset 0px 1px 1px rgba(0, 0, 0, 0.08)',
                transition: baseTheme.transitions.create(['background-color', 'color'], {
                    easing: baseTheme.transitions.easing.easeIn,
                    duration: baseTheme.transitions.duration.short,
                }),
                '&.Mui-disabled': {
                    backgroundColor: lightGrey.lighter,
                },
                '&.Mui-readOnly': {
                    boxShadow: 'none',
                    borderColor: 'transparent',
                },
                '&.Mui-readOnly .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'transparent',
                },
            },
            input: {
                height: '18px',
                paddingLeft: '8px !important',
                paddingRight: '8px',
                paddingTop: 11,
                paddingBottom: 11,
                '&.Mui-readOnly': {
                    cursor: 'default !important',
                },
            },
            notchedOutline: {
                transition: baseTheme.transitions.create(['border-color'], {
                    easing: baseTheme.transitions.easing.easeIn,
                    duration: baseTheme.transitions.duration.short,
                }),
                borderColor: inputBorder,
                '& input:invalid': {
                    borderColor: (_b$1 = baseTheme.palette.error) === null || _b$1 === void 0 ? void 0 : _b$1.main,
                },
            },
        },
    },
    MuiLinearProgress: {
        defaultProps: {
            color: 'primary',
            variant: 'determinate',
        },
        styleOverrides: {
            bar: ({ ownerState, theme }) => (Object.assign(Object.assign({}, (!ownerState.value ? { backgroundColor: 'transparent' } : {})), (ownerState.disabled
                ? { backgroundColor: theme.palette.action.disabled }
                : {}))),
        },
    },
    MuiLink: {
        styleOverrides: {
            root: ({ ownerState: { disabled }, theme }) => {
                return {
                    cursor: 'default',
                    userSelect: disabled ? 'none' : undefined,
                    color: disabled ? theme.palette.text.disabled : undefined,
                    ':hover': {
                        color: disabled
                            ? theme.palette.text.disabled
                            : theme.palette.primary.dark,
                    },
                };
            },
        },
    },
    MuiListItem: {
        defaultProps: {
            alignItems: 'flex-start',
        },
        styleOverrides: {
            root: {
                paddingLeft: 4,
                paddingRight: 4,
            },
        },
    },
    MuiListItemAvatar: {
        styleOverrides: {
            root: {
                '& > div': {
                    display: 'flex',
                },
            },
        },
    },
    MuiListItemButton: {
        styleOverrides: {
            root: {
                borderRadius: 4,
                paddingLeft: 4,
                paddingRight: 4,
                '&.Mui-selected': {
                    backgroundColor: baseTheme.palette.primary.lighter,
                },
            },
        },
    },
    MuiListItemText: {
        styleOverrides: {
            primary: {
                fontWeight: 400,
                fontSize: 16,
                lineHeight: '26px',
                color: 'inherit',
            },
            secondary: {
                fontWeight: 400,
                color: (_c$1 = typography.body1) === null || _c$1 === void 0 ? void 0 : _c$1.color,
            },
        },
    },
    MuiListItemIcon: {
        styleOverrides: {
            root: {
                minWidth: 40,
            },
        },
    },
    MuiInputAdornment: {
        styleOverrides: {
            // @ts-ignore
            root: {
                boxSizing: 'content-box !important',
                backgroundColor: 'transparent',
                justifyContent: 'center',
                padding: 8,
                paddingRight: 4,
                maxHeight: '100%',
                maxWidth: 40,
                marginRight: 0,
                height: 24,
                width: 24,
            },
        },
    },
    MuiFormHelperText: {
        defaultProps: {
            variant: 'outlined',
            children: ' ',
        },
        styleOverrides: {
            root: Object.assign(Object.assign({}, typography.caption), { marginLeft: 0 }),
        },
    },
    MuiMenuItem: {
        defaultProps: {
            dense: true,
        },
        styleOverrides: {
            root: ({ theme }) => ({
                transition: theme.transitions.create(['background-color', 'color'], {
                    duration: theme.transitions.duration.shortest,
                    easing: theme.transitions.easing.easeOut,
                }),
            }),
        },
    },
    MuiPagination: {
        styleOverrides: {
            root: {
                color: 'unset !important',
            },
            ul: {
                borderRadius: '3px',
                border: `1px solid ${palette$1.lighter.grey}`,
                '& li': {
                    borderRight: `1px solid ${palette$1.lighter.grey}`,
                    borderLeft: '0px',
                },
                '& li:last-child': {
                    borderRight: '0px',
                },
            },
        },
    },
    MuiPaginationItem: {
        styleOverrides: {
            root: {
                margin: '0',
                '&.Mui-selected': {
                    backgroundColor: palette$1.main.blue,
                    color: '#FFFFFF',
                },
                '&.Mui-disabled': {
                    pointerEvents: 'auto',
                    cursor: 'not-allowed',
                    backgroundColor: 'white !important',
                    color: palette$1.lighter.grey,
                },
            },
            rounded: {
                borderRadius: '0',
            },
            text: {
                color: palette$1.main.blue,
            },
        },
    },
    // MuiPickersYear: {
    //   styleOverrides: {
    //     root: ({ theme }) => ({
    //       '&.Mui-selected': {
    //         backgroundColor: theme.palette.primary?.main,
    //       },
    //     }),
    //   },
    // },
    // MuiPickersDay: {
    //   styleOverrides: {
    //     root: ({ theme }) => {
    //       console.log(theme)
    //       return {
    //         '&.Mui-selected': {
    //           backgroundColor: 'purple',
    //           // backgroundColor: theme.palette.primary?.main,
    //         },
    //       }
    //     },
    //   },
    // },
    MuiSelect: {
        defaultProps: {
            placeholder: 'Choose',
        },
        styleOverrides: {
            icon: ({ theme }) => ({
                transition: theme.transitions.create(['fill', 'transform']),
            }),
            select: ({ ownerState, theme }) => {
                var _a, _b;
                const isPlaceholderVisible = !((_a = ownerState.value) === null || _a === void 0 ? void 0 : _a.length) &&
                    ((_b = ownerState.placeholder) === null || _b === void 0 ? void 0 : _b.length);
                return {
                    // @ts-ignore
                    height: components.MuiOutlinedInput.styleOverrides.input.height,
                    // @ts-ignore
                    minHeight: components.MuiOutlinedInput.styleOverrides.input.height,
                    color: isPlaceholderVisible ? theme.palette.text.disabled : undefined,
                };
            },
        },
    },
    MuiSnackbar: {
        defaultProps: {
            autoHideDuration: 6000,
        },
    },
    MuiSvgIcon: {
        defaultProps: {
            color: 'inherit',
        },
        variants: [
            {
                props: { fontSize: 'xSmall' },
                style: {
                    fontSize: 12,
                },
            },
            {
                props: { fontSize: 'medium' },
                style: {
                    fontSize: '1.5rem',
                },
            },
            {
                props: { fontSize: 'xLarge' },
                style: {
                    fontSize: 64,
                },
            },
        ],
    },
    MuiTab: {
        defaultProps: {
            iconPosition: 'start',
        },
        styleOverrides: {
            root: {
                minHeight: '48px',
                alignItems: 'flex-end',
                padding: '14px 16px',
            },
        },
    },
    MuiTableCell: {
        defaultProps: {
            size: 'small',
            align: 'left',
        },
        styleOverrides: {
            root: {
                fontWeight: 400,
                fontSize: 12,
                padding: '12px 8px',
                lineHeight: '15px',
                borderBottom: 'none',
                color: 'inherit',
                head: {
                    color: baseTheme.palette.common.white,
                },
            },
            stickyHeader: {
                backgroundColor: 'inherit',
            },
        },
    },
    MuiToolbar: {
        styleOverrides: {
            root: {
                minHeight: '40px !important',
                height: 40,
                paddingLeft: '8px !important',
            },
        },
    },
    MuiStack: {
        defaultProps: {
            borderColor: grey.lighter,
        },
    },
    MuiSwitch: {
        styleOverrides: {
            root: ({ ownerState }) => {
                const sizeSmall = ownerState.size === 'small';
                return {
                    padding: 4,
                    height: sizeSmall ? 24 : 28,
                    width: sizeSmall ? 40 : 48,
                };
            },
            switchBase: ({ ownerState, theme }) => {
                var _a, _b, _c;
                const sizeSmall = ownerState.size === 'small';
                return {
                    padding: sizeSmall ? 2 : 4,
                    '& > svg': {
                        backgroundColor: theme.palette.background.paper,
                        borderRadius: '50%',
                        fontSize: sizeSmall ? 14 : 16,
                        margin: sizeSmall ? 1 : 2,
                        fill: ownerState.disabled
                            ? ownerState.checked
                                ? (_a = theme.palette.primary) === null || _a === void 0 ? void 0 : _a.light
                                : theme.palette.action.disabled
                            : ownerState.checked
                                ? (_b = theme.palette.primary) === null || _b === void 0 ? void 0 : _b.main
                                : theme.palette.action.active,
                    },
                    '&.Mui-checked+.MuiSwitch-track': {
                        opacity: '1',
                    },
                    '&.Mui-disabled+.MuiSwitch-track': {
                        backgroundColor: ownerState.checked
                            ? (_c = theme.palette.primary) === null || _c === void 0 ? void 0 : _c.light
                            : theme.palette.action.disabled,
                        opacity: 1,
                    },
                };
            },
            track: ({ ownerState, theme }) => {
                var _a;
                return ({
                    backgroundColor: ownerState.checked
                        ? (_a = theme.palette.primary) === null || _a === void 0 ? void 0 : _a.main
                        : theme.palette.action.active,
                    borderRadius: 16,
                    opacity: 0.7,
                    '&.Mui-disabled': {
                        backgroundColor: theme.palette.action.disabled,
                    },
                });
            },
        },
    },
};
const theme$1 = createTheme(baseTheme, {
    components: Object.assign({}, components),
    typography,
});

var _a, _b, _c, _d;
const palette = {
    // @ts-ignore
    primary: {
        dark: black,
        main: black,
        light: grey.main,
    },
    // @ts-ignore
    secondary: {
        dark: lightGrey.dark,
        // main: lightGrey.main,
        main: black,
        light: lightGrey.lighter,
        lightAlt: lightGrey.lighterAlt,
    },
    // @ts-ignore
    success: green,
    // @ts-ignore
    warning,
    // @ts-ignore
    error: red,
    divider,
    // @ts-ignore
    background: {
        alt: lightGrey.lighter,
        dark: '#2B2B2B',
    },
    // @ts-ignore
    action: {
        hover: lightGrey.lighter,
        disabled: grey.lighter,
    },
    // @ts-ignore
    text: {
        primary: black,
        secondary: grey.main,
    },
};
const portalComponents = Object.assign(Object.assign({}, components), { MuiAppBar: {
        styleOverrides: {
            root: ({ theme }) => ({
                backgroundColor: theme.palette.background.dark,
                height: 'fit-content',
            }),
        },
    }, MuiAvatar: {
        styleOverrides: {
            root: ({ theme }) => ({
                backgroundColor: theme.palette.background.alt,
                '& > svg': {
                    fill: theme.palette.primary.main,
                },
            }),
        },
    }, MuiDivider: {
        styleOverrides: {
            root: {
                margin: '8px 0',
                borderRadius: 8,
            },
        },
    }, MuiDrawer: {
        styleOverrides: {
            paper: ({ theme }) => ({
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.getContrastText(theme.palette.primary.main),
                '& .MuiAvatar-root': {
                    height: 32,
                    width: 32,
                    fontSize: 14,
                    backgroundColor: theme.palette.secondary.light,
                    color: theme.palette.primary.main,
                },
                '& .MuiListItemButton-root': {
                    border: 'none',
                    backgroundColor: 'transparent',
                    '&:hover': {
                        backgroundColor: theme.palette.primary.light,
                    },
                    '&.Mui-selected': {
                        backgroundColor: theme.palette.primary.light,
                    },
                },
                '& .MuiSvgIcon-root': {
                    fill: theme.palette.getContrastText(theme.palette.primary.main),
                },
                '& .MuiListItemText-root > MuiTypography-root': {
                    color: `${theme.palette.getContrastText(theme.palette.primary.main)} !important`,
                },
            }),
        },
    }, MuiIconButton: {
        styleOverrides: {
            root: ({ ownerState, theme }) => (Object.assign({ color: black }, (ownerState.color === 'secondary' && {
                backgroundColor: theme.palette.action.hover,
                '&:hover': {
                    backgroundColor: lightGrey.lighterAlt,
                },
            }))),
        },
    }, MuiOutlinedInput: {
        defaultProps: (_a = components === null || components === void 0 ? void 0 : components.MuiOutlinedInput) === null || _a === void 0 ? void 0 : _a.defaultProps,
        styleOverrides: Object.assign(Object.assign({}, (_b = components === null || components === void 0 ? void 0 : components.MuiOutlinedInput) === null || _b === void 0 ? void 0 : _b.styleOverrides), { root: Object.assign(Object.assign({}, (_d = (_c = components === null || components === void 0 ? void 0 : components.MuiOutlinedInput) === null || _c === void 0 ? void 0 : _c.styleOverrides) === null || _d === void 0 ? void 0 : _d.root), { borderRadius: 8 }) }),
    }, MuiList: {
        styleOverrides: {
            root: {
                '& .MuiListItem-root': {
                    marginBottom: 8,
                },
                '& .MuiListItemButton-root': {
                    marginBottom: 8,
                },
            },
        },
    }, MuiListItem: {
        styleOverrides: {
            root: {
                borderRadius: 8,
                borderStyle: 'solid',
                borderColor: divider,
                borderWidth: 1,
            },
        },
    }, MuiListItemButton: {
        styleOverrides: {
            root: ({ theme }) => ({
                transition: theme.transitions.create(['border-color', 'background-color'], {
                    duration: theme.transitions.duration.short,
                    easing: theme.transitions.easing.easeIn,
                }),
                backgroundColor: theme.palette.action.hover,
                borderRadius: 8,
                borderStyle: 'solid',
                borderColor: divider,
                borderWidth: 1,
                '&:hover': {
                    borderColor: black,
                },
                '&.Mui-disabled': {
                    backgroundColor: theme.palette.background.paper,
                },
            }),
        },
    }, MuiListItemIcon: {
        styleOverrides: {
            root: {
                color: black,
                minWidth: 'fit-content',
                marginTop: 0,
                marginLeft: 0,
                marginRight: 8,
            },
        },
    }, MuiToolbar: {
        styleOverrides: {
            root: {
                minHeight: '40px !important',
                height: 40,
            },
        },
    } });
const theme = createTheme({
    palette,
    components: portalComponents,
    typography,
});

const MultiThemeProvider = ({ children, fortressTheme, portalTheme, }) => {
    const [themeName] = useThemeName();
    return (React.createElement(ThemeProvider, { theme: themeName === 'Fortress' ? fortressTheme !== null && fortressTheme !== void 0 ? fortressTheme : {} : portalTheme !== null && portalTheme !== void 0 ? portalTheme : {} }, typeof children === 'function' ? children(themeName) : children));
};
MultiThemeProvider.defaultProps = {
    fortressTheme: theme$1,
    portalTheme: theme,
};

const SvgIcon = (props) => (React.createElement(MultiThemeProvider, null,
    React.createElement(SvgIcon$2, Object.assign({}, props))));
SvgIcon.defaultProps = {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
};

const AddPropertyIcon$1 = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { viewBox: "0 0 200 200" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M169.143 106.301C168.557 106.301 167.676 106.301 167.09 105.715L100.293 38.3324L33.496 ' +
            '105.129C32.0288 106.301 30.271 106.301 29.0991 105.129C27.9272 103.957 27.9272 101.904 29.0991 ' +
            '100.732L97.6538 31.8824C99.121 30.7106 100.879 30.7106 102.051 31.8824L170.901 100.732C172.073 ' +
            '101.904 172.073 103.957 170.901 105.129C170.901 105.715 169.729 106.301 169.143 106.301ZM150.979 ' +
            '168.997H49.6116C47.8538 168.997 46.6819 167.529 46.6819 165.772V106.297C46.6819 104.539 47.8538 ' +
            '103.367 49.6116 103.367C51.6647 103.367 52.8366 104.539 52.8366 106.297V163.132H148.344V109.517C148.344 ' +
            '107.759 149.812 106.292 151.569 106.292C153.327 106.292 154.794 107.759 154.794 109.517V166.353C153.913 ' +
            '167.525 152.741 168.992 150.983 168.992L150.979 168.997ZM142.185 61.4746C142.185 63.2324 143.357 ' +
            '64.4043 145.41 64.4043C147.168 64.4043 148.34 62.6465 148.34 61.4746V40.0856C148.34 38.3278 147.168 ' +
            '37.1559 145.41 37.1559H124.021C122.263 37.1559 120.796 38.3278 120.796 40.0856C120.796 42.1387 122.263 ' +
            '43.3106 124.021 43.3106H142.185V61.4746Z' }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M122.9 115.641H101.026V93.7659C101.026 93.18 100.635 92.6909 100.049 92.6909C99.4632 92.6909 ' +
            '98.9742 93.18 98.9742 93.7659V115.641H77.0999C76.5139 115.641 76.0249 116.032 76.0249 116.617C76.0249 ' +
            '117.203 76.5139 117.692 77.0999 117.692H98.9742V139.567C98.9742 140.153 99.3648 140.642 99.9507 ' +
            '140.642C100.537 140.642 101.026 140.153 101.026 139.567V117.692H122.9C123.486 117.692 123.975 117.203 ' +
            '123.975 116.617C123.975 116.032 123.486 115.641 122.9 115.641Z' })));

const AlertIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'AlertIcon' }),
        React.createElement("path", { d: "M12 16.7308C12.2288 16.7308 12.4207 16.6533 12.5755 16.4985C12.7303 16.3437\n    12.8077 16.1518 12.8077 15.923C12.8077 15.6942 12.7303 15.5023 12.5755 15.3475C12.4207\n    15.1928 12.2288 15.1155 12 15.1155C11.7712 15.1155 11.5793 15.1928 11.4245 15.3475C11.2697\n    15.5023 11.1923 15.6942 11.1923 15.923C11.1923 16.1518 11.2697 16.3437 11.4245\n    16.4985C11.5793 16.6533 11.7712 16.7308 12 16.7308ZM11.25 13.077H12.75V7.077H11.25V13.077ZM12.0017\n    21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433\n    17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877\n    2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308\n    4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983\n    2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653\n    4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506\n    9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752\n    15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757\n    16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017\n    21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20\n    14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333\n    4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4\n    14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" })));
};

const AlertCriticalIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'AlertCriticalIcon' }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: "M2.7251 20L12.0001 4L21.2751 20H2.7251ZM4.4501 19H19.5501L12.0001\n      6L4.4501 19ZM12.0001 17.625C12.1668 17.625 12.3128 17.5627 12.4381\n      17.438C12.5628 17.3127 12.6251 17.1667 12.6251 17C12.6251 16.8333\n      12.5628 16.6873 12.4381 16.562C12.3128 16.4373 12.1668 16.375\n      12.0001 16.375C11.8334 16.375 11.6874 16.4373 11.5621 16.562C11.4374\n      16.6873 11.3751 16.8333 11.3751 17C11.3751 17.1667 11.4374 17.3127\n      11.5621 17.438C11.6874 17.5627 11.8334 17.625 12.0001 17.625ZM11.5001\n      15.375H12.5001V10.375H11.5001V15.375Z" })));

const AlertInfoIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'AlertInfoIcon' }),
    React.createElement("path", { d: "M11.25 16.75H12.75V11H11.25V16.75ZM12 9.2885C12.2288 9.2885 12.4207\n    9.21108 12.5755 9.05625C12.7303 8.90142 12.8077 8.70958 12.8077 8.48075C12.8077\n    8.25192 12.7303 8.06008 12.5755 7.90525C12.4207 7.75058 12.2288 7.67325\n    12 7.67325C11.7712 7.67325 11.5793 7.75058 11.4245 7.90525C11.2697 8.06008\n    11.1923 8.25192 11.1923 8.48075C11.1923 8.70958 11.2697 8.90142 11.4245\n    9.05625C11.5793 9.21108 11.7712 9.2885 12 9.2885ZM12.0017 21.5C10.6877\n    21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795\n    18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5\n    13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033\n    4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294\n    3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473\n    2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757\n    6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5\n    11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766\n    17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503\n    21.2506 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675\n    17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125\n    4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4\n     14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" })));

const CalendarIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props),
    React.createElement("path", { d: 'M5.625 21.1125C5.15833 21.1125 4.771 20.9585 4.463 20.6505C4.15433 ' +
            '20.3418 4 19.9542 4 19.4875V6.73751C4 6.27085 4.15433 5.88351 4.463 ' +
            '5.57551C4.771 5.26685 5.15833 5.11251 5.625 ' +
            '5.11251H7.375V2.88751H8.45V5.11251H15.625V2.88751H16.625V5.11251H18.375C18.8417 ' +
            '5.11251 19.2293 5.26685 19.538 5.57551C19.846 5.88351 20 6.27085 20 ' +
            '6.73751V19.4875C20 19.9542 19.846 20.3418 19.538 20.6505C19.2293 20.9585 ' +
            '18.8417 21.1125 18.375 21.1125H5.625ZM5.625 20.1125H18.375C18.5417 ' +
            '20.1125 18.6873 20.0498 18.812 19.9245C18.9373 19.7998 19 19.6542 ' +
            '19 19.4875V10.7375H5V19.4875C5 19.6542 5.06267 19.7998 5.188 ' +
            '19.9245C5.31267 20.0498 5.45833 20.1125 5.625 20.1125ZM5 9.73751H19V6.73751C19 ' +
            '6.57085 18.9373 6.42518 18.812 6.30051C18.6873 6.17518 18.5417 6.11251 18.375 ' +
            '6.11251H5.625C5.45833 6.11251 5.31267 6.17518 5.188 6.30051C5.06267 6.42518 5 ' +
            '6.57085 5 6.73751V9.73751Z' })));

const CheckIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'CheckIcon' }),
    React.createElement("path", { d: 'M9.54983 17.6537L4.21533 12.3192L5.28433 11.25L9.54983 ' +
            '15.5155L18.7153 6.34998L19.7843 7.41923L9.54983 17.6537Z' })));

const CircleCheckIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'circleCheckIcon' }),
    React.createElement("path", { d: 'M10.55 15.9L16.95 9.5L16.25 8.8L10.55 14.5L7.7 11.65L7 12.35L10.55 ' +
            '15.9ZM12 21C10.75 21 9.57933 20.7627 8.488 20.288C7.396 19.8127 6.446 ' +
            '19.1707 5.638 18.362C4.82933 17.554 4.18733 16.604 3.712 15.512C3.23733 ' +
            '14.4207 3 13.25 3 12C3 10.75 3.23733 9.579 3.712 8.487C4.18733 7.39567 ' +
            '4.82933 6.44567 5.638 5.637C6.446 4.829 7.396 4.18733 8.488 3.712C9.57933 ' +
            '3.23733 10.75 3 12 3C13.25 3 14.421 3.23733 15.513 3.712C16.6043 4.18733 ' +
            '17.5543 4.829 18.363 5.637C19.171 6.44567 19.8127 7.39567 20.288 8.487C20.7627 ' +
            '9.579 21 10.75 21 12C21 13.25 20.7627 14.4207 20.288 15.512C19.8127 16.604 ' +
            '19.171 17.554 18.363 18.362C17.5543 19.1707 16.6043 19.8127 15.513 ' +
            '20.288C14.421 20.7627 13.25 21 12 21ZM12 20C14.2333 20 16.125 19.225 ' +
            '17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 ' +
            '17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 ' +
            '6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 ' +
            '19.225 9.76667 20 12 20Z' })));

/* istanbul ignore next */
const CircleIcon = (props) => (
/* istanbul ignore next */
React.createElement(SvgIcon, Object.assign({}, props, { viewBox: "0 0 24 24" }),
    React.createElement("circle", { cx: "12", cy: "12", r: "12" })));

const CircleDeleteIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "data-testid": "deleteIcon" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 
        // eslint-disable-next-line max-len
        'M11.9825 3.36871C7.23608 3.36871 3.3689 7.2359 3.3689 11.9823C3.3689 14.2677 4.24808 16.4474 5.90015 18.0646C7.51733 19.7172 9.66215 20.6313 11.9825 20.6313C16.7288 20.6313 20.596 16.7641 20.6309 12.0177C20.6309 7.27134 16.7637 3.36928 11.9825 3.36928V3.36871ZM11.9825 19.8573C9.87308 19.8573 7.90433 19.0484 6.42777 17.537C4.91577 16.0604 4.10746 14.0917 4.10746 11.9823C4.1429 7.65778 7.65852 4.10728 12.0179 4.10728C16.3424 4.14271 19.8929 7.65834 19.858 12.0177C19.858 16.3422 16.3424 19.8578 11.983 19.8578L11.9825 19.8573ZM14.9001 8.53696C15.0756 8.39634 15.2866 8.39634 15.4626 8.53696L15.4632 8.53753C15.6038 8.71303 15.6038 8.92396 15.4632 9.10003L12.5101 11.9828L15.4283 14.936C15.569 15.0766 15.569 15.2875 15.4283 15.4636C15.358 15.5339 15.2523 15.5693 15.182 15.5693C15.0768 15.5693 14.971 15.5339 14.9007 15.4636L11.9825 12.5105L9.06421 15.4287C8.9939 15.499 8.88815 15.5345 8.81783 15.5345C8.71265 15.5345 8.6069 15.499 8.53658 15.4287C8.39596 15.2881 8.39596 15.0417 8.53658 14.9011L11.4548 11.9828L8.53658 9.06459C8.39596 8.92396 8.39596 8.67759 8.53658 8.53696C8.71208 8.39634 8.92302 8.39634 9.09908 8.53696L11.9819 11.4552L14.9001 8.53696Z' })));

const CommentDotsIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "CommentDotsIcon" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: 'M3 11.0683C3 6.9904 7.04243 3.65048 11.9994 3.65048H12.0006C16.957 ' +
                '3.65048 21 6.9904 21 11.0683C21 15.1461 16.9576 ' +
                '18.4861 12.0006 18.4861C10.9808 18.4861 9.96163 18.3454 9.01219 ' +
                '18.0642L4.1958 20.3141C4.12549 20.3495 4.09006 20.3495 ' +
                '4.01975 20.3495C3.91457 20.3495 3.80882 20.3141 3.73852 20.2438C3.63277 ' +
                '20.1386 3.59734 19.9625 3.70308 19.8219L5.49622 ' +
                '16.2008C3.87913 14.83 3 13.002 3 11.0683ZM9.08137 17.3251C10.0308 ' +
                '17.6064 10.9797 17.747 11.9994 17.747L11.9989 ' +
                '17.7464C16.534 17.7464 20.2604 14.7586 20.2604 11.0671C20.2604 ' +
                '7.41112 16.534 4.42275 11.9989 4.42275C7.46372 ' +
                '4.42275 3.73739 7.41112 3.73739 11.0671C3.73739 12.8603 4.61596 ' +
                '14.5477 6.19818 15.8132C6.33935 15.919 6.37423 16.0945 ' +
                '6.30392 16.2705L4.82745 19.1886L8.83501 17.3251C8.90532 17.2897 ' +
                '9.01106 17.2897 9.08137 17.3251ZM8.23824 9.27513C7.42941 ' +
                '9.27513 6.76177 9.94334 6.76177 10.787C6.76177 11.6307 7.42997 ' +
                '12.2989 8.23824 12.2989C9.08193 12.2989 9.75014 11.6307 ' +
                '9.75014 10.787C9.75014 9.94334 9.08193 9.27513 8.23824 ' +
                '9.27513ZM7.49972 10.7865C7.49972 11.2083 7.85126 11.525 8.23823 ' +
                '11.525C8.66008 11.525 9.01162 11.2083 9.01162 10.7865C9.01162 10.3646 ' +
                '8.66008 10.048 8.23823 10.048C7.85126 10.048 ' +
                '7.49972 10.3646 7.49972 10.7865ZM11.9994 9.27513C11.1557 9.27513 ' +
                '10.4875 9.94334 10.4875 10.787C10.4875 11.6307 ' +
                '11.1557 12.2989 11.9994 12.2989C12.8431 12.2989 13.5113 11.6307 ' +
                '13.5113 10.787C13.5113 9.94334 12.8431 9.27513 ' +
                '11.9994 9.27513ZM11.2609 10.7865C11.2609 11.2083 11.5776 11.525 ' +
                '11.9994 11.525C12.4213 11.525 12.738 11.2083 12.738 ' +
                '10.7865C12.738 10.3646 12.4213 10.048 11.9994 10.048C11.5776 10.048 ' +
                '11.2609 10.3646 11.2609 10.7865ZM15.7612 ' +
                '9.27513C14.9175 9.27513 14.2493 9.94334 14.2493 10.787C14.2493 ' +
                '11.6307 14.9175 12.2989 15.7612 12.2989C16.57 ' +
                '12.2989 17.2377 11.6307 17.2377 10.787C17.2377 9.94334 16.5695 ' +
                '9.27513 15.7612 9.27513ZM14.9878 10.7865C14.9878 ' +
                '11.2083 15.3394 11.525 15.7612 11.525C16.1482 11.525 16.4997 ' +
                '11.2083 16.4997 10.7865C16.4997 10.3646 16.1482 10.048 15.7612 ' +
                '10.048C15.3394 10.048 14.9878 10.3646 14.9878 10.7865Z' })));
};

const CloseIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "CloseIcon" }),
    React.createElement("path", { d: 'M8.8 16L8 15.2L11.2 12L8 8.8L8.8 8L12 11.2L15.2 ' +
            '8L16 8.8L12.8 12L16 15.2L15.2 16L12 12.8L8.8 16Z' })));

const DeleteIcon = (props) => React.createElement(CloseIcon, Object.assign({}, props));

const FloppyIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "FloppyIcon" }),
    React.createElement("path", { d: 'M20 7.42307V18.3846C20 18.8449 19.8458 19.2292 19.5375 19.5375C19.2292 ' +
            '19.8458 18.8449 20 18.3846 20H5.61538C5.15513 20 4.77083 19.8458 4.4625 ' +
            '19.5375C4.15417 19.2292 4 18.8449 4 18.3846V5.61537C4 5.15512 4.15417 ' +
            '4.77083 4.4625 4.4625C4.77083 4.15417 5.15513 4 5.61538 4H16.5769L20 ' +
            '7.42307ZM19 7.85L16.15 5H5.61538C5.43589 5 5.28846 5.05769 5.17308 ' +
            '5.17307C5.05769 5.28846 5 5.43589 5 5.61537V18.3846C5 18.5641 5.05769 ' +
            '18.7115 5.17308 18.8269C5.28846 18.9423 5.43589 19 5.61538 19H18.3846C18.5641 ' +
            '19 18.7115 18.9423 18.8269 18.8269C18.9423 18.7115 19 18.5641 19 ' +
            '18.3846V7.85ZM12 16.5385C12.5513 16.5385 13.0224 16.343 13.4135 ' +
            '15.9519C13.8045 15.5609 14 15.0898 14 14.5385C14 13.9872 13.8045 ' +
            '13.516 13.4135 13.125C13.0224 12.734 12.5513 12.5385 12 12.5385C11.4487 ' +
            '12.5385 10.9776 12.734 10.5865 13.125C10.1955 13.516 10 13.9872 10 ' +
            '14.5385C10 15.0898 10.1955 15.5609 10.5865 15.9519C10.9776 16.343 ' +
            '11.4487 16.5385 12 16.5385ZM6.76923 9.76922H14.1923V6.76922H6.76923V9.76922Z' })));

const FolderIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'folderIcon' }),
    React.createElement("path", { d: 'M4.61538 18.9999C4.15513 18.9999 3.77083 18.8458 3.4625 18.5374C3.15417 ' +
            '18.2291 3 17.8448 3 17.3846V7.38454C3 6.92429 3.15417 6.54 3.4625 ' +
            '6.23167C3.77083 5.92333 4.15513 5.76917 4.61538 5.76917H10.7692L12 ' +
            '6.99994H19.3846C19.8449 6.99994 20.2292 7.15411 20.5375 ' +
            '7.46244C20.8458 7.77077 21 8.15507 21 8.61532V17.3846C21 ' +
            '17.8448 20.8458 18.2291 20.5375 18.5374C20.2292 18.8458 ' +
            '19.8449 18.9999 19.3846 18.9999H4.61538ZM4 7.38454V17.3846C4 ' +
            '17.564 4.05769 17.7115 4.17308 17.8269C4.28846 17.9422 4.43589 ' +
            '17.9999 4.61538 17.9999H19.3846C19.5641 17.9999 19.7115 17.9422 ' +
            '19.8269 17.8269C19.9423 17.7115 20 17.564 20 17.3846V8.61532C20 ' +
            '8.43583 19.9423 8.2884 19.8269 8.17301C19.7115 8.05763 19.5641 ' +
            '7.99994 19.3846 7.99994H11.5981L10.3673 6.76917H4.61538C4.43589 ' +
            '6.76917 4.28846 6.82686 4.17308 6.94224C4.05769 7.05762 4 7.20506 ' +
            '4 7.38454ZM4 7.38454V6.76917V17.9999V7.38454Z' })));

const HomeHandIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { viewBox: "0 0 24 24" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: 'M18.2229 8.83632L12.5979 3.98491L7.04325 8.83632L6.51562 8.30871L12.5979 3L18.6803 8.30871L18.2229 ' +
            '8.83632ZM16.2891 13.5825H14.1094V12.8091H15.5859V8.30927H16.2891V13.5825ZM13.3359 12.8091L14.1094 ' +
            '12.8091V9.82066H11.1911V12.8091H9.67969V8.30927H8.94112V13.5825H11.1911V12.8091L11.8594 ' +
            '12.8091V10.5592H13.3359V12.8091ZM16.3594 5.70779H17.0276V3.14118H14.4609V3.80941H16.3594V5.70779ZM6.69169 ' +
            '20.3323H3V13.6529H6.69169V14.32H6.58481V15.0585H6.69169V18.6213L6.44531 18.5391L6.16406 18.3631L6.69169 ' +
            '19.0662L6.23438 19.2068C6.3884 19.2604 6.54117 19.3127 6.69169 19.3638V20.3323ZM15.2322 16.8838C15.2051 ' +
            '16.2561 14.8279 15.8319 14.3197 15.8319H11.7885C11.6827 15.8319 11.4718 15.6913 11.3312 15.5152C10.7333 ' +
            '15.0585 9.67856 14.32 8.41294 14.32H6.69169V15.0585H8.30775C9.38502 15.0585 10.2044 15.6387 10.797 ' +
            '16.0584L10.8744 16.1132C11.2614 16.4298 11.4724 16.5705 11.6833 16.5705H14.3203C14.4609 16.5705 14.5667 ' +
            '16.8168 14.5667 16.9574C14.5667 17.0981 14.4609 17.309 14.3203 17.309H9.89062V18.0824H14.3203L14.3197 ' +
            '18.0818C14.6204 18.0818 14.8755 17.9331 15.0391 17.6813L18.2927 16.6402C18.8203 16.4996 19.2068 16.4996 ' +
            '19.8047 16.9569C18.6837 17.4458 17.7975 17.9344 17.0502 18.3463L17.05 18.3465C16.8835 18.4382 16.724 ' +
            '18.5262 16.5703 18.6094C14.5925 19.6609 13.6172 20.1794 12.6097 20.252C11.6295 20.3226 10.6189 19.9711 ' +
            '8.625 19.2777C8.0865 19.0875 7.43327 18.8686 6.69169 18.6213V19.0662V19.3638C6.93704 19.447 7.17644 ' +
            '19.5268 7.40568 19.6033L7.4066 19.6036C7.77441 19.7263 8.11604 19.8402 8.41406 19.9453C10.2776 20.613 ' +
            '11.4026 21 12.387 21H12.3864C13.5817 21 14.6364 20.4724 16.8864 19.2771C17.3919 19.0335 17.9774 18.7302 ' +
            '18.6373 18.3883L18.6374 18.3883L18.6375 18.3883C19.2164 18.0883 19.8527 17.7587 20.5427 17.4136L21 ' +
            '17.1672L20.613 16.8157C19.8047 15.972 19.0661 15.6907 18.0817 15.972L15.2322 16.8838ZM15.2322 ' +
            '16.8838L14.5661 17.0969L14.7771 17.7652L15.0391 17.6813C15.1624 17.4917 15.2338 17.2437 15.2338 ' +
            '16.9569C15.2338 16.9322 15.2333 16.9079 15.2322 16.8838ZM5.91825 19.5589H3.66825V14.3205H5.91825V19.5589Z', stroke: "transparent" })));

const LockIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M16.25 7.5V9.75H18.5V21H5V9.75H7.25V7.5C7.25 5.00419 9.25419 3 ' +
            '11.75 3C14.2458 3 16.25 5.00362 16.25 7.5ZM11.0114 14.2506C11.0114 ' +
            '13.8287 11.3281 13.512 11.75 13.512C12.1719 13.512 12.4886 13.8287 ' +
            '12.4886 14.2506C12.4886 14.5318 12.3479 14.7776 12.137 ' +
            '14.8834V16.8876C12.137 17.0985 11.9609 17.2391 11.75 17.2391C11.5391 ' +
            '17.2391 11.363 17.0985 11.363 16.8876V14.8834C11.1521 14.7782 11.0114 ' +
            '14.5318 11.0114 14.2506ZM7.98856 7.5C7.98856 5.4255 9.67606 3.738 11.7506 ' +
            '3.738C13.8251 3.738 15.5126 5.4255 15.5126 7.5V9.75H7.98913L7.98856 ' +
            '7.5ZM5.73856 20.262H17.762V10.4886H5.73856V20.262Z' })));

const MinusIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props),
    React.createElement("path", { d: 'M6 12.5V11.5H18V12.5H6Z' })));

const MoneyIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'moneyIcon' }),
    React.createElement("path", { d: 'M11.5059 20V18.0941C10.7059 17.9843 10.0157 17.702 9.43529 ' +
            '17.2471C8.8549 16.7922 8.42353 16.1647 8.14117 15.3647L9.01176 ' +
            '14.9882C9.27843 15.6941 9.65082 16.2353 10.1289 16.6118C10.6077 ' +
            '16.9882 11.2549 17.1765 12.0706 17.1765C12.7765 17.1765 13.4274 ' +
            '17.0002 14.0235 16.6475C14.6196 16.2943 14.9176 15.7176 14.9176 ' +
            '14.9176C14.9176 14.2431 14.698 13.7057 14.2588 13.3054C13.8196 ' +
            '12.9057 13.0039 12.5098 11.8118 12.1176C10.6039 11.7255 9.74902 ' +
            '11.2822 9.24706 10.7878C8.7451 10.294 8.49412 9.64706 8.49412 ' +
            '8.84706C8.49412 7.96863 8.83137 7.27059 9.50588 6.75294C10.1804 ' +
            '6.23529 10.8471 5.95294 11.5059 5.90588V4H12.4471V5.90588C13.1059 ' +
            '5.96863 13.6706 6.14902 14.1412 6.44706C14.6118 6.7451 14.9961 ' +
            '7.16863 15.2941 7.71765L14.4706 8.14118C14.2353 7.73333 13.9216 ' +
            '7.40392 13.5294 7.15294C13.1373 6.90196 12.6353 6.77647 12.0235 ' +
            '6.77647C11.302 6.77647 10.6902 6.96847 10.1882 7.35247C9.68627 ' +
            '7.7371 9.43529 8.23529 9.43529 8.84706C9.43529 9.42745 9.64329 ' +
            '9.89804 10.0593 10.2588C10.4747 10.6196 11.2941 10.9882 12.5176 ' +
            '11.3647C13.6627 11.7255 14.506 12.192 15.0475 12.7642C15.5884 ' +
            '13.3371 15.8588 14.0549 15.8588 14.9176C15.8588 15.8588 15.5256 ' +
            '16.608 14.8593 17.1652C14.1923 17.7217 13.3882 18.0314 12.4471 ' +
            '18.0941V20H11.5059Z' })));

const NotesIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props),
    React.createElement("path", { d: 'M6.18837 20.8212C5.72812 20.8212 5.34383 20.667 5.0355 20.3587C4.72716 20.0503 4.573 19.666 ' +
            '4.573 19.2058V6.43654C4.573 5.97629 4.72716 5.592 5.0355 5.28367C5.34383 4.97533 5.72812 4.82117 ' +
            '6.18837 4.82117H16.1499L20.573 9.24424V19.2058C20.573 19.666 20.4188 20.0503 20.1105 20.3587C19.8022 ' +
            '20.667 19.4179 20.8212 18.9576 20.8212H6.18837ZM6.18837 19.8212H18.9576C19.1371 19.8212 19.2845 ' +
            '19.7635 19.3999 19.6481C19.5153 19.5327 19.573 19.3853 ' +
            '19.573 19.2058V9.82117H15.573V5.82117H6.18837C6.00889 ' +
            '5.82117 5.86146 5.87886 5.74607 5.99424C5.63069 6.10962 5.573 6.25706 5.573 6.43654V19.2058C5.573 19.3853 ' +
            '5.63069 19.5327 5.74607 19.6481C5.86146 19.7635 6.00889 19.8212 6.18837 19.8212ZM8.073 ' +
            '16.8212H17.073V15.8212H8.073V16.8212ZM8.073 9.82117H12.573V8.82117H8.073V9.82117ZM8.073 ' +
            '13.3212H17.073V12.3212H8.073V13.3212Z' })));

const PencilIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props),
    React.createElement("path", { d: 'M5.1875 18.8125H6.2625L16.1625 8.9125L15.0875 7.8375L5.1875 17.7375V18.8125ZM18.3125 ' +
            '8.1875L15.8125 5.7125L17.0125 4.5125C17.2125 4.29583 17.4542 4.1875 17.7375 ' +
            '4.1875C18.0208 4.1875 18.2625 4.29583 18.4625 4.5125L19.5125 5.5375C19.7125 ' +
            '5.7375 19.8125 5.97917 19.8125 6.2625C19.8125 6.54583 19.7125 6.7875 19.5125 ' +
            '6.9875L18.3125 8.1875ZM17.5875 8.9125L6.6875 19.8125H4.1875V17.3125L15.0875 ' +
            '6.4125L17.5875 8.9125Z' })));

const PeopleIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'peopleIcon' }),
    React.createElement("path", { d: 'M2.57202 18.8235V17.1773C2.57202 16.7132 2.69221 16.3142 2.9326 15.9802C3.17298 ' +
            '15.6462 3.49602 15.3793 3.90172 15.1795C4.7691 14.7665 5.63035 14.4372 6.48547 ' +
            '14.1917C7.3406 13.9462 8.36945 13.8235 9.57202 13.8235C10.7746 13.8235 11.8034 ' +
            '13.9462 12.6586 14.1917C13.5137 14.4372 14.3749 14.7665 15.2423 15.1795C15.648 ' +
            '15.3793 15.9711 15.6462 16.2114 15.9802C16.4518 16.3142 16.572 16.7132 16.572 ' +
            '17.1773V18.8235H2.57202ZM18.572 18.8235V17.1312C18.572 16.5517 18.4547 16.0047 ' +
            '18.2202 15.4902C17.9856 14.9756 17.6529 14.5342 17.222 14.1658C17.7131 14.2658 ' +
            '18.1861 14.4045 18.6412 14.5821C19.0964 14.7597 19.5464 14.9594 19.9913 ' +
            '15.1812C20.4246 15.3991 20.7643 15.678 21.0105 16.0179C21.2566 16.3578 ' +
            '21.3797 16.7289 21.3797 17.1312V18.8235H18.572ZM9.57202 11.5927C8.74702 ' +
            '11.5927 8.04077 11.299 7.45327 10.7115C6.86577 10.124 6.57202 9.41771 ' +
            '6.57202 8.59271C6.57202 7.76769 6.86577 7.06143 7.45327 6.47393C8.04077 ' +
            '5.88643 8.74702 5.59268 9.57202 5.59268C10.397 5.59268 11.1033 5.88643 ' +
            '11.6908 6.47393C12.2783 7.06143 12.572 7.76769 12.572 8.59271C12.572 ' +
            '9.41771 12.2783 10.124 11.6908 10.7115C11.1033 11.299 10.397 11.5927 ' +
            '9.57202 11.5927ZM16.8413 8.59271C16.8413 9.41771 16.5475 10.124 15.96 ' +
            '10.7115C15.3725 11.299 14.6663 11.5927 13.8413 11.5927C13.799 11.5927 ' +
            '13.7451 11.5879 13.6797 11.5783C13.6143 11.5687 13.5605 11.5581 13.5182 ' +
            '11.5466C13.8569 11.1316 14.1172 10.6713 14.2991 10.1657C14.4811 9.66001 ' +
            '14.572 9.13489 14.572 8.59031C14.572 8.04574 14.4768 7.52538 14.2864 ' +
            '7.02923C14.0961 6.53308 13.84 6.06962 13.5182 5.63883C13.572 5.61962 ' +
            '13.6259 5.60712 13.6797 5.60133C13.7336 5.59557 13.7874 5.59268 13.8413 ' +
            '5.59268C14.6663 5.59268 15.3725 5.88643 15.96 6.47393C16.5475 7.06143 ' +
            '16.8413 7.76769 16.8413 8.59271ZM3.57202 17.8235H15.572V17.1773C15.572 ' +
            '16.9427 15.5134 16.7376 15.3961 16.5619C15.2788 16.3863 15.0682 16.2183 ' +
            '14.7643 16.0581C14.0182 15.6594 13.2316 15.3539 12.4047 15.1417C11.5778 ' +
            '14.9295 10.6336 14.8235 9.57202 14.8235C8.51049 14.8235 7.56625 14.9295 ' +
            '6.73932 15.1417C5.9124 15.3539 5.12587 15.6594 4.37972 16.0581C4.07587 ' +
            '16.2183 3.86529 16.3863 3.74797 16.5619C3.63067 16.7376 3.57202 16.9427 ' +
            '3.57202 17.1773V17.8235ZM9.57202 10.5927C10.122 10.5927 10.5929 10.3969 ' +
            '10.9845 10.0052C11.3762 9.61354 11.572 9.14271 11.572 8.59271C11.572 ' +
            '8.04271 11.3762 7.57187 10.9845 7.18021C10.5929 6.78854 10.122 6.59271 ' +
            '9.57202 6.59271C9.02202 6.59271 8.55119 6.78854 8.15952 7.18021C7.76785 ' +
            '7.57187 7.57202 8.04271 7.57202 8.59271C7.57202 9.14271 7.76785 9.61354 ' +
            '8.15952 10.0052C8.55119 10.3969 9.02202 10.5927 9.57202 10.5927Z' })));

const PlusIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props),
    React.createElement("path", { d: 'M11.5 18.5V12.5H5.5V11.5H11.5V5.5H12.5V11.5H18.5V12.5H12.5V18.5H11.5Z' })));

const UnCheckedIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'unCheckedIcon' }),
    React.createElement("path", { d: 'M5.625 20C5.15833 20 4.771 19.846 4.463 19.538C4.15433 19.2293 4 18.8417 4 ' +
            '18.375V5.625C4 5.15833 4.15433 4.771 4.463 4.463C4.771 4.15433 5.15833 4 ' +
            '5.625 4H18.375C18.8417 4 19.2293 4.15433 19.538 4.463C19.846 4.771 20 ' +
            '5.15833 20 5.625V18.375C20 18.8417 19.846 19.2293 19.538 19.538C19.2293 ' +
            '19.846 18.8417 20 18.375 20H5.625Z', fill: "transparent" }),
    React.createElement("path", { d: 'M5.625 20C5.15833 20 4.771 19.846 4.463 19.538C4.15433 19.2293 4 18.8417 4 ' +
            '18.375V5.625C4 5.15833 4.15433 4.771 4.463 4.463C4.771 4.15433 5.15833 4 ' +
            '5.625 4H18.375C18.8417 4 19.2293 4.15433 19.538 4.463C19.846 4.771 20 ' +
            '5.15833 20 5.625V18.375C20 18.8417 19.846 19.2293 19.538 19.538C19.2293 ' +
            '19.846 18.8417 20 18.375 20H5.625ZM5.625 19H18.375C18.5417 19 18.6873 ' +
            '18.9373 18.812 18.812C18.9373 18.6873 19 18.5417 19 18.375V5.625C19 5.45833 ' +
            '18.9373 5.31267 18.812 5.188C18.6873 5.06267 18.5417 5 18.375 5H5.625C5.45833 ' +
            '5 5.31267 5.06267 5.188 5.188C5.06267 5.31267 5 5.45833 5 5.625V18.375C5 ' +
            '18.5417 5.06267 18.6873 5.188 18.812C5.31267 18.9373 5.45833 19 5.625 19Z', fill: props.fill })));
UnCheckedIcon.defaultProps = {};

const OpenStatusIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 ' +
                '22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 ' +
                '4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 ' +
                '16.41 16.41 20 12 20ZM15 12C15 13.66 13.66 15 12 15C10.34 ' +
                '15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 ' +
                '12Z', fill: props.color })));
};
OpenStatusIcon.defaultProps = {
    color: blue.main,
};

const InProgressStatusIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { viewBox: '0 -960 960 960', "data-testid": 'inProgressStatusIcon' }),
        React.createElement("path", { d: 'm625.846-305.846 28.308-28.308L500-488.326V-680h-40v208.308l165.846 ' +
                '165.846ZM480.134-120q-74.673 ' +
                '0-140.41-28.339-65.737-28.34-114.365-76.922-48.627-48.582-76.993-114.257Q120-405.194 ' +
                '120-479.866q0-74.673 28.339-140.41 28.34-65.737 76.922-114.365 48.582-48.627 ' +
                '114.257-76.993Q405.194-840 479.866-840q74.673 0 140.41 28.339 65.737 28.34 ' +
                '114.365 76.922 48.627 48.582 76.993 114.257Q840-554.806 840-480.134q0 ' +
                '74.673-28.339 140.41-28.34 65.737-76.922 114.365-48.582 48.627-114.257 ' +
                '76.993Q554.806-120 480.134-120ZM480-480Zm0 320q133 0 ' +
                '226.5-93.5T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 ' +
                '133 93.5 226.5T480-160Z' })));
};
InProgressStatusIcon.defaultProps = {};

const OnHoldStatusIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M10 16C10.55 16 11 15.55 11 15V9C11 8.45 10.55 8 10 8C9.45 8 9 ' +
                '8.45 9 9V15C9 15.55 9.45 16 10 16ZM12 2C6.48 2 2 6.48 2 12C2 ' +
                '17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 ' +
                '2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 ' +
                '20 12C20 16.41 16.41 20 12 20ZM14 16C14.55 16 15 15.55 15 15V9C15 ' +
                '8.45 14.55 8 14 8C13.45 8 13 8.45 13 9V15C13 15.55 13.45 16 14 16Z', fill: props.color })));
};
OnHoldStatusIcon.defaultProps = {
    color: yellow.main,
};

const CompletedStatusIcon = (props) => {
    return React.createElement(CircleCheckIcon, Object.assign({}, props));
};
CompletedStatusIcon.defaultProps = {};

const CanceledStatusIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'canceledStatusIcon' }),
        React.createElement("path", { d: 'M8.4 16.3L12 12.7L15.6 16.3L16.3 15.6L12.7 12L16.3 8.4L15.6 7.7L12 ' +
                '11.3L8.4 7.7L7.7 8.4L11.3 12L7.7 15.6L8.4 16.3ZM12 21C10.75 21 ' +
                '9.57933 20.7627 8.488 20.288C7.396 19.8127 6.446 19.1707 5.638 ' +
                '18.362C4.82933 17.554 4.18733 16.604 3.712 15.512C3.23733 14.4207 ' +
                '3 13.25 3 12C3 10.75 3.23733 9.579 3.712 8.487C4.18733 7.39567 ' +
                '4.82933 6.44567 5.638 5.637C6.446 4.829 7.396 4.18733 8.488 ' +
                '3.712C9.57933 3.23733 10.75 3 12 3C13.25 3 14.421 3.23733 ' +
                '15.513 3.712C16.6043 4.18733 17.5543 4.829 18.363 5.637C19.171 ' +
                '6.44567 19.8127 7.39567 20.288 8.487C20.7627 9.579 21 10.75 21 ' +
                '12C21 13.25 20.7627 14.4207 20.288 15.512C19.8127 16.604 19.171 ' +
                '17.554 18.363 18.362C17.5543 19.1707 16.6043 19.8127 15.513 ' +
                '20.288C14.421 20.7627 13.25 21 12 21ZM12 20C14.2333 20 16.125 ' +
                '19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 ' +
                '19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 ' +
                '7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 ' +
                '4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z' })));
};
CanceledStatusIcon.defaultProps = {};

const SortIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'sortIcon' }),
        React.createElement("path", { stroke: "transparent", d: 'M12 20.2692L8.15381 16.4231L8.87303 15.7038L12 18.8308L15.1269 15.7038L15.8461 ' +
                '16.4231L12 20.2692ZM8.87303 8.31922L8.15381 7.6L12 3.75385L15.8461 7.6L15.1269 ' +
                '8.31922L12 5.19232L8.87303 8.31922Z' })));
};

const CommentWordsIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }),
        React.createElement("path", { stroke: "transparent", d: 'M12.9994 3.65048C8.04243 3.65048 4 6.9904 4 11.0683C4 ' +
                '13.002 4.87913 14.83 6.49622 16.2008L4.70308 ' +
                '19.8219C4.59734 19.9625 4.63277 20.1386 4.73852 ' +
                '20.2438C4.80882 20.3141 4.91457 20.3495 5.01975 ' +
                '20.3495C5.09006 20.3495 5.12549 20.3495 5.1958 ' +
                '20.3141L10.0122 18.0642C10.9616 18.3454 11.9808 ' +
                '18.4861 13.0006 18.4861C17.9576 18.4861 22 15.1461 ' +
                '22 11.0683C22 6.9904 17.957 3.65048 13.0006 ' +
                '3.65048H12.9994ZM12.9994 17.747C11.9797 17.747 ' +
                '11.0308 17.6064 10.0814 17.3251C10.0111 17.2897 ' +
                '9.90532 17.2897 9.83501 17.3251L5.82745 19.1886L7.30392 ' +
                '16.2705C7.37423 16.0945 7.33935 15.919 7.19818 ' +
                '15.8132C5.61596 14.5477 4.73739 12.8603 4.73739 ' +
                '11.0671C4.73739 7.41112 8.46372 4.42275 12.9989 ' +
                '4.42275C17.534 4.42275 21.2604 7.41112 21.2604 ' +
                '11.0671C21.2604 14.7586 17.534 17.7464 12.9989 ' +
                '17.7464L12.9994 17.747ZM14.5113 9.8376H9.62465C9.41372 ' +
                '9.8376 9.23767 9.69698 9.23767 9.48605C9.23767 9.27513 ' +
                '9.41372 9.09908 9.62465 9.09908H14.5113C14.7223 9.09908 ' +
                '14.8629 9.27513 14.8629 9.48605C14.8629 9.69698 14.7223 ' +
                '9.8376 14.5113 9.8376ZM16.7612 11.3489H9.62465C9.41372 ' +
                '11.3489 9.23767 11.525 9.23767 11.7359C9.23767 11.9468 ' +
                '9.41372 12.0875 9.62465 12.0875H16.7612C16.9721 12.0875 ' +
                '17.1127 11.9468 17.1127 11.7359C17.1127 11.525 16.9721 ' +
                '11.3489 16.7612 11.3489ZM9.62465 13.5988H16.7612C16.9721 ' +
                '13.5988 17.1127 13.7748 17.1127 13.9858C17.1127 14.1967 ' +
                '16.9721 14.3373 16.7612 14.3373H9.62465C9.41372 14.3373 ' +
                '9.23767 14.1967 9.23767 13.9858C9.23767 13.7748 9.41372 ' +
                '13.5988 9.62465 13.5988Z' })));
};
CommentWordsIcon.defaultProps = {
    color: blue.main,
};

const FilterIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", "data-testid": "filterIcon" }),
        React.createElement("path", { stroke: "transparent", d: 'M20.6087 3C20.7493 3 20.8898 3.07031 20.9601 ' +
                '3.21092H20.9618C21.0321 3.35154 20.9966 3.49216 ' +
                '20.9264 3.5979L13.5114 12.5625V18.3632C13.5114 ' +
                '18.4683 13.476 18.5741 13.4057 18.6444L11.1567 ' +
                '20.8943C11.0864 20.9646 10.9813 21 10.8756 21C10.8407 ' +
                '21 10.7704 21 10.735 20.9646C10.5945 20.9297 ' +
                '10.4887 20.7891 10.4887 20.613V12.5625L3.07379 ' +
                '3.5979C3.00295 3.49216 2.96809 3.35154 3.03837 ' +
                '3.21092C3.10865 3.07031 3.24921 3 3.38978 ' +
                '3H20.6087ZM12.7366 12.4567C12.7366 12.351 ' +
                '12.772 12.2807 12.8423 12.2104L19.8345 ' +
                '3.73795H4.16175L11.155 12.2104C11.2253 ' +
                '12.2807 11.2607 12.351 11.2607 ' +
                '12.4567V19.7339L12.7366 18.222V12.4567Z' }),
        React.createElement("g", { transform: `translate(2, 4) rotate(${props.selected ? 180 : 0})` },
            React.createElement("polygon", { stroke: "transparent", points: "16.5,11 19,14 14,14" }))));
};
FilterIcon.defaultProps = {
    selected: false,
};

const SearchIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'searchIcon' }),
        React.createElement("path", { d: 'M19.4758 20.1504L13.2258 13.9004C12.7258 14.3171 12.1508 14.6421 ' +
                '11.5008 14.8754C10.8508 15.1087 10.2008 15.2254 9.55078 15.2254C7.93411 ' +
                '15.2254 6.57178 14.6711 5.46378 13.5624C4.35511 12.4544 3.80078 11.1004 ' +
                '3.80078 9.50039C3.80078 7.90039 4.35511 6.54606 5.46378 5.43739C6.57178 ' +
                '4.32939 7.92578 3.77539 9.52578 3.77539C11.1258 3.77539 12.4841 4.32939 ' +
                '13.6008 5.43739C14.7174 6.54606 15.2758 7.90039 15.2758 9.50039C15.2758 ' +
                '10.2004 15.1508 10.8754 14.9008 11.5254C14.6508 12.1754 14.3258 12.7254 ' +
                '13.9258 13.1754L20.2008 19.4504L19.4758 20.1504ZM9.55078 14.2254C10.8674 ' +
                '14.2254 11.9841 13.7714 12.9008 12.8634C13.8174 11.9547 14.2758 10.8337 ' +
                '14.2758 9.50039C14.2758 8.16706 13.8174 7.04606 12.9008 6.13739C11.9841 ' +
                '5.22939 10.8674 4.77539 9.55078 4.77539C8.21745 4.77539 7.09245 5.22939 ' +
                '6.17578 6.13739C5.25911 7.04606 4.80078 8.16706 4.80078 9.50039C4.80078 ' +
                '10.8337 5.25911 11.9547 6.17578 12.8634C7.09245 13.7714 8.21745 14.2254 ' +
                '9.55078 14.2254Z' })));
};

const DownloadIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'downloadIcon' }),
        React.createElement("path", { d: 'M6.5 19C5.25 19 4.18733 18.5667 3.312 17.7C2.43733 16.8333 2 15.775 2 14.525C2 ' +
                '13.375 2.39167 12.354 3.175 11.462C3.95833 10.5707 4.93333 10.0917 6.1 ' +
                '10.025C6.26667 8.79165 6.88767 7.65399 7.963 6.61199C9.03767 5.57065 ' +
                '10.2167 5.04999 11.5 5.04999C11.7667 5.04999 12 5.14999 12.2 5.34999C12.4 ' +
                '5.54999 12.5 5.78332 12.5 6.04999V13.35L14.55 11.3L15.275 12L12 ' +
                '15.275L8.725 12L9.45 11.3L11.5 13.35V6.04999C10.25 6.11665 9.18733 ' +
                '6.66665 8.312 7.69999C7.43733 8.73332 7 9.83332 7 11H6.5C5.53333 ' +
                '11 4.70833 11.3417 4.025 12.025C3.34167 12.7083 3 13.5333 3 14.5C3 ' +
                '15.4667 3.34167 16.2917 4.025 16.975C4.70833 17.6583 5.53333 18 6.5 ' +
                '18H18.5C19.2 18 19.7917 17.7583 20.275 17.275C20.7583 16.7917 21 ' +
                '16.2 21 15.5C21 14.8 20.7583 14.2083 20.275 13.725C19.7917 13.2417 ' +
                '19.2 13 18.5 13H17V11C17 10.1667 16.8167 9.40432 16.45 8.71299C16.0833 ' +
                '8.02099 15.6 7.44999 15 6.99999V5.79999C15.9333 6.33332 16.6667 ' +
                '7.06232 17.2 7.98699C17.7333 8.91232 18 9.91665 18 11V12H18.625C19.575 ' +
                '12.0333 20.375 12.3873 21.025 13.062C21.675 13.7373 22 14.55 22 15.5C22 ' +
                '16.4833 21.6627 17.3127 20.988 17.988C20.3127 18.6627 19.4833 19 18.5 19H6.5Z' })));
};

const PDFIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "pdfIcon" }),
        React.createElement("path", { d: 'M8.65 12.375H9.425V10.375H10.65C10.8667 10.375 11.05 10.304 11.2 ' +
                '10.162C11.35 10.0207 11.425 9.84167 11.425 9.625V8.375C11.425 ' +
                '8.15833 11.35 7.979 11.2 7.837C11.05 7.69567 10.8667 7.625 ' +
                '10.65 7.625H8.65V12.375ZM9.425 9.625V8.375H10.65V9.625H9.425ZM12.45 ' +
                '12.375H14.375C14.6083 12.375 14.796 12.304 14.938 12.162C15.0793 ' +
                '12.0207 15.15 11.8417 15.15 11.625V8.375C15.15 8.15833 15.0793 ' +
                '7.979 14.938 7.837C14.796 7.69567 14.6083 7.625 14.375 ' +
                '7.625H12.45V12.375ZM13.225 11.625V8.375H14.375V11.625H13.225ZM16.375 ' +
                '12.375H17.15V10.375H18.55V9.625H17.15V8.375H18.55V7.625H16.375V12.375ZM8.125 ' +
                '17C7.65833 17 7.271 16.846 6.963 16.538C6.65433 16.2293 6.5 15.8417 6.5 ' +
                '15.375V4.625C6.5 4.15833 6.65433 3.77067 6.963 3.462C7.271 3.154 7.65833 ' +
                '3 8.125 3H18.875C19.3417 3 19.7293 3.154 20.038 3.462C20.346 3.77067 20.5 ' +
                '4.15833 20.5 4.625V15.375C20.5 15.8417 20.346 16.2293 20.038 16.538C19.7293 ' +
                '16.846 19.3417 17 18.875 17H8.125ZM8.125 16H18.875C19.0417 16 19.1873 15.9373 ' +
                '19.312 15.812C19.4373 15.6873 19.5 15.5417 19.5 15.375V4.625C19.5 4.45833 ' +
                '19.4373 4.31267 19.312 4.188C19.1873 4.06267 19.0417 4 18.875 4H8.125C7.95833 ' +
                '4 7.81267 4.06267 7.688 4.188C7.56267 4.31267 7.5 4.45833 7.5 4.625V15.375C7.5 ' +
                '15.5417 7.56267 15.6873 7.688 15.812C7.81267 15.9373 7.95833 16 8.125 16ZM5.125 ' +
                '20C4.65833 20 4.27067 19.846 3.962 19.538C3.654 19.2293 3.5 18.8417 3.5 ' +
                '18.375V6.625H4.5V18.375C4.5 18.5417 4.56267 18.6873 4.688 18.812C4.81267 ' +
                '18.9373 4.95833 19 5.125 19H16.875V20H5.125Z' })));
};

const SortAscendingIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'sortAscendingIcon' }),
        React.createElement("path", { d: 'M11.5001 17.3077V7.4154L7.40008 11.5154L6.69238 10.8077L12.0001 5.5L17.3078 ' +
                '10.8077L16.6001 11.5154L12.5001 7.4154V17.3077H11.5001Z' })));
};

const SortDescendingIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'sortDescendingIcon' }),
        React.createElement("path", { d: 'M12.0001 17.3077L6.69238 12L7.40008 11.2923L11.5001 ' +
                '15.3923V5.5H12.5001V15.3923L16.6001 11.2923L17.3078 12L12.0001 17.3077Z' })));
};

const HomeIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'HomeIcon' }),
    React.createElement("path", { d: 'M5.14286 19.8857H9.37143V13.1714H14.6286V19.8857H18.8571V9.60001L12 ' +
            '4.40001L5.14286 9.60001V19.8857ZM4 ' +
            '21.0286V9.02858L12 2.97144L20 9.02858V21.0286H13.4857V14.3143H10.5143V21.0286H4Z' })));

const MailIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'mailIcon' }),
        React.createElement("path", { d: 'M4.625 19C4.15833 19 3.771 18.846 3.463 18.538C3.15433 18.2293 3 ' +
                '17.8417 3 17.375V6.625C3 6.15833 3.15433 5.771 3.463 5.463C3.771 ' +
                '5.15433 4.15833 5 4.625 5H19.375C19.8417 5 20.2293 5.15433 20.538 ' +
                '5.463C20.846 5.771 21 6.15833 21 6.625V17.375C21 17.8417 20.846 ' +
                '18.2293 20.538 18.538C20.2293 18.846 19.8417 19 19.375 19H4.625ZM12 ' +
                '12.125L4 6.875V17.375C4 17.5583 4.05833 17.7083 4.175 17.825C4.29167 ' +
                '17.9417 4.44167 18 4.625 18H19.375C19.5583 18 19.7083 17.9417 19.825 ' +
                '17.825C19.9417 17.7083 20 17.5583 20 17.375V6.875L12 12.125ZM12 11L19.7 ' +
                '6H4.3L12 11ZM4 6.875V6V17.375C4 17.5583 4.05833 17.7083 4.175 ' +
                '17.825C4.29167 17.9417 4.44167 18 4.625 18H4V17.375V6.875Z' })));
};

const PhoneIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'phoneIcon' }),
        React.createElement("path", { d: 'M18.9 19.875C17.1667 19.875 15.4127 19.4333 13.638 ' +
                '18.55C11.8627 17.6667 10.2667 16.5127 8.84999 15.088C7.43332 ' +
                '13.6627 6.27932 12.0667 5.38799 10.3C4.49599 8.53333 ' +
                '4.04999 6.78333 4.04999 5.05C4.04999 4.75 4.14999 4.5 ' +
                '4.34999 4.3C4.54999 4.1 4.79999 4 5.09999 4H7.54999C7.84999 ' +
                '4 8.09999 4.08333 8.29999 4.25C8.49999 4.41667 8.62499 ' +
                '4.64167 8.67499 4.925L9.17499 7.3C9.22499 7.56667 ' +
                '9.22099 7.804 9.16299 8.012C9.10432 8.22067 8.99165 ' +
                '8.4 8.82499 8.55L6.64999 10.6C7.53332 12.0833 8.53765 ' +
                '13.379 9.66299 14.487C10.7877 15.5957 12.1 16.575 ' +
                '13.6 17.425L15.725 15.225C15.8917 15.0583 16.0793 ' +
                '14.9417 16.288 14.875C16.496 14.8083 16.7167 14.8 ' +
                '16.95 14.85L19.05 15.275C19.3167 15.3417 19.5333 ' +
                '15.475 19.7 15.675C19.8667 15.875 19.95 16.1167 ' +
                '19.95 16.4V18.825C19.95 19.125 19.85 19.375 19.65 ' +
                '19.575C19.45 19.775 19.2 19.875 18.9 19.875ZM6.14999 ' +
                '9.65L8.07499 7.9C8.14165 7.83333 8.18332 7.75833 ' +
                '8.19999 7.675C8.21665 7.59167 8.21665 7.50833 ' +
                '8.19999 7.425L7.74999 5.3C7.71665 5.2 7.67099 ' +
                '5.125 7.61299 5.075C7.55432 5.025 7.47499 5 ' +
                '7.37499 5H5.32499C5.24165 5 5.17499 5.025 5.12499 ' +
                '5.075C5.07499 5.125 5.04999 5.19167 5.04999 ' +
                '5.275C5.06665 5.95833 5.17099 6.67067 5.36299' +
                ' 7.412C5.55432 8.154 5.81665 8.9 6.14999 9.65ZM14.525 ' +
                '17.875C15.2083 18.2083 15.9333 18.4543 16.7 ' +
                '18.613C17.4667 18.771 18.1333 18.8583 18.7 ' +
                '18.875C18.7667 18.875 18.825 18.85 18.875 ' +
                '18.8C18.925 18.75 18.95 18.6833 18.95 18.6V16.6C18.95 ' +
                '16.5 18.925 16.4167 18.875 16.35C18.825 16.2833 18.75 ' +
                '16.2333 18.65 16.2L16.8 15.825C16.7333 15.8083 16.671 ' +
                '15.8083 16.613 15.825C16.5543 15.8417 16.4917 15.8833 ' +
                '16.425 15.95L14.525 17.875Z' })));
};

const HeartIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: 'M12.6088 6.99543C14.2009 5.37207 16.7296 5.0911 18.4466 ' +
            '6.55837C20.4134 8.24417 20.507 11.2412 18.7588 13.0518L12.7024 ' +
            '19.2955C12.3278 19.7014 11.6722 19.7014 11.2976 19.2955L5.24119 ' +
            '13.0518C3.49295 11.2412 3.58661 8.24417 5.55338 6.55837C7.27039 ' +
            '5.0911 9.83031 5.37207 11.3912 6.99543L12.0156 7.6198L12.6088 ' +
            '6.99543ZM12.685 11.9161H14.7401C14.9827 11.9161 15.1968 12.1302 ' +
            '15.1968 12.3728V12.8294C15.1968 13.0863 14.9827 13.2861 14.7401 ' +
            '13.2861H12.685V15.3412C12.685 15.5981 12.471 15.7979 12.2283 ' +
            '15.7979H11.7717C11.5148 15.7979 11.315 15.5981 11.315 ' +
            '15.3412V13.2861H9.25991C9.00302 13.2861 8.80322 13.0863 ' +
            '8.80322 12.8294V12.3728C8.80322 12.1302 9.00302 11.9161 ' +
            '9.25991 11.9161H11.315V9.86101C11.315 9.6184 11.5148 ' +
            '9.40433 11.7717 9.40433H12.2283C12.471 9.40433 12.685 ' +
            '9.6184 12.685 9.86101V11.9161Z' })));

const ContainsIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M2.93555 19.013V15.513H3.93555V18.013H21.9355V15.513H22.9355V19.013H2.93555ZM10.7932 ' +
            '15.9688V14.9649H10.699C10.4695 15.3752 10.1746 15.6826 9.8144 15.8871C9.45413 ' +
            '16.0915 9.03426 16.1938 8.55477 16.1938C7.84067 16.1938 7.27272 16.0005 6.85092 ' +
            '15.614C6.42914 15.2274 6.21825 14.706 6.21825 14.0495C6.21825 13.3495 6.46664 ' +
            '12.7819 6.96342 12.3467C7.46022 11.9114 8.10798 11.6938 8.9067 11.6938C9.25156 ' +
            '11.6938 9.58971 11.7294 9.92112 11.8005C10.2525 11.8717 10.5413 11.9739 10.7875 ' +
            '12.1072V11.5649C10.7875 10.9226 10.6301 10.4361 10.3153 10.1053C10.0006 9.77455 ' +
            '9.53811 9.60916 8.92785 9.60916C8.57785 9.60916 8.25189 9.66814 7.94997 ' +
            '9.78609C7.64804 9.90404 7.35028 10.0854 7.0567 10.3303L6.44325 9.78031C6.79836 ' +
            '9.4457 7.17272 9.20019 7.56632 9.04379C7.95991 8.88737 8.40926 8.80916 8.9144 ' +
            '8.80916C9.84516 8.80916 10.5375 9.04859 10.9913 9.52744C11.4452 10.0063 11.6721 ' +
            '10.7188 11.6721 11.6649V15.9688H10.7932ZM9.06632 12.4649C8.46889 12.4649 7.99645 ' +
            '12.6044 7.649 12.8832C7.30156 13.162 7.12785 13.5444 7.12785 14.0303C7.12785 ' +
            '14.4534 7.26246 14.7883 7.5317 15.0351C7.80093 15.2819 8.15478 15.4053 8.59325 ' +
            '15.4053C9.22913 15.4053 9.75381 15.1665 10.1673 14.689C10.5807 14.2114 10.7875 ' +
            '13.6098 10.7875 12.8842C10.567 12.7508 10.3003 12.6476 9.98747 12.5746C9.67466 ' +
            '12.5015 9.36761 12.4649 9.06632 ' +
            '12.4649ZM13.7875 15.988V5.96301H14.6836V9.30724L14.6086 ' +
            '10.3072H14.6644C14.8682 9.99314 15.1548 9.72295 15.524 ' +
            '9.49666C15.8932 9.27038 16.3439 9.15724 16.8759 9.15724C17.7503 9.15724 ' +
            '18.4509 9.48288 18.9779 10.1342C19.5048 10.7854 19.7682 11.6495 19.7682 ' +
            '12.7265C19.7682 13.7777 19.509 14.6217 18.9904 15.2582C18.4718 15.8947 ' +
            '17.7605 16.213 16.8567 16.213C16.3272 16.213 15.8737 16.1015 15.4961 ' +
            '15.8784C15.1186 15.6553 14.8413 15.3835 14.6644 ' +
            '15.063H14.6086V15.988H13.7875ZM16.7855 10.038C16.1445 10.038 15.6215 10.2967 ' +
            '15.2163 10.814C14.8112 11.3313 14.6086 11.9669 14.6086 12.7207C14.6086 13.4784 ' +
            '14.8112 14.1117 15.2163 14.6207C15.6215 15.1297 16.1445 15.3842 16.7855 ' +
            '15.3842C17.4266 15.3842 17.9282 15.1393 18.2903 14.6495C18.6525 14.1598 ' +
            '18.8336 13.5169 18.8336 12.7207C18.8336 11.9245 18.6525 11.2784 18.2903 ' +
            '10.7822C17.9282 10.2861 17.4266 10.038 16.7855 10.038Z' })));

const BetweenIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M18.9355 7.5L19.9355 7.5V16.5H18.9355V7.5ZM5.93555 7.5H6.93555L6.93555 16.5H5.93555L5.93555 ' +
            '7.5ZM6.43555 11.1H19.3025V12.9H6.43555L6.43555 11.1Z' })));

const DoesNotContainIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M2.93555 14.9111V13.9111H3.93555H21.9355H22.9355V14.9111H2.93555ZM10.7932 ' +
            '17.8669V16.863H10.699C10.4695 17.2733 10.1746 17.5806 9.8144 17.7851C9.45413 ' +
            '17.9896 9.03426 18.0919 8.55477 18.0919C7.84067 18.0919 7.27272 17.8986 ' +
            '6.85092 17.512C6.42914 17.1255 6.21825 16.604 6.21825 15.9476C6.21825 ' +
            '15.2476 6.46664 14.68 6.96342 14.2447C7.46022 13.8095 8.10798 13.5919 ' +
            '8.9067 13.5919C9.25156 13.5919 9.58971 13.6274 9.92112 13.6986C10.2525 ' +
            '13.7697 10.5413 13.872 10.7875 14.0053V13.463C10.7875 12.8207 10.6301 ' +
            '12.3342 10.3153 12.0034C10.0006 11.6726 9.53811 11.5072 8.92785 ' +
            '11.5072C8.57785 11.5072 8.25189 11.5662 7.94997 11.6842C7.64804 ' +
            '11.8021 7.35028 11.9835 7.0567 12.2284L6.44325 11.6784C6.79836 ' +
            '11.3438 7.17272 11.0983 7.56632 10.9419C7.95991 10.7854 8.40926 ' +
            '10.7072 8.9144 10.7072C9.84516 10.7072 10.5375 10.9467 10.9913 ' +
            '11.4255C11.4452 11.9044 11.6721 12.6169 11.6721 13.563V17.8669H10.7932ZM9.06632 ' +
            '14.363C8.46889 14.363 7.99645 14.5024 7.649 14.7813C7.30156 15.0601 7.12785 ' +
            '15.4425 7.12785 15.9284C7.12785 16.3515 7.26246 16.6864 7.5317 16.9332C7.80093 ' +
            '17.18 8.15478 17.3034 8.59325 17.3034C9.22913 17.3034 9.75381 17.0646 ' +
            '10.1673 16.587C10.5807 16.1095 10.7875 15.5079 10.7875 14.7822C10.567 ' +
            '14.6489 10.3003 14.5457 9.98747 14.4726C9.67466 14.3995 9.36761 14.363 ' +
            '9.06632 14.363ZM13.7875 17.8861V7.86108H14.6836V11.2053L14.6086 ' +
            '12.2053H14.6644C14.8682 11.8912 15.1548 11.621 15.524 11.3947C15.8932 ' +
            '11.1685 16.3439 11.0553 16.8759 11.0553C17.7503 11.0553 18.4509 11.381 ' +
            '18.9779 12.0322C19.5048 12.6835 19.7682 13.5476 19.7682 14.6245C19.7682 ' +
            '15.6758 19.509 16.5197 18.9904 17.1563C18.4718 17.7928 17.7605 18.1111 ' +
            '16.8567 18.1111C16.3272 18.1111 15.8737 17.9995 15.4961 17.7765C15.1186 ' +
            '17.5534 14.8413 17.2816 14.6644 16.9611H14.6086V17.8861H13.7875ZM16.7855 ' +
            '11.9361C16.1445 11.9361 15.6215 12.1947 15.2163 12.712C14.8112 13.2294 ' +
            '14.6086 13.8649 14.6086 14.6188C14.6086 15.3765 14.8112 16.0098 15.2163 ' +
            '16.5188C15.6215 17.0278 16.1445 17.2822 16.7855 17.2822C17.4266 17.2822 ' +
            '17.9282 17.0374 18.2903 16.5476C18.6525 16.0579 18.8336 15.4149 18.8336 ' +
            '14.6188C18.8336 13.8226 18.6525 13.1765 18.2903 12.6803C17.9282 12.1842 ' +
            '17.4266 11.9361 16.7855 11.9361Z' })));

const DoesNotEqualIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M19.8843 21.7761L15.7074 17.5992L15.0862 16.978H5.43555V14.978H13.0862L9.08626 ' +
            '10.978H5.43555V8.97803H7.08626L3.79199 5.68375L4.49969 4.97607L5.20329 ' +
            '5.67967L5.19922 5.68375L16.3954 16.8799L17.1146 17.5992L20.5879 21.0725L19.8843' +
            ' 21.7761ZM17.9089 16.978H20.4355V14.978H15.9089L17.9089 16.978ZM11.9089 ' +
            '10.978H20.4355V8.97803H9.90887L11.9089 10.978Z' })));

const EndsWithIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M2.93555 19.007V18.007H3.93555H21.9355V15.507H22.9355V19.007H2.93555ZM10.7932 ' +
            '15.9628V14.959H10.699C10.4695 15.3692 10.1746 15.6766 9.8144 15.8811C9.45413 ' +
            '16.0856 9.03426 16.1878 8.55477 16.1878C7.84067 16.1878 7.27272 15.9945 6.85092 ' +
            '15.608C6.42914 15.2214 6.21825 14.7 6.21825 14.0436C6.21825 13.3436 6.46664 ' +
            '12.7759 6.96342 12.3407C7.46022 11.9054 8.10798 11.6878 8.9067 11.6878C9.25156 ' +
            '11.6878 9.58971 11.7234 9.92112 11.7945C10.2525 11.8657 10.5413 11.9679 10.7875 ' +
            '12.1013V11.559C10.7875 10.9167 10.6301 10.4301 10.3153 10.0993C10.0006 9.76856 ' +
            '9.53811 9.60318 8.92785 9.60318C8.57785 9.60318 8.25189 9.66216 7.94997 ' +
            '9.78011C7.64804 9.89806 7.35028 10.0795 7.0567 10.3243L6.44325 9.77433C6.79836 ' +
            '9.43971 7.17272 9.19421 7.56632 9.03781C7.95991 8.88139 8.40926 8.80318 8.9144 ' +
            '8.80318C9.84516 8.80318 10.5375 9.04261 10.9913 9.52146C11.4452 10.0003 11.6721 ' +
            '10.7128 11.6721 11.659V15.9628H10.7932ZM9.06632 12.459C8.46889 12.459 7.99645 ' +
            '12.5984 7.649 12.8772C7.30156 13.1561 7.12785 13.5384 7.12785 14.0243C7.12785 ' +
            '14.4474 7.26246 14.7824 7.5317 15.0292C7.80093 15.2759 8.15478 15.3993 8.59325 ' +
            '15.3993C9.22913 15.3993 9.75381 15.1605 10.1673 14.683C10.5807 14.2054 10.7875 ' +
            '13.6038 10.7875 12.8782C10.567 12.7448 10.3003 12.6416 9.98747 12.5686C9.67466 ' +
            '12.4955 9.36761 12.459 9.06632 12.459ZM13.7875 15.982V5.95703H14.6836V9.30126L14.6086 ' +
            '10.3013H14.6644C14.8682 9.98716 15.1548 9.71696 15.524 9.49068C15.8932 9.2644 ' +
            '16.3439 9.15126 16.8759 9.15126C17.7503 9.15126 18.4509 9.4769 18.9779 ' +
            '10.1282C19.5048 10.7795 19.7682 11.6436 19.7682 12.7205C19.7682 13.7718 ' +
            '19.509 14.6157 18.9904 15.2522C18.4718 15.8888 17.7605 16.207 16.8567 ' +
            '16.207C16.3272 16.207 15.8737 16.0955 15.4961 15.8724C15.1186 15.6493 ' +
            '14.8413 15.3775 14.6644 15.057H14.6086V15.982H13.7875ZM16.7855 10.032C16.1445 ' +
            '10.032 15.6215 10.2907 15.2163 10.808C14.8112 11.3253 14.6086 11.9609 14.6086 ' +
            '12.7147C14.6086 13.4724 14.8112 14.1057 15.2163 14.6147C15.6215 15.1237 16.1445 ' +
            '15.3782 16.7855 15.3782C17.4266 15.3782 17.9282 15.1333 18.2903 14.6436C18.6525 ' +
            '14.1538 18.8336 13.5109 18.8336 12.7147C18.8336 ' +
            '11.9186 18.6525 11.2724 18.2903 10.7763C17.9282 10.2801 17.4266 10.032 16.7855 10.032Z' })));

const EqualsIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M5.43555 16.98V14.98H20.4355V16.98H5.43555ZM5.43555 10.98V8.97998H20.4355V10.98H5.43555Z' })));

const GreaterThanIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M7.93555 16.8685L9.02171 17.9547L17.9355 12.8781L9.02171 ' +
            '7.80151L7.93555 8.88768L14.9955 12.8781L7.93555 16.8685Z' })));

const GreaterThanOrEqualToIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M7.93555 14.8181L9.02171 15.9043L17.9355 10.8277L9.02171 5.7511L7.93555 ' +
            '6.83726L14.9955 10.8277L7.93555 14.8181Z' }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M7.93555 18.249H17.9355V16.9044L7.93555 16.9044V18.249Z' })));

const LessThanIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M17.9355 16.8075L16.8494 17.8936L7.93555 12.8171L16.8494 7.74048L17.9355 8.82664L10.8756 ' +
            '12.8171L17.9355 16.8075Z' })));

const LessThanOrEqualToIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M17.9355 15.7573L16.8494 16.8435L7.93555 11.7669L16.8494 6.69031L17.9355 7.77647L10.8756 ' +
            '11.7669L17.9355 15.7573Z' }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M17.9355 19.1882H7.93555V17.8436L17.9355 17.8436V19.1882Z' })));

const BoltIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { viewBox: '0 -960 960 960', "data-testid": 'boltIcon' }),
    React.createElement("path", { d: 'm422-232 207-248H469l29-227-185 267h139l-30 208Zm-15.846-168H286.769q-16.308 ' +
            '0-23.577-14.192-7.269-14.192 2.115-27.269l225.155-326.155q6.153-8.615 15.23-11.423 ' +
            '9.077-2.808 19.154.885 10.077 3.692 14.616 12.154 4.538 8.461 3.308 ' +
            '18.538L514.616-520h143.461q16.77 0 23.808 15.307 7.039 15.308-3.808 ' +
            '28.385L427.538-176.153q-6.384 7.615-15.461 ' +
            '9.692t-17.923-1.846q-8.847-3.923-13.5-11.885-4.654-7.961-3.424-18.038L406.154-400ZM471-470Z' })));

const CameraIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M19.0675 7.50056H17.8723L17.2041 6.1995V6.16406C16.7823 5.56612 16.2901 5.25 15.7625 5.25H12.0009C11.4733 5.25 10.9463 5.56669 10.5593 6.16406L9.57506 7.5H7.50075V7.113C7.50075 6.51506 6.9383 5.988 6.34042 5.988H5.63736C5.03948 5.988 4.51247 6.51563 4.51247 7.113V7.53487C3.28183 7.64062 3.00061 8.48438 3.00061 9.15206V16.9567C3.00061 18.0817 3.70367 18.75 4.9343 18.75H19.0658C20.2964 18.75 20.9995 18.0817 20.9995 16.9567V9.15206C20.9995 8.4135 20.6828 7.49944 19.0658 7.49944L19.0675 7.50056ZM5.63905 6.76256H6.34211C6.55303 6.76256 6.76395 6.93862 6.76395 7.11413V7.50113H5.25209L5.28752 7.11413C5.28752 6.93806 5.46357 6.76256 5.63905 6.76256ZM19.0675 18.0126C19.8757 18.0126 20.2627 17.6964 20.2627 16.9579L20.2632 9.15263C20.2632 8.69587 20.1581 8.23856 19.068 8.23856H17.3807L16.537 6.55106C16.3964 6.34013 16.1152 5.98856 15.7637 5.98856H12.002C11.6505 5.98856 11.3338 6.37556 11.1932 6.5865L9.92771 8.23913H4.86569C3.95171 8.23913 3.74079 8.62556 3.74079 9.15319V16.9579C3.74079 17.6959 4.12719 18.0126 4.93599 18.0126H19.0675ZM13.8648 8.23913C11.4041 8.23913 9.36526 10.2782 9.36526 12.7391C9.36526 15.2355 11.4041 17.2391 13.8648 17.2391C16.361 17.2391 18.3644 15.2349 18.3644 12.7391C18.3644 10.2782 16.3604 8.23913 13.8648 8.23913ZM10.1386 12.7386C10.1386 14.8131 11.826 16.5006 13.8648 16.5006C15.9391 16.5006 17.6265 14.8131 17.6265 12.7386C17.6265 10.6995 15.9391 9.012 13.8648 9.012C11.826 9.012 10.1386 10.6995 10.1386 12.7386ZM13.8648 10.1376C12.4233 10.1376 11.2635 11.298 11.2635 12.7391C11.2635 14.2157 12.4239 15.3761 13.8648 15.3761C15.3413 15.3761 16.5016 14.2157 16.5016 12.7391C16.5016 11.2974 15.3413 10.1376 13.8648 10.1376ZM12.0015 12.7391C12.0015 13.7938 12.8451 14.6376 13.8648 14.6376C14.9194 14.6376 15.7631 13.7938 15.7631 12.7391C15.7631 11.7193 14.9194 10.8756 13.8648 10.8756C12.8451 10.8756 12.0015 11.7193 12.0015 12.7391ZM5.99058 9.01256C5.18178 9.01256 4.51416 9.68081 4.51416 10.4891C4.51416 11.3329 5.18234 12.0011 5.99058 12.0011C6.83425 12.0011 7.50244 11.3329 7.50244 10.4891C7.50244 9.68025 6.83425 9.01256 5.99058 9.01256ZM5.25209 10.4891C5.25209 10.911 5.60362 11.2626 5.99058 11.2626C6.41242 11.2626 6.76395 10.911 6.76395 10.4891C6.76395 10.1021 6.41242 9.75056 5.99058 9.75056C5.60362 9.75056 5.25209 10.1021 5.25209 10.4891Z' // eslint-disable-line max-len
     })));

const TrashIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'trashIcon' }),
    React.createElement("path", { d: 'M7.80019 19.6475C7.35276 19.6475 6.97166 19.4902 6.65691 19.1754C6.34218 ' +
            '18.8607 6.18481 18.4796 6.18481 ' +
            '18.0322V5.64755H5.18481V4.64755H9.18481V3.8783H15.1848V4.64755H19.1848V5.64755H18.' +
            '1848V18.0322C18.1848 18.4924 18.0306 18.8767 17.7223 19.185C17.414 19.4934 17.0297 ' +
            '19.6475 16.5694 19.6475H7.80019ZM17.1848 5.64755H7.18481V18.0322C7.18481 18.2117 ' +
            '7.24251 18.3591 7.35789 18.4745C7.47327 18.5899 7.62071 18.6475 7.80019 ' +
            '18.6475H16.5694C16.7233 18.6475 16.8643 18.5834 16.9925 18.4552C17.1207 ' +
            '18.327 17.1848 18.186 17.1848 18.0322V5.64755ZM9.99249 ' +
            '16.6475H10.9925V7.64755H9.99249V16.6475ZM13.3771 16.6475H14.3771V7.64755H13.3771V16.6475Z' })));

const AddIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "AddIcon" }),
    React.createElement("path", { d: 'M11.5 18.5V12.5H5.5V11.5H11.5V5.5H12.5V11.5H18.5V12.5H12.5V18.5H11.5Z' })));

const DriveIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'garageIcon' }),
    React.createElement("path", { d: 'M4.61538 21.4565C4.15513 21.4565 3.77083 21.299 3.4625 20.984C3.15417 20.6689 ' +
            '3 20.2763 3 19.806V4.71571C3 4.24545 3.15417 3.85281 3.4625 3.53777C3.77083 ' +
            '3.22273 4.15513 3.06522 4.61538 3.06522H19.3846C19.8449 3.06522 20.2292 ' +
            '3.22273 20.5375 3.53777C20.8458 3.85281 21 4.24545 21 4.71571V19.806C21 ' +
            '20.2763 20.8458 20.6689 20.5375 20.984C20.2292 21.299 19.8449 21.4565 ' +
            '19.3846 21.4565H4.61538ZM4.61538 20.4348H19.3846C19.5385 20.4348 ' +
            '19.6795 20.3693 19.8077 20.2383C19.9359 20.1073 20 19.9632 20 ' +
            '19.806V4.71571C20 4.55853 19.9359 4.41444 19.8077 4.28344C19.6795 ' +
            '4.15245 19.5385 4.08696 19.3846 4.08696H4.61538C4.46154 4.08696 ' +
            '4.32052 4.15245 4.1923 4.28344C4.0641 4.41444 4 4.55853 4 4.71571V19.806C4 ' +
            '19.9632 4.0641 20.1073 4.1923 20.2383C4.32052 20.3693 4.46154 20.4348 ' +
            '4.61538 20.4348ZM8.61538 14.0686C8.40898 14.0686 8.22917 13.9903 ' +
            '8.07597 13.8338C7.92276 13.6772 7.84615 13.4935 7.84615 13.2826C7.84615 ' +
            '13.0717 7.92276 12.888 8.07597 12.7315C8.22917 12.5749 8.40898 12.4967 ' +
            '8.61538 12.4967C8.82179 12.4967 9.0016 12.5749 9.1548 12.7315C9.30802 ' +
            '12.888 9.38463 13.0717 9.38463 13.2826C9.38463 13.4935 9.30802 13.6772 ' +
            '9.1548 13.8338C9.0016 13.9903 8.82179 14.0686 8.61538 14.0686ZM15.3846 ' +
            '14.0686C15.1782 14.0686 14.9984 13.9903 14.8452 13.8338C14.692 13.6772 ' +
            '14.6154 13.4935 14.6154 13.2826C14.6154 13.0717 14.692 12.888 14.8452 ' +
            '12.7315C14.9984 12.5749 15.1782 12.4967 15.3846 12.4967C15.591 12.4967 ' +
            '15.7708 12.5749 15.924 12.7315C16.0772 12.888 16.1538 13.0717 16.1538 ' +
            '13.2826C16.1538 13.4935 16.0772 13.6772 15.924 13.8338C15.7708 13.9903 ' +
            '15.591 14.0686 15.3846 14.0686ZM6 11.4985V17.4167C6 17.5503 6.04295 ' +
            '17.661 6.12885 17.7488C6.21473 17.8365 6.32307 17.8804 6.45385 ' +
            '17.8804H6.54615C6.67692 17.8804 6.78525 17.8365 6.87115 17.7488C6.95705 ' +
            '17.661 7 17.5503 7 17.4167V15.837H17V17.4167C17 17.5503 17.0429 17.661 ' +
            '17.1288 17.7488C17.2147 17.8365 17.3231 17.8804 17.4538 ' +
            '17.8804H17.5462C17.6769 17.8804 17.7853 17.8365 17.8712 17.7488C17.9571 ' +
            '17.661 18 17.5503 18 17.4167V11.4985L16.5038 7.10502C16.459 6.9583 ' +
            '16.3792 6.84433 16.2644 6.76312C16.1497 6.68191 16.0205 6.6413 15.8769 ' +
            '6.6413H8.12308C7.97949 6.6413 7.85033 6.68191 7.73558 6.76312C7.62083 ' +
            '6.84433 7.54102 6.9583 7.49615 7.10502L6 11.4985ZM7.30385 10.7283L8.35 ' +
            '7.66304H15.65L16.6962 10.7283H7.30385ZM7 14.8152V11.75H17V14.8152H7Z' })));

const MedicalServicesIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'medicalServicesIcon' }),
    React.createElement("path", { d: 'M11.5 17.5H12.5V14.5H15.5V13.5H12.5V10.5H11.5V13.5H8.5V14.5H11' +
            '.5V17.5ZM4.61538 21C4.15513 21 3.77083 20.8458 3.4625 20.5375C3.' +
            '15417 20.2292 3 19.8449 3 19.3846V8.61538C3 8.15513 3.15417 ' +
            '7.77083 3.4625 7.4625C3.77083 7.15417 4.15513 7 4.61538 7H9V5.61537C9 ' +
            '5.15512 9.15417 4.77083 9.4625 4.4625C9.77083 4.15417 10.1551 4 ' +
            '10.6154 4H13.3846C13.8449 4 14.2292 4.15417 14.5375 4.4625C14.8458 ' +
            '4.77083 15 5.15512 15 5.61537V7H19.3846C19.8449 7 20.2292 7.15417 ' +
            '20.5375 7.4625C20.8458 7.77083 21 8.15513 21 8.61538V19.3846C21 ' +
            '19.8449 20.8458 20.2292 20.5375 20.5375C20.2292 20.8458 19.8449 ' +
            '21 19.3846 21H4.61538ZM4.61538 20H19.3846C19.5385 20 19.6795 ' +
            '19.9359 19.8077 19.8077C19.9359 19.6795 20 19.5385 20 19.3846V8.61538C20 ' +
            '8.46154 19.9359 8.32052 19.8077 8.1923C19.6795 8.0641 19.5385 8 19.3846 ' +
            '8H4.61538C4.46154 8 4.32052 8.0641 4.1923 8.1923C4.0641 8.32052 4 ' +
            '8.46154 4 8.61538V19.3846C4 19.5385 4.0641 19.6795 4.1923 19.8077C4.32052 ' +
            '19.9359 4.46154 20 4.61538 20ZM10 7H14V5.61537C14 5.46152 13.9359 5.3205 ' +
            '13.8077 5.1923C13.6795 5.0641 13.5385 5 13.3846 5H10.6154C10.4615 5 ' +
            '10.3205 5.0641 10.1923 5.1923C10.0641 5.3205 10 5.46152 10 5.61537V7Z' })));

const GarageIcon = (props) => (React.createElement(SvgIcon$2, Object.assign({}, props, { "data-testid": 'garageIcon' }),
    React.createElement("path", { d: 'M5 20V9.50002L12 4.21155L19 9.50002V20H18V10L12 5.46157L6 10V20H5ZM8.5 ' +
            '18.9808H15.5V15.9808H8.5V18.9808ZM8.5 14.9808H15.5V11.9808H8.5V14.9808ZM7.5 ' +
            '19.9808V10.9808H16.5V19.9808H7.5Z' })));

const AssignmentIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'assignmentIcon' }),
        React.createElement("path", { d: 'M5.625 21C5.175 21 4.79167 20.8417 4.475 20.525C4.15833 20.2083 4 19.825 4 ' +
                '19.375V6.625C4 6.175 4.15833 5.79167 4.475 5.475C4.79167 5.15833 5.175 5 5.625 ' +
                '5H10.325C10.225 4.48333 10.3417 4.02067 10.675 3.612C11.0083 3.204 11.45 3 ' +
                '12 3C12.55 3 12.996 3.204 13.338 3.612C13.6793 4.02067 13.7917 4.48333 ' +
                '13.675 5H18.375C18.825 5 19.2083 5.15833 19.525 5.475C19.8417 5.79167 ' +
                '20 6.175 20 6.625V19.375C20 19.825 19.8417 20.2083 19.525 20.525C19.2083 ' +
                '20.8417 18.825 21 18.375 21H5.625ZM5.625 20H18.375C18.5417 20 18.6873 ' +
                '19.9373 18.812 19.812C18.9373 19.6873 19 19.5417 19 19.375V6.625C19 6.45833 ' +
                '18.9373 6.31267 18.812 6.188C18.6873 6.06267 18.5417 6 18.375 ' +
                '6H5.625C5.45833 6 5.31267 6.06267 5.188 6.188C5.06267 6.31267 ' +
                '5 6.45833 5 6.625V19.375C5 19.5417 5.06267 19.6873 5.188 19.812C5.31267 ' +
                '19.9373 5.45833 20 5.625 20ZM7.5 17.275H13.5V16.275H7.5V17.275ZM7.5 ' +
                '13.5H16.5V12.5H7.5V13.5ZM7.5 9.725H16.5V8.725H7.5V9.725ZM12 5.45C12.2167 ' +
                '5.45 12.396 5.379 12.538 5.237C12.6793 5.09567 12.75 4.91667 12.75 ' +
                '4.7C12.75 4.48333 12.6793 4.304 12.538 4.162C12.396 4.02067 12.2167 ' +
                '3.95 12 3.95C11.7833 3.95 11.6043 4.02067 11.463 4.162C11.321 4.304 ' +
                '11.25 4.48333 11.25 4.7C11.25 4.91667 11.321 5.09567 11.463 ' +
                '5.237C11.6043 5.379 11.7833 5.45 12 5.45Z' })));
};

const HeartPlusIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'heartPlusIcon' }),
    React.createElement("path", { d: 'M11 19.6538L9.84423 18.6115C8.32371 17.2204 7.05736 16.023 6.04518 ' +
            '15.0192C5.03301 14.0153 4.22852 13.1224 3.63172 12.3403C3.03492 ' +
            '11.5583 2.61378 10.8429 2.36828 10.1942C2.12276 9.54545 2 8.88904 ' +
            '2 8.22494C2 6.95314 2.43205 5.88615 3.29615 5.02396C4.16025 4.1618 ' +
            '5.2282 3.73071 6.5 3.73071C7.37948 3.73071 8.20448 3.95571 8.975 ' +
            '4.40571C9.74552 4.85571 10.4205 5.5102 11 6.36916C11.5795 5.5102 ' +
            '12.2545 4.85571 13.025 4.40571C13.7955 3.95571 14.6205 3.73071 ' +
            '15.5 3.73071C16.6577 3.73071 17.6404 4.09065 18.4481 4.81051C19.2558 ' +
            '5.53038 19.7494 6.42685 19.9289 7.49994H18.9C18.741 6.67942 18.3442 ' +
            '6.01275 17.7096 5.49994C17.075 4.98712 16.3385 4.73071 15.5 ' +
            '4.73071C14.6885 4.73071 13.9519 4.95988 13.2904 5.41821C12.6288 5.87655 ' +
            '11.9994 6.57045 11.4019 7.49994H10.5981C9.99166 6.55764 9.35608 5.86052 ' +
            '8.69135 5.40859C8.0266 4.95667 7.29615 4.73071 6.5 4.73071C5.52437 ' +
            '4.73071 4.69713 5.06308 4.01828 5.72781C3.33943 6.39256 3 7.22494 3 ' +
            '8.22494C3 8.78775 3.11667 9.35891 3.35 9.93841C3.58333 10.5179 4 ' +
            '11.1849 4.6 11.9394C5.2 12.6938 6.01667 13.5797 7.05 14.5971C8.08333 ' +
            '15.6144 9.4 16.8487 11 18.2999C11.5103 17.8397 12.0122 17.3852 12.5058 ' +
            '16.9365C12.9994 16.4878 13.4404 16.0775 13.8288 15.7057L14.5423 ' +
            '16.4192C14.15 16.791 13.7122 17.1939 13.2289 17.6278C12.7455 18.0618 ' +
            '12.2551 18.5089 11.7577 18.9692L11 19.6538ZM17.7308 ' +
            '16.4999V13.4999H14.7308V12.4999H17.7308V9.49994H18.7308V12.4999H21.7308V13.4999H18.' +
            '7308V16.4999H17.7308Z' })));

const HandyManIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'handyManIcon' }),
        React.createElement("path", { d: 'M18.4654 20.975C18.3577 20.975 18.2583 20.9574 18.1673 20.9221C18.0763 ' +
                '20.8868 17.9872 20.8256 17.9 20.7385L12.9154 15.7731C12.8282 15.6859 ' +
                '12.767 15.5968 12.7317 15.5058C12.6965 15.4147 12.6789 15.3154 12.6789 ' +
                '15.2077C12.6789 15.1 12.6965 15.0006 12.7317 14.9096C12.767 14.8186 12.8282 ' +
                '14.7295 12.9154 14.6423L14.5789 12.9788C14.666 12.8916 14.7551 12.8304 14.8462 ' +
                '12.7952C14.9372 12.7599 15.0365 12.7423 15.1442 12.7423C15.2519 12.7423 15.3513 ' +
                '12.7599 15.4423 12.7952C15.5333 12.8304 15.6224 12.8916 15.7096 12.9788L20.6942 ' +
                '17.9635C20.7814 18.0506 20.8426 18.1397 20.8779 18.2308C20.9132 18.3218 20.9308 ' +
                '18.4211 20.9308 18.5288C20.9308 18.6365 20.9132 18.7359 20.8779 18.8269C20.8426 ' +
                '18.9179 20.7814 19.007 20.6942 19.0942L19.0308 20.7385C18.9436 20.8256 18.8545 ' +
                '20.8868 18.7635 20.9221C18.6724 20.9574 18.5731 20.975 18.4654 20.975ZM18.4654 ' +
                '19.9269L19.8635 18.5288L15.15 13.8154L13.7519 15.2135L18.4654 19.9269ZM5.50963 ' +
                '20.9808C5.40193 20.9808 5.3016 20.9622 5.20865 20.925C5.1157 20.8878 5.02564 ' +
                '20.8256 4.93845 20.7385L3.28078 19.1C3.19359 19.0128 3.13141 18.9227 3.09423 ' +
                '18.8298C3.05704 18.7368 3.03845 18.6365 3.03845 18.5288C3.03845 18.4211 3.05704 ' +
                '18.3186 3.09423 18.2211C3.13141 18.1237 3.19359 18.0314 3.28078 17.9442L8.42693 ' +
                '12.7981H10.5135L11.2865 12.025L7.04615 7.78461H5.62115L3.09615 5.25961L5.22885 ' +
                '3.12691L7.75385 5.65191V7.07691L11.9942 11.3173L15.0096 8.30191L13.1654 ' +
                '6.45768L14.2962 5.32691H12.0289L11.6173 4.93461L14.4558 2.09613L14.8481 ' +
                '2.48843V4.77498L15.9789 3.64421L19.9519 7.57883C20.1968 7.81088 20.3782 ' +
                '8.07722 20.4962 8.37786C20.6141 8.67851 20.6731 8.99678 20.6731 ' +
                '9.33268C20.6731 9.57883 20.6365 9.81793 20.5635 10.05C20.4904 10.282 20.3827 ' +
                '10.5013 20.2404 10.7077L18.1923 8.65961L16.7731 10.0788L15.7039 9.00961L11.2019 ' +
                '13.5115V15.6308L6.075 20.7385C5.98782 20.8256 5.89872 20.8878 5.8077 ' +
                '20.925C5.71667 20.9622 5.61731 20.9808 5.50963 20.9808ZM5.50963 19.9077L10.4327 ' +
                '14.9846V13.5865H9.03463L4.11155 18.5096L5.50963 19.9077ZM5.50963 19.9077L4.11155 ' +
                '18.5096L4.81345 19.2058L5.50963 19.9077Z' })));
};

const InsuranceIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'insuranceIcon' }),
    React.createElement("path", { d: 'M12 20.9615C9.99102 20.3654 8.32211 19.1484 6.99327 17.3106C5.66442 15.4727 5 ' +
            '13.4025 5 11.1V5.69228L12 3.0769L19 5.69228V11.1C19 13.4025 18.3356 15.4727 ' +
            '17.0067 17.3106C15.6779 19.1484 14.009 20.3654 12 20.9615ZM12 8.89038L6.26538 ' +
            '13.3558C6.56923 14.6109 7.09038 15.7542 7.82885 16.7856C8.5673 17.817 9.45768 ' +
            '18.6308 10.5 19.2269V15.5H13.5V19.2269C14.5423 18.6308 15.4327 17.817 16.1712 ' +
            '16.7856C16.9096 15.7542 17.4308 14.6109 17.7346 13.3558L12 8.89038ZM12 4.1442L6 ' +
            '6.37498V11.1C6 11.2731 6.00737 11.4641 6.02212 11.6731C6.03686 11.882 6.05705 ' +
            '12.073 6.0827 12.2461L12 7.63458L17.9173 12.2461C17.943 12.073 17.9631 11.882 ' +
            '17.9779 11.6731C17.9926 11.4641 18 11.2731 18 11.1V6.37498L12 4.1442Z' })));

const ExpandMoreIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'expandMoreIcon' }),
    React.createElement("path", { d: 'M12 15.0125L6.70001 9.7125L7.40001 8.9875L12 13.5875L16.6 ' +
            '8.9875L17.3 9.7125L12 15.0125Z' })));

const ApplicationIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'applicationIcon' }),
    React.createElement("path", { d: 'M5.61538 21.3077C5.16794 21.3077 4.78685 21.1503 4.4721 20.8356C4.15737 20.5208' +
            ' 4 20.1397 4 19.6923V6.92303C4 6.4756 4.15737 6.09451 4.4721 5.77976C4.78685 ' +
            '5.46503 5.16794 5.30766 5.61538 5.30766H10.2519C10.3455 4.91663 10.5532 4.5881 ' +
            '10.875 4.32208C11.1968 4.05605 11.5718 3.92303 12 3.92303C12.4359 3.92303 ' +
            '12.8138 4.05605 13.1337 4.32208C13.4535 4.5881 13.6603 4.91663 13.7538 ' +
            '5.30766H18.3846C18.8321 5.30766 19.2132 5.46503 19.5279 5.77976C19.8426 ' +
            '6.09451 20 6.4756 20 6.92303V19.6923C20 20.1397 19.8426 20.5208 19.5279 ' +
            '20.8356C19.2132 21.1503 18.8321 21.3077 18.3846 21.3077H5.61538ZM5.61538 ' +
            '20.3077H18.3846C18.5385 20.3077 18.6795 20.2436 18.8077 20.1154C18.9359 ' +
            '19.9871 19 19.8461 19 19.6923V6.92303C19 6.7692 18.9359 6.62818 18.8077' +
            ' 6.49996C18.6795 6.37176 18.5385 6.30766 18.3846 ' +
            '6.30766H16V8.53843H8V6.30766H5.61538C5.46154 6.30766 5.32052 ' +
            '6.37176 5.1923 6.49996C5.0641 6.62818 5 6.7692 5 6.92303V19.6923C5 ' +
            '19.8461 5.0641 19.9871 5.1923 20.1154C5.32052 20.2436 5.46154 ' +
            '20.3077 5.61538 20.3077ZM12 6.53843C12.232 6.53843 12.4247 6.46183 ' +
            '12.5779 6.30861C12.7311 6.15541 12.8077 5.96278 12.8077 ' +
            '5.73073C12.8077 5.49868 12.7311 5.30606 12.5779 5.15286C12.4247' +
            ' 4.99964 12.232 4.92303 12 4.92303C11.768 4.92303 11.5753 4.99964 ' +
            '11.4221 5.15286C11.2689 5.30606 11.1923 5.49868 11.1923 5.73073C11.1923 5.96278 ' +
            '11.2689 6.15541 11.4221 6.30861C11.5753 6.46183 11.768 6.53843 12 6.53843Z' })));

const UserIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'userIcon' }),
    React.createElement("path", { d: 'M12 11.375C11.1667 11.375 10.4583 11.0833 9.875 10.5C9.29167 9.91667 9 9.20833 ' +
            '9 8.375C9 7.55833 9.29167 6.854 9.875 6.262C10.4583 5.67067 11.1667 5.375 ' +
            '12 5.375C12.8333 5.375 13.5417 5.67067 14.125 6.262C14.7083 6.854 15 ' +
            '7.55833 15 8.375C15 9.20833 14.7083 9.91667 14.125 10.5C13.5417 11.0833 ' +
            '12.8333 11.375 12 11.375ZM5 18.625V16.975C5 16.5583 5.121 16.1707 5.363 ' +
            '15.812C5.60433 15.454 5.925 15.175 6.325 14.975C7.275 14.525 8.221 ' +
            '14.1873 9.163 13.962C10.1043 13.7373 11.05 13.625 12 13.625C12.95 ' +
            '13.625 13.896 13.7373 14.838 13.962C15.7793 14.1873 16.725 14.525 ' +
            '17.675 14.975C18.075 15.175 18.396 15.454 18.638 15.812C18.8793 ' +
            '16.1707 19 16.5583 19 16.975V18.625H5ZM6 17.625H18V16.975C18 16.7417 ' +
            '17.9293 16.529 17.788 16.337C17.646 16.1457 17.45 15.9833 17.2 ' +
            '15.85C16.3667 15.45 15.5127 15.146 14.638 14.938C13.7627 14.7293 ' +
            '12.8833 14.625 12 14.625C11.1167 14.625 10.2377 14.7293 9.363 ' +
            '14.938C8.48767 15.146 7.63333 15.45 6.8 15.85C6.55 15.9833 6.35433 ' +
            '16.1457 6.213 16.337C6.071 16.529 6 16.7417 6 16.975V17.625ZM12 ' +
            '10.375C12.55 10.375 13.021 10.179 13.413 9.787C13.8043 9.39567 ' +
            '14 8.925 14 8.375C14 7.825 13.8043 7.35433 13.413 6.963C13.021 ' +
            '6.571 12.55 6.375 12 6.375C11.45 6.375 10.9793 6.571 10.588 ' +
            '6.963C10.196 7.35433 10 7.825 10 8.375C10 8.925 10.196 9.39567 ' +
            '10.588 9.787C10.9793 10.179 11.45 10.375 12 10.375Z' })));

const CalMoveInIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'calMoveInIcon' }),
    React.createElement("path", { d: 'M16.3 19.9625V18.9625H19.625C19.7917 18.9625 19.9373 18.8998 20.062 18.7745C20.1873 ' +
            '18.6498 20.25 18.5042 20.25 18.3375V9.5875H6.25V13.4625H5.25V5.5875C5.25 5.12084 ' +
            '5.40433 4.7335 5.713 4.4255C6.021 4.11684 6.40833 3.9625 6.875 ' +
            '3.9625H8.625V1.7375H9.7V3.9625H16.875V1.7375H17.875V3.9625H19.625C20.0917 ' +
            '3.9625 20.4793 4.11684 20.788 4.4255C21.096 4.7335 21.25 5.12084 21.25 ' +
            '5.5875V18.3375C21.25 18.8042 21.096 19.1918 20.788 19.5005C20.4793 ' +
            '19.8085 20.0917 19.9625 19.625 19.9625H16.3ZM9.25 22.2625L8.55 21.5625L11.625 ' +
            '18.4625H2.75V17.4625H11.625L8.55 14.3625L9.25 13.6625L13.55 17.9625L9.25 ' +
            '22.2625ZM6.25 8.5875H20.25V5.5875C20.25 5.42084 20.1873 5.27517 20.062 ' +
            '5.1505C19.9373 5.02517 19.7917 4.9625 19.625 4.9625H6.875C6.70833 4.9625 ' +
            '6.56267 5.02517 6.438 5.1505C6.31267 5.27517 6.25 5.42084 6.25 5.5875V8.5875Z' })));

const CalMoveOutIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'calMoveOutIcon' }),
    React.createElement("path", { d: 'M7.7 19.9625V18.9625H4.375C4.20833 18.9625 4.06267 18.8998 3.938 18.7745C3.81267 ' +
            '18.6498 3.75 18.5042 3.75 18.3375V9.5875H17.75V13.4625H18.75V5.5875C18.75 5.12084 ' +
            '18.5957 4.7335 18.287 4.4255C17.979 4.11684 17.5917 3.9625 17.125 ' +
            '3.9625H15.375V1.7375H14.3V3.9625H7.125V1.7375H6.125V3.9625H4.375C3.90833 ' +
            '3.9625 3.52067 4.11684 3.212 4.4255C2.904 4.7335 2.75 5.12084 2.75 ' +
            '5.5875V18.3375C2.75 18.8042 2.904 19.1918 3.212 19.5005C3.52067 ' +
            '19.8085 3.90833 19.9625 4.375 19.9625H7.7ZM14.75 22.2625L15.45 ' +
            '21.5625L12.375 18.4625H21.25V17.4625H12.375L15.45 14.3625L14.75 13.6625L10.45 ' +
            '17.9625L14.75 22.2625ZM17.75 8.5875H3.75V5.5875C3.75 5.42084 3.81267 5.27517 ' +
            '3.938 5.1505C4.06267 5.02517 4.20833 4.9625 4.375 4.9625H17.125C17.2917 ' +
            '4.9625 17.4373 5.02517 17.562 5.1505C17.6873 5.27517 17.75 5.42084 17.75 ' +
            '5.5875V8.5875Z' })));

const RenewIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'renewIcon' }),
    React.createElement("path", { d: 'M5.225 15.2C4.99167 14.7167 4.81267 14.2083 4.688 13.675C4.56267 ' +
            '13.1417 4.5 12.6 4.5 12.05C4.5 9.95 5.22933 8.16666 6.688 6.7C8.146 ' +
            '5.23333 9.91667 4.5 12 4.5H13.375L11.275 2.4L12 1.7L15.3 5L12 ' +
            '8.3L11.275 7.6L13.375 5.5H12C10.2 5.5 8.66667 6.13733 7.4 ' +
            '7.412C6.13333 8.68733 5.5 10.2333 5.5 12.05C5.5 12.45 5.54167 ' +
            '12.854 5.625 13.262C5.70833 13.6707 5.825 14.0667 5.975 ' +
            '14.45L5.225 15.2ZM12 22.3L8.7 19L12 15.7L12.725 16.4L10.625 ' +
            '18.5H12C13.8 18.5 15.3333 17.8623 16.6 16.587C17.8667 15.3123 ' +
            '18.5 13.7667 18.5 11.95C18.5 11.55 18.4583 11.146 18.375 10.738C18.2917 ' +
            '10.3293 18.175 9.93333 18.025 9.55L18.775 8.8C19.0083 9.28333 19.1873 ' +
            '9.79166 19.312 10.325C19.4373 10.8583 19.5 11.4 19.5 11.95C19.5 14.05 ' +
            '18.7707 15.8333 17.312 17.3C15.854 18.7667 14.0833 19.5 12 19.5H10.625L12.725 21.6L12 22.3Z' })));

const BalanceIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'balanceIcon' }),
    React.createElement("path", { d: 'M3 20.625V19.625H11.5V8.325C11.0333 8.24167 10.6167 8.02933 10.25 7.688C9.88333' +
            ' 7.346 9.65 6.90833 9.55 6.375H6.125L9 13.6C8.96667 14.2667 8.65833 14.8333 ' +
            '8.075 15.3C7.49167 15.7667 6.8 16 6 16C5.2 16 4.50833 15.7667 3.925 ' +
            '15.3C3.34167 14.8333 3.03333 14.2667 3 13.6L5.875 6.375H4V5.375H9.55C9.66667 ' +
            '4.825 9.95 4.354 10.4 3.962C10.85 3.57067 11.3833 3.375 12 3.375C12.6167 ' +
            '3.375 13.15 3.57067 13.6 3.962C14.05 4.354 14.3333 4.825 14.45 ' +
            '5.375H20V6.375H18.125L21 13.6C20.9667 14.2667 20.6583 14.8333 20.075 ' +
            '15.3C19.4917 15.7667 18.8 16 18 16C17.2 16 16.5083 15.7667 15.925 ' +
            '15.3C15.3417 14.8333 15.0333 14.2667 15 13.6L17.875 6.375H14.45C14.35 6.90833 ' +
            '14.1167 7.346 13.75 7.688C13.3833 8.02933 12.9667 8.24167 12.5 ' +
            '8.325V19.625H21V20.625H3ZM16 13.5H20L18 8.475L16 13.5ZM4 13.5H8L6 8.475L4 ' +
            '13.5ZM12 7.375C12.4167 7.375 12.7707 7.22933 13.062 6.938C13.354 6.646 ' +
            '13.5 6.29167 13.5 5.875C13.5 5.475 13.354 5.125 13.062 4.825C12.7707 ' +
            '4.525 12.4167 4.375 12 4.375C11.5833 4.375 11.2293 4.525 10.938 4.825C10.646 ' +
            '5.125 10.5 5.475 10.5 5.875C10.5 6.29167 10.646 6.646 10.938 6.938C11.2293 ' +
            '7.22933 11.5833 7.375 12 7.375Z' })));

const LateFeeIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'lateFeeIcon' }),
    React.createElement("path", { d: 'M12 17.5C12.1667 17.5 12.3127 17.4417 12.438 17.325C12.5627 17.2083 12.625 ' +
            '17.0583 12.625 16.875C12.625 16.7083 12.5627 16.5667 12.438 16.45C12.3127 ' +
            '16.3333 12.1667 16.275 12 16.275C11.8333 16.275 11.6873 16.3333 11.562 ' +
            '16.45C11.4373 16.5667 11.375 16.7083 11.375 16.875C11.375 17.0583 11.4373 ' +
            '17.2083 11.562 17.325C11.6873 17.4417 11.8333 17.5 12 17.5ZM11.5 ' +
            '14.55H12.5V8.45H11.5V14.55ZM5.625 21C5.175 21 4.79167 20.8417 4.475 20.525C4.15833 ' +
            '20.2083 4 19.825 4 19.375V6.625C4 6.175 4.15833 5.79167 4.475 5.475C4.79167 ' +
            '5.15833 5.175 5 5.625 5H10.325C10.225 4.48333 10.3417 4.02067 10.675 3.612C11.0083' +
            ' 3.204 11.45 3 12 3C12.55 3 12.996 3.204 13.338 3.612C13.6793 4.02067 13.7917 ' +
            '4.48333 13.675 5H18.375C18.825 5 19.2083 5.15833 19.525 5.475C19.8417 5.79167 20 ' +
            '6.175 20 6.625V19.375C20 19.825 19.8417 20.2083 19.525 20.525C19.2083 20.8417 18.825 ' +
            '21 18.375 21H5.625ZM5.625 20H18.375C18.5417 20 18.6873 19.9373 18.812 19.812C18.9373 ' +
            '19.6873 19 19.5417 19 19.375V6.625C19 6.45833 18.9373 6.31267 18.812 6.188C18.6873 ' +
            '6.06267 18.5417 6 18.375 6H5.625C5.45833 6 5.31267 6.06267 5.188 6.188C5.06267 ' +
            '6.31267 5 6.45833 5 6.625V19.375C5 19.5417 5.06267 19.6873 5.188 19.812C5.31267 ' +
            '19.9373 5.45833 20 5.625 20ZM12 5.45C12.2167 5.45 12.396 5.379 12.538 5.237C12.6793 ' +
            '5.09567 12.75 4.91667 12.75 4.7C12.75 4.48333 12.6793 4.304 12.538 4.162C12.396 ' +
            '4.02067 12.2167 3.95 12 3.95C11.7833 3.95 11.6043 4.02067 11.463 4.162C11.321 ' +
            '4.304 11.25 4.48333 11.25 4.7C11.25 4.91667 11.321 5.09567 11.463 5.237C11.6043 ' +
            '5.379 11.7833 5.45 12 5.45Z' })));

const CalStartIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'calStartIcon' }),
    React.createElement("path", { d: 'M9 15.7375C8.41667 15.7375 7.91667 15.5292 7.5 15.1125C7.08333 14.6958 6.875 ' +
            '14.1958 6.875 13.6125C6.875 13.0292 7.08333 12.5292 7.5 12.1125C7.91667 ' +
            '11.6958 8.41667 11.4875 9 11.4875C9.58333 11.4875 10.0833 11.6958 10.5 12.1125C10.9167 ' +
            '12.5292 11.125 13.0292 11.125 13.6125C11.125 14.1958 10.9167 14.6958 10.5 ' +
            '15.1125C10.0833 15.5292 9.58333 15.7375 9 15.7375ZM5.625 21.1125C5.15833 ' +
            '21.1125 4.771 20.9585 4.463 20.6505C4.15433 20.3418 4 19.9542 4 19.4875V6.7375C4 ' +
            '6.27083 4.15433 5.8835 4.463 5.5755C4.771 5.26683 5.15833 5.1125 5.625 ' +
            '5.1125H7.375V2.8875H8.45V5.1125H15.625V2.8875H16.625V5.1125H18.375C18.8417 ' +
            '5.1125 19.2293 5.26683 19.538 5.5755C19.846 5.8835 20 6.27083 20 6.7375V19.4875C20 ' +
            '19.9542 19.846 20.3418 19.538 20.6505C19.2293 20.9585 18.8417 21.1125 18.375 ' +
            '21.1125H5.625ZM5.625 20.1125H18.375C18.5417 20.1125 18.6873 20.0498 18.812 ' +
            '19.9245C18.9373 19.7998 19 19.6542 19 19.4875V10.7375H5V19.4875C5 19.6542 5.06267 ' +
            '19.7998 5.188 19.9245C5.31267 20.0498 5.45833 20.1125 5.625 20.1125ZM5 ' +
            '9.7375H19V6.7375C19 6.57083 18.9373 6.42516 18.812 6.3005C18.6873 6.17516 ' +
            '18.5417 6.1125 18.375 6.1125H5.625C5.45833 6.1125 5.31267 6.17516 5.188 6.3005C5.06267 ' +
            '6.42516 5 6.57083 5 6.7375V9.7375Z' })));

const CalEndIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'calEndIcon' }),
        React.createElement("path", { d: 'M14.875 18.1125C14.2917 18.1125 13.7957 17.9042 13.387 17.4875C12.979 17.0708 ' +
                '12.775 16.5708 12.775 15.9875C12.775 15.4042 12.979 14.9082 13.387 14.4995C13.7957 ' +
                '14.0915 14.2917 13.8875 14.875 13.8875C15.4583 13.8875 15.9583 14.0915 16.375 ' +
                '14.4995C16.7917 14.9082 17 15.4042 17 15.9875C17 16.5708 16.7917 17.0708 16.375 ' +
                '17.4875C15.9583 17.9042 15.4583 18.1125 14.875 18.1125ZM5.625 21.1125C5.15833 ' +
                '21.1125 4.771 20.9585 4.463 20.6505C4.15433 20.3418 4 19.9542 4 19.4875V6.7375C4 ' +
                '6.27083 4.15433 5.8835 4.463 5.5755C4.771 5.26683 5.15833 5.1125 5.625 ' +
                '5.1125H7.375V2.8875H8.45V5.1125H15.625V2.8875H16.625V5.1125H18.375C18.8417 ' +
                '5.1125 19.2293 5.26683 19.538 5.5755C19.846 5.8835 20 6.27083 20 6.7375V19.4875C20 ' +
                '19.9542 19.846 20.3418 19.538 20.6505C19.2293 20.9585 18.8417 21.1125 18.375 ' +
                '21.1125H5.625ZM5.625 20.1125H18.375C18.5417 20.1125 18.6873 20.0498 18.812 ' +
                '19.9245C18.9373 19.7998 19 19.6542 19 19.4875V10.7375H5V19.4875C5 19.6542 5.06267 ' +
                '19.7998 5.188 19.9245C5.31267 20.0498 5.45833 20.1125 5.625 20.1125ZM5 ' +
                '9.7375H19V6.7375C19 6.57083 18.9373 6.42516 18.812 6.3005C18.6873 6.17516 ' +
                '18.5417 6.1125 18.375 6.1125H5.625C5.45833 6.1125 5.31267 6.17516 5.188 6.3005C5.06267 ' +
                '6.42516 5 6.57083 5 6.7375V9.7375Z' })));
};

const ExcelIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'excelIcon' }),
    React.createElement("g", { clipPath: 'url(#clip0_1985_562)' },
        React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M6 21.9048V19.3125H1.125C0.503679 19.3125 0 18.8088 0 18.1875V6.9375C0 6.31618 0.50368 ' +
                '5.8125 1.125 5.8125H6V2.09524C6 0.93807 6.92341 0 8.0625 0H18.5355C19.0786 0 19.5998 ' +
                '0.217598 19.9859 0.60556L23.3879 4.02377C23.7796 4.41734 24 4.95376 24 5.51345V21.9048C24 ' +
                '23.0619 23.0766 24 21.9375 24H8.0625C6.92341 24 6 23.0619 6 21.9048ZM7.3125 ' +
                '21.9048V19.3125H12.375C12.9963 19.3125 13.5 18.8088 13.5 18.1875V6.9375C13.5 ' +
                '6.31618 12.9963 5.8125 12.375 5.8125H7.3125V2.09524C7.3125 1.67445 7.64829 1.33333 ' +
                '8.0625 1.33333H18.2812V5.90476C18.2812 6.69374 18.9109 7.33333 19.6875 ' +
                '7.33333H22.6875V21.9048C22.6875 22.3256 22.3517 22.6667 21.9375 22.6667H8.0625C7.64829 ' +
                '22.6667 7.3125 22.3256 7.3125 21.9048ZM22.6875 5.51345V6H19.6875C19.6357 6 19.5938 ' +
                '5.95736 19.5938 5.90476V2.08691L22.4649 4.97175C22.6073 5.11487 22.6875 5.30993 ' +
                '22.6875 5.51345ZM16.0312 9.1875C15.6688 9.1875 15.375 9.48131 15.375 9.84375C15.375 ' +
                '10.2062 15.6688 10.5 16.0312 10.5H20.3438C20.7062 10.5 21 10.2062 21 9.84375C21 ' +
                '9.48131 20.7062 9.1875 20.3438 9.1875H16.0312ZM16.0312 12.1875C15.6688 12.1875 ' +
                '15.375 12.4813 15.375 12.8438C15.375 13.2062 15.6688 13.5 16.0312 13.5H20.3438C20.7062 ' +
                '13.5 21 13.2062 21 12.8438C21 12.4813 20.7062 12.1875 20.3438 12.1875H16.0312ZM15.375 ' +
                '15.8438C15.375 15.4813 15.6688 15.1875 16.0312 15.1875H20.3438C20.7062 15.1875 21 ' +
                '15.4813 21 15.8438C21 16.2062 20.7062 16.5 20.3438 16.5H16.0312C15.6688 16.5 15.375 ' +
                '16.2062 15.375 15.8438ZM5.85718 12.4065L3.75 16.3286H5.24194L6.61084 13.7292L7.97974 ' +
                '16.3286H9.48193L7.37476 12.4629L9.28711 8.8125H7.84644L6.63647 11.2273L5.40088 ' +
                '8.8125H3.94482L5.85718 12.4065Z' })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_1985_562" },
            React.createElement("rect", { width: "24", height: "24", fill: "white" })))));

const ForumIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }),
        React.createElement("path", { d: 'M3 15.5101V4.76922C3 4.55127 3.07372 4.36858 3.22115 4.22115C3.3686 4.07372 3.5513 4 3.76925 ' +
                '4H15.6923C15.9103 4 16.093 4.07372 16.2404 4.22115C16.3878 4.36858 16.4616 4.55127 16.4616 ' +
                '4.76922V12.6923C16.4616 12.9103 16.3878 13.0929 16.2404 13.2404C16.093 13.3878 15.9103 13.4615 ' +
                '15.6923 13.4615H6.07693L3.7154 15.8231C3.57437 15.9641 3.41987 15.9962 3.25192 15.9193C3.08397 ' +
                '15.8423 3 15.7059 3 15.5101ZM6.84617 17.2308C6.62822 17.2308 6.44553 17.1571 6.2981 17.0096C6.15065 ' +
                '16.8622 6.07693 16.6795 6.07693 16.4615V15.4615H17.827L18.4616 16.0962V7H19.4616C19.6795 7 19.8622 ' +
                '7.07372 20.0097 7.22115C20.1571 7.36858 20.2308 7.55128 20.2308 7.76923V19.2811C20.2308 19.4758 20.1468 ' +
                '19.6116 19.9789 19.6885C19.8109 19.7654 19.6564 19.7333 19.5154 19.5923L17.1539 17.2308H6.84617ZM15.4616 ' +
                '5H4.00002V13.8462L5.38462 12.4615H15.4616V5Z' })));
};

const UploadIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'uploadIcon' }),
        React.createElement("path", { d: 'M6.61537 19.3462C6.15512 19.3462 5.77083 19.192 5.4625 ' +
                '18.8837C5.15417 18.5753 5 18.191 5 17.7308V15.3462H6V17.7308C6 ' +
                '17.8846 6.0641 18.0256 6.1923 18.1538C6.32052 18.282 6.46154 ' +
                '18.3462 6.61537 18.3462H17.3846C17.5385 18.3462 17.6795 ' +
                '18.282 17.8077 18.1538C17.9359 18.0256 18 17.8846 18 ' +
                '17.7308V15.3462H19V17.7308C19 18.191 18.8458 18.5753 ' +
                '18.5375 18.8837C18.2292 19.192 17.8449 19.3462 17.3846 ' +
                '19.3462H6.61537ZM11.5 15.5769V6.92692L9.16923 9.2577L8.46152 ' +
                '8.53848L12 5L15.5385 8.53848L14.8308 9.2577L12.5 6.92692V15.5769H11.5Z' })));
};

const LibraryIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'libraryIcon' }),
        React.createElement("path", { d: 'M10 13.5H13.4808V12.5H10V13.5ZM10 10.5H16.9615V9.5H10V10.5ZM10 ' +
                '7.5H16.9615V6.5H10V7.5ZM8.11538 17C7.65513 17 7.27083 16.8458 ' +
                '6.9625 16.5375C6.65417 16.2292 6.5 15.8449 6.5 15.3846V4.61537C6.5 ' +
                '4.15512 6.65417 3.77083 6.9625 3.4625C7.27083 3.15417 7.65513 3 ' +
                '8.11538 3H18.8846C19.3449 3 19.7292 3.15417 20.0375 3.4625C20.3458 ' +
                '3.77083 20.5 4.15512 20.5 4.61537V15.3846C20.5 15.8449 20.3458 ' +
                '16.2292 20.0375 16.5375C19.7292 16.8458 19.3449 17 18.8846 ' +
                '17H8.11538ZM8.11538 16H18.8846C19.0385 16 19.1795 15.9359 19.3077 ' +
                '15.8077C19.4359 15.6795 19.5 15.5385 19.5 15.3846V4.61537C19.5 ' +
                '4.46154 19.4359 4.32052 19.3077 4.1923C19.1795 4.0641 19.0385 4 ' +
                '18.8846 4H8.11538C7.96154 4 7.82052 4.0641 7.6923 4.1923C7.5641 ' +
                '4.32052 7.5 4.46154 7.5 4.61537V15.3846C7.5 15.5385 7.5641 ' +
                '15.6795 7.6923 15.8077C7.82052 15.9359 7.96154 16 8.11538 ' +
                '16ZM5.11538 20C4.65513 20 4.27083 19.8458 3.9625 19.5375C3.65417 ' +
                '19.2292 3.5 18.8449 3.5 18.3846V6.61537H4.5V18.3846C4.5 18.5385 ' +
                '4.5641 18.6795 4.6923 18.8077C4.8205 18.9359 4.96153 19 5.11538 ' +
                '19H16.8846V20H5.11538Z' })));
};

const ImageIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "imageIcon" }),
        React.createElement("path", { d: 'M5.5 21C4.8 21 4.20833 20.7583 3.725 20.275C3.24167 19.7917 3 19.2 3 ' +
                '18.5V5.5C3 4.8 3.24167 4.20833 3.725 3.725C4.20833 3.24167 4.8 3 ' +
                '5.5 3H18.5C19.2 3 19.7917 3.24167 20.275 3.725C20.7583 4.20833 21 ' +
                '4.8 21 5.5V18.5C21 19.2 20.7583 19.7917 20.275 20.275C19.7917 20.7583 ' +
                '19.2 21 18.5 21H5.5ZM5.5 20H18.5C18.9167 20 19.2707 19.854 19.562 ' +
                '19.562C19.854 19.2707 20 18.9167 20 18.5V5.5C20 5.08333 19.854 ' +
                '4.72933 19.562 4.438C19.2707 4.146 18.9167 4 18.5 4H5.5C5.08333 ' +
                '4 4.72933 4.146 4.438 4.438C4.146 4.72933 4 5.08333 4 5.5V18.5C4 ' +
                '18.9167 4.146 19.2707 4.438 19.562C4.72933 19.854 5.08333 20 5.5 ' +
                '20ZM7.2 17L10 14.2L11.85 16.025L14 13.3L16.95 17H7.2ZM8.5 9.5C8.08333 ' +
                '9.5 7.72933 9.354 7.438 9.062C7.146 8.77067 7 8.41667 7 8C7 7.58333 ' +
                '7.146 7.22933 7.438 6.938C7.72933 6.646 8.08333 6.5 8.5 6.5C8.91667 ' +
                '6.5 9.27067 6.646 9.562 6.938C9.854 7.22933 10 7.58333 10 8C10 8.41667 ' +
                '9.854 8.77067 9.562 9.062C9.27067 9.354 8.91667 9.5 8.5 9.5Z' })));
};

const FileDescriptionIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'fileDescriptionIcon' }),
        React.createElement("path", { d: 'M8.5 17.5H15.5V16.5H8.5V17.5ZM8.5 13.5H15.5V12.5H8.5V13.5ZM6.61537 ' +
                '21C6.15512 21 5.77083 20.8458 5.4625 20.5375C5.15417 20.2292 5 ' +
                '19.8449 5 19.3846V4.61537C5 4.15512 5.15417 3.77083 5.4625 ' +
                '3.4625C5.77083 3.15417 6.15512 3 6.61537 3H14.5L19 7.5V19.3846C19 ' +
                '19.8449 18.8458 20.2292 18.5375 20.5375C18.2292 20.8458 17.8449 ' +
                '21 17.3846 21H6.61537ZM14 8V4H6.61537C6.46154 4 6.32052 4.0641 ' +
                '6.1923 4.1923C6.0641 4.32052 6 4.46154 6 4.61537V19.3846C6 ' +
                '19.5385 6.0641 19.6795 6.1923 19.8077C6.32052 19.9359 6.46154 ' +
                '20 6.61537 20H17.3846C17.5385 20 17.6795 19.9359 17.8077 ' +
                '19.8077C17.9359 19.6795 18 19.5385 18 19.3846V8H14Z' })));
};

const CSVIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'CSVIcon' }),
        React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M5.4625 20.5375C5.77083 20.8458 6.15512 21 6.61537 21H17.3846C17.8449 21 ' +
                '18.2292 20.8458 18.5375 20.5375C18.8458 20.2292 19 19.8449 19 ' +
                '19.3846V17H20V11H19V7.5L14.5 3H6.61537C6.15512 3 5.77083 3.15417 ' +
                '5.4625 3.4625C5.15417 3.77083 5 4.15512 5 4.61537V11H4V17H5V19.3846C5 ' +
                '19.8449 5.15417 20.2292 5.4625 20.5375ZM18 11V8H14V4H6.61537C6.46154 ' +
                '4 6.32052 4.0641 6.1923 4.1923C6.0641 4.32052 6 4.46154 6 ' +
                '4.61537V11H18ZM6 17V19.3846C6 19.5385 6.0641 19.6795 6.1923 ' +
                '19.8077C6.32052 19.9359 6.46154 20 6.61537 20H17.3846C17.5385 20 ' +
                '17.6795 19.9359 17.8077 19.8077C17.9359 19.6795 18 19.5385 18 ' +
                '19.3846V17H6ZM9.74256 14.6506H8.95316C8.94773 14.8377 8.92513 ' +
                '14.982 8.88534 15.0835C8.84556 15.185 8.78407 15.2554 8.70088 ' +
                '15.2946C8.6195 15.3338 8.51189 15.3534 8.37806 15.3534C8.26232 ' +
                '15.3534 8.16647 15.3347 8.09051 15.2973C8.01637 15.2599 7.95759 ' +
                '15.2002 7.91419 15.1182C7.87078 15.0363 7.83914 14.9312 7.81924 ' +
                '14.8029C7.79935 14.6729 7.7894 14.5161 7.7894 14.3327V13.6673C7.7894 ' +
                '13.4803 7.80025 13.3218 7.82195 13.1917C7.84547 13.0617 7.88163 ' +
                '12.9566 7.93046 12.8764C7.97929 12.7963 8.04169 12.7384 8.11764 ' +
                '12.7027C8.1936 12.6653 8.28402 12.6466 8.38891 12.6466C8.52998 ' +
                '12.6466 8.64029 12.6689 8.71987 12.7134C8.79944 12.7562 8.85731 ' +
                '12.831 8.89348 12.9379C8.93146 13.043 8.95316 13.1882 8.95859 ' +
                '13.3734H9.7507C9.729 13.0795 9.6648 12.831 9.5581 12.6279C9.45321 ' +
                '12.4231 9.30401 12.2672 9.1105 12.1603C8.91699 12.0534 8.67646 12 ' +
                '8.38891 12C8.1737 12 7.9802 12.0365 7.80839 12.1096C7.63839 12.1808 ' +
                '7.49281 12.2877 7.37164 12.4302C7.25228 12.5709 7.16005 12.7455 7.09495 ' +
                '12.9539C7.03165 13.1623 7 13.4019 7 13.6727V14.3327C7 14.6034 7.02984 ' +
                '14.843 7.08952 15.0514C7.15101 15.2581 7.24143 15.4318 7.36079 ' +
                '15.5725C7.48015 15.7132 7.62483 15.8201 7.79483 15.8931C7.96482 ' +
                '15.9644 8.15924 16 8.37806 16C8.66019 16 8.90071 15.9483 9.09965 ' +
                '15.845C9.30039 15.7417 9.45501 15.5903 9.56352 15.3908C9.67203 15.1895 ' +
                '9.73171 14.9428 9.74256 14.6506ZM12.354 14.7335C12.3667 14.7905 12.373 ' +
                '14.8537 12.373 14.9232C12.373 15.0069 12.3594 15.0817 12.3323 ' +
                '15.1476C12.3052 15.2135 12.26 15.2661 12.1967 15.3053C12.1352 ' +
                '15.3445 12.052 15.3641 11.9471 15.3641C11.8549 15.3641 11.7726' +
                ' 15.3525 11.7002 15.3293C11.6297 15.3044 11.57 15.2679 11.5212 ' +
                '15.2198C11.4724 15.1699 11.4362 15.104 11.4127 15.022C11.3892 ' +
                '14.9383 11.3774 14.8377 11.3774 14.7201H10.5826C10.5826 14.941 ' +
                '10.6179 15.1325 10.6884 15.2946C10.7589 15.4549 10.8557 15.5876 ' +
                '10.9787 15.6927C11.1034 15.796 11.2472 15.8735 11.41 15.9252C11.5727 ' +
                '15.9751 11.7455 16 11.9281 16C12.1162 16 12.2862 15.9742 12.4381 ' +
                '15.9225C12.5918 15.8709 12.7229 15.7978 12.8314 15.7034C12.94 15.6072 ' +
                '13.0222 15.4932 13.0783 15.3614C13.1362 15.2278 13.1651 15.0799 ' +
                '13.1651 14.9178C13.1651 14.754 13.1416 14.6079 13.0946 14.4796C13.0476 ' +
                '14.3514 12.9779 14.2365 12.8857 14.1349C12.7935 14.0316 12.6786 13.939 ' +
                '12.5412 13.857C12.4037 13.7733 12.2455 13.6967 12.0665 13.6273C11.9742 ' +
                '13.5916 11.8892 13.5551 11.8115 13.5177C11.7355 13.4803 11.6695 13.442 ' +
                '11.6134 13.4028C11.5574 13.3618 11.5131 13.3164 11.4805 13.2665C11.4498 ' +
                '13.2149 11.4344 13.157 11.4344 13.0929C11.4344 13.0073 11.4498 12.9307 ' +
                '11.4805 12.8631C11.5131 12.7936 11.5619 12.7393 11.627 12.7001C11.6939 ' +
                '12.6591 11.778 12.6386 11.8793 12.6386C11.9878 12.6386 12.0764 12.6627 ' +
                '12.1451 12.7108C12.2139 12.7589 12.2636 12.8257 12.2943 12.9112C12.3269 ' +
                '12.9949 12.3432 13.092 12.3432 13.2024H13.1353C13.1353 12.969 13.0837 ' +
                '12.7624 12.9806 12.5825C12.8794 12.4026 12.7356 12.261 12.5493 ' +
                '12.1576C12.3649 12.0543 12.146 12.0027 11.8928 12.0027C11.7066 ' +
                '12.0027 11.5375 12.0285 11.3856 12.0802C11.2355 12.1318 11.1043 ' +
                '12.2057 10.9922 12.3019C10.8801 12.3963 10.7933 12.5104 10.7318 ' +
                '12.644C10.6721 12.7776 10.6423 12.9263 10.6423 13.0902C10.6423 ' +
                '13.2576 10.6739 13.4037 10.7372 13.5284C10.8023 13.6513 10.89 13.7582 ' +
                '11.0004 13.849C11.1107 13.9399 11.2346 14.02 11.372 14.0895C11.5094 14.1572 ' +
                '11.6514 14.2213 11.7979 14.2819C11.9209 14.3336 12.0203 14.3834 12.0963 ' +
                '14.4315C12.1741 14.4796 12.2328 14.5277 12.2726 14.5758C12.3142 14.6239 ' +
                '12.3414 14.6765 12.354 14.7335ZM15.0414 15.9466H15.2774H15.6219H15.8552L17 ' +
                '12.0561H16.1428L15.4471 14.899L14.7539 12.0561H13.9048L15.0414 15.9466Z' })));
};

const FolderOpenIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'folderOpenIcon' }),
    React.createElement("path", { d: 'M4.5 18.9999C4.0782 18.9999 3.72275 18.8554 3.43365 18.5663C3.14455 ' +
            '18.2772 3 17.9217 3 17.4999V7.38454C3 6.96276 3.16378 6.58808 ' +
            '3.49135 6.26051C3.8189 5.93295 4.19358 5.76917 4.61538 ' +
            '5.76917H10.7692L12 6.99994H19.3846C19.7295 6.99994 20.0305 ' +
            '7.09321 20.2875 7.27974C20.5446 7.46629 20.7244 7.70636 20.8269 ' +
            '7.99994H11.5981L10.3673 6.76917H4.61538C4.43589 6.76917 4.28846 ' +
            '6.82686 4.17308 6.94224C4.05769 7.05762 4 7.20506 4 7.38454V17.3846C4 ' +
            '17.5256 4.03526 17.641 4.10578 17.7307C4.17628 17.8204 4.26922 ' +
            '17.8974 4.38462 17.9615L6.76537 9.99994H22.9808L20.5981 17.9403C20.5032 ' +
            '18.2583 20.3215 18.5144 20.0529 18.7086C19.7843 18.9028 19.4846 ' +
            '18.9999 19.1539 18.9999H4.5ZM5.42692 17.9999H19.5385L21.6269 ' +
            '10.9999H7.51537L5.42692 17.9999Z' })));

var Launch = {};

var createSvgIcon = {};

var require$$0 = /*@__PURE__*/getAugmentedNamespace(utils);

var hasRequiredCreateSvgIcon;

function requireCreateSvgIcon () {
	if (hasRequiredCreateSvgIcon) return createSvgIcon;
	hasRequiredCreateSvgIcon = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		Object.defineProperty(exports, "default", {
		  enumerable: true,
		  get: function () {
		    return _utils.createSvgIcon;
		  }
		});
		var _utils = require$$0; 
	} (createSvgIcon));
	return createSvgIcon;
}

var _interopRequireDefault$2 = interopRequireDefaultExports;
Object.defineProperty(Launch, "__esModule", {
  value: true
});
var default_1$2 = Launch.default = void 0;
var _createSvgIcon$2 = _interopRequireDefault$2(requireCreateSvgIcon());
var _jsxRuntime$2 = require$$2$1;
default_1$2 = Launch.default = (0, _createSvgIcon$2.default)( /*#__PURE__*/(0, _jsxRuntime$2.jsx)("path", {
  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), 'Launch');

const LaunchExternalIcon = (props) => React.createElement(default_1$2, Object.assign({}, props));

const HelpIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'helpIcon' }),
    React.createElement("path", { d: 'M10.0208 14.3542C10.2014 14.3542 10.3578 14.2917 10.49 14.1667C10.6217 ' +
            '14.0417 10.6875 13.8889 10.6875 13.7083C10.6875 13.5139 10.6217 13.3542 ' +
            '10.49 13.2292C10.3578 13.1042 10.2014 13.0417 10.0208 13.0417C9.84028 ' +
            '13.0417 9.6875 13.1042 9.5625 13.2292C9.4375 13.3542 9.375 13.5139 9.375 ' +
            '13.7083C9.375 13.8889 9.4375 14.0417 9.5625 14.1667C9.6875 14.2917 9.84028 ' +
            '14.3542 10.0208 14.3542ZM9.58333 11.6042H10.3958C10.4236 11.2431 10.4931 ' +
            '10.9478 10.6042 10.7183C10.7153 10.4894 10.9514 10.2014 11.3125 ' +
            '9.85417C11.6875 9.47917 11.9653 9.14583 12.1458 8.85417C12.3264 8.5625 ' +
            '12.4167 8.22222 12.4167 7.83333C12.4167 7.16667 12.1839 6.63889 11.7183 ' +
            '6.25C11.2533 5.86111 10.7083 5.66667 10.0833 5.66667C9.48611 5.66667 ' +
            '8.97917 5.82972 8.5625 6.15583C8.14583 6.4825 7.84028 6.86111 7.64583 ' +
            '7.29167L8.39583 7.60417C8.53472 7.29861 8.72917 7.03111 8.97917 ' +
            '6.80167C9.22917 6.57278 9.58333 6.45833 10.0417 6.45833C10.5833 6.45833 ' +
            '10.9792 6.60417 11.2292 6.89583C11.4792 7.1875 11.6042 7.51389 11.6042 ' +
            '7.875C11.6042 8.16667 11.5278 8.42361 11.375 8.64583C11.2222 8.86806 ' +
            '11.0208 9.09722 10.7708 9.33333C10.2847 9.77778 9.96528 10.1561 9.8125 ' +
            '10.4683C9.65972 10.7811 9.58333 11.1597 9.58333 11.6042ZM10 17.5C8.95833 ' +
            '17.5 7.98278 17.3022 7.07333 16.9067C6.16333 16.5106 5.37167 15.9756 ' +
            '4.69833 15.3017C4.02444 14.6283 3.48944 13.8367 3.09333 12.9267C2.69778 ' +
            '12.0172 2.5 11.0417 2.5 10C2.5 8.95833 2.69778 7.9825 3.09333 7.0725C3.48944 ' +
            '6.16306 4.02444 5.37139 4.69833 4.6975C5.37167 4.02417 6.16333 3.48944 ' +
            '7.07333 3.09333C7.98278 2.69778 8.95833 2.5 10 2.5C11.0417 2.5 12.0175 ' +
            '2.69778 12.9275 3.09333C13.8369 3.48944 14.6286 4.02417 15.3025 ' +
            '4.6975C15.9758 5.37139 16.5106 6.16306 16.9067 7.0725C17.3022 7.9825 ' +
            '17.5 8.95833 17.5 10C17.5 11.0417 17.3022 12.0172 16.9067 12.9267C16.5106 ' +
            '13.8367 15.9758 14.6283 15.3025 15.3017C14.6286 15.9756 13.8369 ' +
            '16.5106 12.9275 16.9067C12.0175 17.3022 11.0417 17.5 10 17.5ZM10 ' +
            '16.6667C11.8611 16.6667 13.4375 16.0208 14.7292 14.7292C16.0208 ' +
            '13.4375 16.6667 11.8611 16.6667 10C16.6667 8.13889 16.0208 6.5625 ' +
            '14.7292 5.27083C13.4375 3.97917 11.8611 3.33333 10 3.33333C8.13889 ' +
            '3.33333 6.5625 3.97917 5.27083 5.27083C3.97917 6.5625 3.33333 8.13889 ' +
            '3.33333 10C3.33333 11.8611 3.97917 13.4375 5.27083 14.7292C6.5625 16.0208 ' +
            '8.13889 16.6667 10 16.6667Z' })));

const CommentConversationIcon = () => {
    return (React.createElement(SvgIcon, { width: "25", height: "24", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: 'M8.02549 13.3534L5.2833 14.4436L6.2328 12.7561C6.33855 12.58 6.30311 12.4045 6.16249 ' +
                '12.2639C5.03749 11.3847 4.40467 10.1191 4.40467 8.78312C4.40467 6.11124 7.11199 ' +
                '3.93156 10.4167 3.93156C13.7214 3.93156 16.4287 6.11124 16.4287 8.78312H17.1672 ' +
                'C17.1672 5.68937 14.1438 3.19299 10.4172 3.19299C6.69067 3.19299 3.66724 5.68937 ' +
                '3.66724 8.78312C3.66724 10.2248 4.30005 11.6311 5.42505 12.6503L4.08911 15.0061' +
                'C4.0188 15.1467 4.0188 15.3227 4.12455 15.4279C4.19486 15.5337 4.30061 15.5686 ' +
                '4.4058 15.5686C4.47611 15.5686 4.51155 15.5686 4.54642 15.5331L8.20267 14.0914' +
                'C8.51936 14.1972 8.83549 14.2675 9.18705 14.3024L9.2928 13.5638C8.94124 13.4935 ' +
                '8.58967 13.4232 8.27299 13.3174C8.20267 13.3174 8.09692 13.3174 8.02661 13.3529 ' +
                'L8.02549 13.3534ZM20.2599 18.2753C21.1739 17.4664 21.6661 16.3769 21.6661 15.1816 ' +
                'C21.6661 12.5446 19.0994 10.33 16.0411 10.33C12.9828 10.33 10.4161 12.5451 10.4161 ' +
                '15.1816C10.4161 17.8889 12.877 20.1389 15.7953 20.1389C16.5339 20.1389 17.237 19.9982 ' +
                '17.9401 19.717L20.788 20.8071H20.9287C21.0344 20.8071 21.1396 20.7717 21.2099 20.7014 ' +
                'C21.3157 20.5956 21.3157 20.4201 21.2454 20.2795L20.2599 18.2753ZM17.9047 18.943C17.975 ' +
                '18.943 18.0099 18.943 18.0453 18.9784L20.1547 19.7524L19.4515 18.3462C19.3812 18.2056 ' +
                '19.4167 17.9946 19.5573 17.8889C20.4714 17.1857 20.9287 16.2717 20.9287 15.1816 ' +
                'C20.9287 12.9664 18.6787 11.068 16.0417 11.068C13.4047 11.068 11.1547 12.9664 11.1547 ' +
                '15.1816C11.1547 17.4664 13.2989 19.4003 15.7953 19.4003C16.463 19.4003 17.1312 19.2597 ' +
                '17.764 18.9784C17.7989 18.943 17.8692 18.943 17.9047 18.943Z' })));
};

const CalculateIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'calculateIcon' }),
    React.createElement("path", { d: 'M8.3 17.7H9.2V15.7H11.2V14.8H9.2V12.8H8.3V14.8H6.3V15.7H8.3V17.7ZM13.3 ' +
            '16.95H17.7V16.05H13.3V16.95ZM13.3 14.45H17.7V13.55H13.3V14.45ZM14.1 ' +
            '10.5L15.5 9.1L16.9 10.5L17.525 9.85L16.125 8.45L17.525 7.05L16.9 ' +
            '6.425L15.5 7.825L14.1 6.425L13.475 7.05L14.875 8.45L13.475 9.85L14.1 ' +
            '10.5ZM6.55 8.9H10.95V8H6.55V8.9ZM5.625 20C5.15833 20 4.771 19.846 ' +
            '4.463 19.538C4.15433 19.2293 4 18.8417 4 18.375V5.625C4 5.15833 ' +
            '4.15433 4.771 4.463 4.463C4.771 4.15433 5.15833 4 5.625 4H18.375C18.8417 ' +
            '4 19.2293 4.15433 19.538 4.463C19.846 4.771 20 5.15833 20 5.625V18.375C20 ' +
            '18.8417 19.846 19.2293 19.538 19.538C19.2293 19.846 18.8417 20 18.375 ' +
            '20H5.625ZM5.625 19H18.375C18.5417 19 18.6873 18.9373 18.812 18.812C18.9373 ' +
            '18.6873 19 18.5417 19 18.375V5.625C19 5.45833 18.9373 5.31267 ' +
            '18.812 5.188C18.6873 5.06267 18.5417 5 18.375 5H5.625C5.45833 5 5.31267 ' +
            '5.06267 5.188 5.188C5.06267 5.31267 5 5.45833 5 5.625V18.375C5 18.5417 ' +
            '5.06267 18.6873 5.188 18.812C5.31267 18.9373 5.45833 19 5.625 19Z' })));

const AddPropertyIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { viewBox: "0 0 24 24" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 
        // eslint-disable-next-line max-len
        'M8.11673 16.5385C8.33506 16.5385 8.51762 16.4646 8.66442 16.3169C8.81122 16.1692 8.88463 15.9862 8.88463 15.7679C8.88463 15.5495 8.81078 15.367 8.66308 15.2202C8.51538 15.0734 8.33236 15 8.11403 15C7.89569 15 7.71313 15.0738 7.56635 15.2215C7.41955 15.3692 7.34615 15.5522 7.34615 15.7706C7.34615 15.9889 7.42 16.1715 7.5677 16.3183C7.71538 16.4651 7.89839 16.5385 8.11673 16.5385ZM8.11673 12.7692C8.33506 12.7692 8.51762 12.6954 8.66442 12.5477C8.81122 12.4 8.88463 12.217 8.88463 11.9986C8.88463 11.7803 8.81078 11.5978 8.66308 11.451C8.51538 11.3042 8.33236 11.2308 8.11403 11.2308C7.89569 11.2308 7.71313 11.3046 7.56635 11.4523C7.41955 11.6 7.34615 11.783 7.34615 12.0014C7.34615 12.2197 7.42 12.4022 7.5677 12.549C7.71538 12.6958 7.89839 12.7692 8.11673 12.7692ZM8.11673 9C8.33506 9 8.51762 8.92615 8.66442 8.77845C8.81122 8.63077 8.88463 8.44776 8.88463 8.22942C8.88463 8.01109 8.81078 7.82853 8.66308 7.68173C8.51538 7.53493 8.33236 7.46152 8.11403 7.46152C7.89569 7.46152 7.71313 7.53537 7.56635 7.68307C7.41955 7.83078 7.34615 8.01379 7.34615 8.23213C7.34615 8.45046 7.42 8.63302 7.5677 8.7798C7.71538 8.9266 7.89839 9 8.11673 9ZM11.1923 16.2692H16.5769V15.2692H11.1923V16.2692ZM11.1923 12.5H16.5769V11.5H11.1923V12.5ZM11.1923 8.73077H16.5769V7.73077H11.1923V8.73077ZM5.61538 20C5.15513 20 4.77083 19.8458 4.4625 19.5375C4.15417 19.2292 4 18.8449 4 18.3846V5.61537C4 5.15512 4.15417 4.77083 4.4625 4.4625C4.77083 4.15417 5.15513 4 5.61538 4H18.3846C18.8449 4 19.2292 4.15417 19.5375 4.4625C19.8458 4.77083 20 5.15512 20 5.61537V18.3846C20 18.8449 19.8458 19.2292 19.5375 19.5375C19.2292 19.8458 18.8449 20 18.3846 20H5.61538ZM5.61538 19H18.3846C18.5385 19 18.6795 18.9359 18.8077 18.8077C18.9359 18.6795 19 18.5385 19 18.3846V5.61537C19 5.46154 18.9359 5.32052 18.8077 5.1923C18.6795 5.0641 18.5385 5 18.3846 5H5.61538C5.46154 5 5.32052 5.0641 5.1923 5.1923C5.0641 5.32052 5 5.46154 5 5.61537V18.3846C5 18.5385 5.0641 18.6795 5.1923 18.8077C5.32052 18.9359 5.46154 19 5.61538 19Z' }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M122.9 115.641H101.026V93.7659C101.026 93.18 100.635 92.6909 100.049 92.6909C99.4632 92.6909 ' +
            '98.9742 93.18 98.9742 93.7659V115.641H77.0999C76.5139 115.641 76.0249 116.032 76.0249 116.617C76.0249 ' +
            '117.203 76.5139 117.692 77.0999 117.692H98.9742V139.567C98.9742 140.153 99.3648 140.642 99.9507 ' +
            '140.642C100.537 140.642 101.026 140.153 101.026 139.567V117.692H122.9C123.486 117.692 123.975 117.203 ' +
            '123.975 116.617C123.975 116.032 123.486 115.641 122.9 115.641Z' })));

const NewMessagesIcon = () => {
    return (React.createElement(SvgIcon, { width: "25", height: "24", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: 'M5.02549 10.3534L2.2833 11.4436L3.2328 9.75606C3.33855' +
                ' 9.57999 3.30311 9.40449 3.16249 9.26387C2.03749 8.38468 1.40467 ' +
                '7.11906 1.40467 5.78312C1.40467 3.11124 4.11199 0.931556 7.41667 ' +
                '0.931556C10.7214 ' +
                '0.931556 13.4287 3.11124 13.4287 5.78312H14.1672C14.1672 2.68937 ' +
                '11.1438 0.192993 7.41724 ' +
                '0.192993C3.69067 0.192993 0.667236 2.68937 0.667236 ' +
                '5.78312C0.667236 7.22481 1.30005 8.63106 2.42505 ' +
                '9.65031L1.08911 12.0061C1.0188 12.1467 1.0188 12.3227 ' +
                '1.12455 12.4279C1.19486 12.5337 1.30061 12.5686 1.4058 ' +
                '12.5686C1.47611 12.5686 1.51155 12.5686 1.54642 12.5331L5.20267 ' +
                '11.0914C5.51936 11.1972 5.83549 11.2675 6.18705 ' +
                '11.3024L6.2928 10.5638C5.94124 10.4935 5.58967 10.4232 5.27299 ' +
                '10.3174C5.20267 10.3174 5.09692 10.3174 5.02661' +
                ' 10.3529L5.02549 10.3534ZM17.2599 15.2753C18.1739 14.4664 18.6661 13.3769 ' +
                '18.6661 12.1816C18.6661 ' +
                '9.54456 16.0994 7.32999 13.0411 7.32999C9.9828 7.32999 7.41611 9.54512 7.41611' +
                ' 12.1816C7.41611 14.8889' +
                ' 9.87705 17.1389 12.7953 17.1389C13.5339 17.1389 14.237 16.9982 14.9401 16.717L17.788 ' +
                '17.8071H17.9287C18.0344 ' +
                '17.8071 18.1396 17.7717 18.2099 17.7014C18.3157 17.5956 18.3157 17.4201 18.2454 ' +
                '17.2795L17.2599 15.2753ZM14.9047 ' +
                '15.943C14.975 15.943 15.0099 15.943 15.0453 15.9784L17.1547 ' +
                '16.7524L16.4515 15.3462C16.3812 ' +
                '15.2056 16.4167 14.9946 ' +
                '16.5573 14.8889C17.4714 14.1857 17.9287 13.2717 17.9287 12.1816C17.9287 ' +
                '9.96643 15.6787 8.06799 ' +
                '13.0417 8.06799C10.4047 ' +
                '8.06799 8.15467 9.96643 8.15467 12.1816C8.15467 14.4664 10.2989 16.4003 ' +
                '12.7953 16.4003C13.463' +
                ' 16.4003 14.1312 16.2597 ' +
                '14.764 15.9784C14.7989 15.943 14.8692 15.943 14.9047 15.943Z' }),
        React.createElement("circle", { cx: "19.1667", cy: "6", r: "3.5", fill: "#D70000", stroke: "white" })));
};

const SettingsIcon = (props) => {
    const pathD = `
    M10.125 21L9.775 18.1C9.45833 18.0167 9.11267 17.871 8.738 17.663
    C8.36267 17.4543 8.05 17.2333 7.8 17L5.125 18.125L3.25 14.875L5.575 13.125
    C5.54167 12.9583 5.51267 12.779 5.488 12.587C5.46267 12.3957 5.45 12.2083 5.45 12.025
    C5.45 11.8583 5.46267 11.679 5.488 11.487C5.51267 11.2957 5.54167 11.0917 5.575 10.875
    L3.25 9.125L5.125 5.925L7.775 7.025C8.075 6.775 8.396 6.55 8.738 6.35
    C9.07933 6.15 9.41667 6 9.75 5.9L10.125 3H13.875L14.225 5.9
    C14.6083 6.05 14.946 6.20833 15.238 6.375C15.5293 6.54167 15.8333 6.75833 16.15 7.025
    L18.875 5.925L20.75 9.125L18.35 10.925C18.4167 11.125 18.45 11.3127 18.45 11.488V12C18.45 
    12.15 18.446 12.3127 18.438 12.488
    C18.4293 12.6627 18.4 12.875 18.35 13.125L20.7 14.875L18.825 18.125L16.15 16.975C15.8333 17.2417 
    15.521 17.4667 15.213 17.65
    C14.9043 17.8333 14.575 17.9833 14.225 18.1L13.875 21H10.125Z
    M11.975 14.5C12.675 14.5 13.2667 14.2583 13.75 13.775C14.2333 13.2917 14.475 12.7 14.475 12C14.475 
    11.3 14.2333 10.7083 13.75 10.225
    C13.2667 9.74167 12.675 9.5 11.975 9.5C11.275 9.5 10.6833 9.74167 10.2 10.225
    C9.71667 10.7083 9.475 11.3 9.475 12C9.475 12.7 9.71667 13.2917 10.2 13.775
    C10.6833 14.2583 11.275 14.5 11.975 14.5Z
    M11.975 13.5C11.5583 13.5 11.2043 13.354 10.913 13.062
    C10.621 12.7707 10.475 12.4167 10.475 12C10.475 11.5833 10.621 11.2293 10.913 10.938
    C11.2043 10.646 11.5583 10.5 11.975 10.5
    C12.3917 10.5 12.746 10.646 13.038 10.938
    C13.3293 11.2293 13.475 11.5833 13.475 12C13.475 12.4167 13.3293 12.7707 13.038 13.062
    C12.746 13.354 12.3917 13.5 11.975 13.5Z
    M11 20H12.95L13.325 17.3C13.825 17.1667 14.2793 16.9833 14.688 16.75
    C15.096 16.5167 15.5083 16.1917 15.925 15.775L18.4 16.85L19.4 15.15L17.225 13.5
    C17.3083 13.2167 17.3627 12.954 17.388 12.712C17.4127 12.4707 17.425 12.2333 17.425 12
    C17.425 11.75 17.4127 11.5123 17.388 11.287C17.3627 11.0623 17.3083 10.8083 17.225 10.525
    L19.45 8.85L18.45 7.15L15.9 8.225C15.6 7.89167 15.2043 7.579 14.713 7.287
    C14.221 6.99567 13.75 6.8 13.3 6.7L13 4H11L10.7 6.7
    C10.2 6.8 9.73733 6.97067 9.312 7.212C8.88733 7.454 8.46667 7.78333 8.05 8.2
    L5.55 7.15L4.55 8.85L6.725 10.475C6.64167 10.6917 6.58333 10.9333 6.55 11.2
    C6.51667 11.4667 6.5 11.7417 6.5 12.025C6.5 12.275 6.51667 12.525 6.55 12.775
    C6.58333 13.025 6.63333 13.2667 6.7 13.5L4.55 15.15L5.55 16.85L8.025 15.8
    C8.425 16.2 8.83333 16.5167 9.25 16.75C9.66667 16.9833 10.1417 17.1667 10.675 17.3L11 20Z
  `;
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'SettingsIcon' }),
        React.createElement("path", { d: pathD })));
};

const VisibilityIcon = (props) => {
    const pathD = `
    M12.0047 15.1538C13.021 15.1538 13.8832 14.7982 14.5916 14.0868
    C15.2999 13.3755 15.6541 12.5117 15.6541 11.4955
    C15.6541 10.4793 15.2984 9.61698 14.587 8.90865
    C13.8757 8.20032 13.0119 7.84615 11.9957 7.84615
    C10.9795 7.84615 10.1172 8.20182 9.40887 8.91317
    C8.70054 9.62452 8.34637 10.4883 8.34637 11.5045
    C8.34637 12.5207 8.70205 13.383 9.4134 14.0913
    C10.1247 14.7997 10.9885 15.1538 12.0047 15.1538Z
    M12.0002 14.2C11.2502 14.2 10.6127 13.9375 10.0877 13.4125
    C9.56272 12.8875 9.30022 12.25 9.30022 11.5
    C9.30022 10.75 9.56272 10.1125 10.0877 9.5875
    C10.6127 9.0625 11.2502 8.8 12.0002 8.8
    C12.7502 8.8 13.3877 9.0625 13.9127 9.5875
    C14.4377 10.1125 14.7002 10.75 14.7002 11.5
    C14.7002 12.25 14.4377 12.8875 13.9127 13.4125
    C13.3877 13.9375 12.7502 14.2 12.0002 14.2Z
    M12.003 18C9.83704 18 7.86305 17.4106 6.081 16.2317
    C4.29893 15.0529 2.96432 13.4756 2.07715 11.5
    C2.96432 9.52435 4.29802 7.94711 6.07825 6.76828
    C7.85847 5.58943 9.83154 5 11.9975 5
    C14.1634 5 16.1374 5.58943 17.9194 6.76828
    C19.7015 7.94711 21.0361 9.52435 21.9233 11.5
    C21.0361 13.4756 19.7024 15.0529 17.9222 16.2317
    C16.142 17.4106 14.1689 18 12.003 18Z
    M12.0002 17C13.8836 17 15.6127 16.5042 17.1877 15.5125
    C18.7627 14.5208 19.9669 13.1833 20.8002 11.5
    C19.9669 9.81667 18.7627 8.47917 17.1877 7.4875
    C15.6127 6.49583 13.8836 6 12.0002 6
    C10.1169 6 8.38772 6.49583 6.81272 7.4875
    C5.23772 8.47917 4.03356 9.81667 3.20022 11.5
    C4.03356 13.1833 5.23772 14.5208 6.81272 15.5125
    C8.38772 16.5042 10.1169 17 12.0002 17
  `;
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: pathD })));
};

const VisibilityOffIcon = (props) => {
    const pathD = `
    M15.4464 12.6453L14.6502 11.8491C14.8002 10.9761 14.5528 10.2203 13.9079 9.58183
    C13.263 8.94337 12.5105 8.69913 11.6502 8.84913L10.8541 8.05298
    C11.022 7.98375 11.1973 7.93183 11.38 7.89721
    C11.5627 7.86259 11.7695 7.84528 12.0002 7.84528
    C13.0195 7.84528 13.8832 8.19945 14.5916 8.90778
    C15.2999 9.61612 15.6541 10.4799 15.6541 11.4991
    C15.6541 11.7299 15.6368 11.943 15.6021 12.1386
    C15.5675 12.3341 15.5156 12.503 15.4464 12.6453Z
    M18.6079 15.7184L17.8502 15.0491C18.4836 14.5658 19.0461 14.0366 19.5377 13.4616
    C20.0294 12.8866 20.4502 12.2325 20.8002 11.4991
    C19.9669 9.8158 18.7711 8.4783 17.2127 7.48663
    C15.6544 6.49497 13.9169 5.99913 12.0002 5.99913
    C11.5169 5.99913 11.0419 6.03247 10.5752 6.09913
    C10.1086 6.1658 9.65022 6.2658 9.20022 6.39913L8.41945 5.61836
    C9.00022 5.39913 9.59124 5.24111 10.1925 5.14431
    C10.7938 5.04753 11.3964 4.99913 12.0002 4.99913
    C14.1707 4.99913 16.156 5.59561 17.956 6.78856
    C19.756 7.98151 21.0784 9.5517 21.9233 11.4991
    C21.5656 12.303 21.1127 13.0584 20.5646 13.7655
    C20.0166 14.4725 19.3643 15.1235 18.6079 15.7184Z
    M19.7233 21.1376L15.831 17.2568C15.3887 17.453 14.8396 17.6257 14.1839 17.7751
    C13.5281 17.9245 12.8002 17.9991 12.0002 17.9991
    C9.81689 17.9991 7.83163 17.4027 6.04445 16.2097
    C4.25726 15.0168 2.93483 13.4466 2.07715 11.4991
    C2.4656 10.6158 2.97777 9.78856 3.61367 9.01741
    C4.24957 8.24626 4.92842 7.59914 5.65022 7.07606L2.86175 4.27606
    L3.56945 3.56836L20.431 20.4299L19.7233 21.1376Z
    M6.3579 7.78376C5.78483 8.19144 5.19894 8.72733 4.60022 9.39144
    C4.00151 10.0556 3.53484 10.7581 3.20022 11.4991
    C4.03356 13.1825 5.22939 14.52 6.78772 15.5116
    C8.34606 16.5033 10.0836 16.9991 12.0002 16.9991
    C12.5771 16.9991 13.1585 16.943 13.7444 16.8309
    C14.3303 16.7187 14.7707 16.6056 15.0656 16.4914
    L13.4348 14.8491C13.2771 14.9376 13.0573 15.0104 12.7752 15.0674
    C12.4932 15.1245 12.2348 15.153 12.0002 15.153
    C10.981 15.153 10.1172 14.7988 9.40887 14.0905
    C8.70054 13.3822 8.34637 12.5184 8.34637 11.4991
    C8.34637 11.2773 8.3749 11.0286 8.43195 10.753
    C8.489 10.4773 8.56176 10.2478 8.65022 10.0645
    L6.3579 7.78376Z
  `;
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: pathD })));
};

const ErrorFilledIcon = (props) => {
    const pathD = `
    M12 2.99377C6.48 2.99377 2 7.47377 2 12.9938
    C2 18.5138 6.48 22.9938 12 22.9938
    C17.52 22.9938 22 18.5138 22 12.9938
    C22 7.47377 17.52 2.99377 12 2.99377Z
    M13 17.9938H11V15.9938H13V17.9938Z
    M13 13.9938H11V7.99377H13V13.9938Z
  `;
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: pathD })));
};

const Icon = (props) => {
    const pathD = `
    M16.5308 16.9438L10.2693 10.6823C9.76928 11.1079 9.19428 11.4374 8.54428 11.6708
    C7.89428 11.9041 7.24107 12.0208 6.58466 12.0208
    C4.98299 12.0208 3.62745 11.4663 2.51803 10.3575
    C1.4086 9.24871 0.853882 7.89391 0.853882 6.29311
    C0.853882 4.69231 1.40829 3.33645 2.51711 2.22555
    C3.62592 1.11465 4.98073 0.559204 6.58153 0.559204
    C8.18235 0.559204 9.5382 1.11391 10.6491 2.22333
    C11.76 3.33275 12.3154 4.6883 12.3154 6.28998
    C12.3154 6.98485 12.1924 7.65728 11.9462 8.30728
    C11.7001 8.95728 11.377 9.51306 10.977 9.97461
    L17.2385 16.2361L16.5308 16.9438Z
    M6.58466 11.0208C7.91159 11.0208 9.03178 10.564 9.94523 9.65056
    C10.8587 8.73709 11.3154 7.6169 11.3154 6.28998
    C11.3154 4.96306 10.8587 3.84287 9.94523 2.92941
    C9.03178 2.01594 7.91159 1.5592 6.58466 1.5592
    C5.25774 1.5592 4.13755 2.01594 3.22408 2.92941
    C2.31063 3.84287 1.85391 4.96306 1.85391 6.28998
    C1.85391 7.6169 2.31063 8.73709 3.22408 9.65056
    C4.13755 10.564 5.25774 11.0208 6.58466 11.0208
    ZM6.08466 8.67461V6.78998H4.20006V5.78998H6.08466V3.90535H7.08468V5.78998H8.96928V6.78998H7.08468V8.67461H6.08466Z
  `;
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'zoomInIcon' }),
        React.createElement("path", { d: pathD })));
};

const MenuArrowLeft$1 = (props) => {
    const pathD = `
    M1.86272 9L1.33594 8.47266L1.863 8.99972L1.86272 9Z
    M1.86328 9L1.863 9.00028L1.86272 9L1.86244 9.00028L2.601 9.73884H2.60213
    L9.14062 16.2773C9.42188 16.5586 9.42188 17.0857 9.14062 17.4023
    C8.8245 17.6836 8.29688 17.6836 8.01562 17.4023L0.210938 9.59766
    C-0.0703125 9.31641 -0.0703125 8.78934 0.210938 8.47266
    C0.0703125 8.61328 0 8.78934 0 9.00028C0 8.78934 0.0703125 8.54297 0.210938 8.40234
    L8.01562 0.597656C8.29688 0.316406 8.8245 0.316406 9.14062 0.597656
    C9.42188 0.914344 9.42188 1.44141 9.14062 1.72266L2.60156 8.26172H2.601
    L1.863 8.99972L1.86328 9Z
    M1.86328 9L2.60156 8.26172H16.488C16.875 8.26172 17.1562 8.61328 17.1562 9.00028
    C17.1562 9.38728 16.875 9.73884 16.4177 9.73884H2.60213L1.86328 9Z
  `;
    return (React.createElement(SvgIcon, Object.assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", "data-testid": 'zoomInIcon' }),
        React.createElement("path", { d: pathD })));
};

const MenuArrowLeft = (props) => {
    const pathD = `
    M8.0865 0.597656C7.80525 0.914344 7.80525 1.44141 8.0865 1.72266
    L14.625 8.26116H0.738563C0.28125 8.26116 0 8.61272 0 8.99972
    C0 9.38672 0.351563 9.73828 0.738563 9.73828H14.6256L8.0865 16.2773
    C7.80525 16.5586 7.80525 17.0857 8.0865 17.4023
    C8.40263 17.6836 8.93025 17.6836 9.2115 17.4023
    L17.0162 9.59766C17.1568 9.45703 17.2271 9.21066 17.2271 8.99972
    C17.2271 9.21066 17.1568 9.38672 17.0162 9.52734
    C17.2974 9.21066 17.2974 8.68359 17.0162 8.40234
    L9.2115 0.597656C8.93025 0.316406 8.40263 0.316406 8.0865 0.597656
    ZM15.3638 9L15.8912 9.52734L15.3641 8.99972L14.6256 8.26116H14.625
    L15.3638 9Z
  `;
    return (React.createElement(SvgIcon, Object.assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", "data-testid": 'zoomInIcon' }),
        React.createElement("path", { d: pathD })));
};

const OverviewIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { viewBox: '0 -960 960 960', "data-testid": 'overviewIcon' }),
        React.createElement("path", { d: 'M735.385-241.846v-93.539q0-6.461-4.462-10.923-4.461-4.461-10.923-4.461t-10.923 ' +
                '4.461q-4.462 4.462-4.462 10.923v92.77q0 6.461 2.231 12.307t7.462 11.077l61.769 ' +
                '61.769q4.461 4.462 10.538 4.847 6.077.384 11.308-4.847 4.462-4.461 4.462-10.923 ' +
                '0-6.461-4.462-10.923l-62.538-62.538ZM224.615-160q-26.846 0-45.731-18.884Q160-197.769 ' +
                '160-224.615v-510.77q0-26.846 18.884-45.731Q197.769-800 224.615-800h510.77q26.846 0 ' +
                '45.731 18.884Q800-762.231 ' +
                '800-735.385v238q-10.538-3.615-20.154-5.884-9.615-2.27-19.846-4.5v-227.616q0-9.23-7.692-16.923Q744.615-760 ' +
                '735.385-760h-510.77q-9.23 0-16.923 7.692Q200-744.615 200-735.385v510.77q0 9.23 7.692 ' +
                '16.923Q215.385-200 224.615-200h226.616q1.461 11.231 3.731 20.846 2.269 9.616 5.884 ' +
                '19.154H224.615ZM200-240v40-560V-507.769v-3V-240Zm100-89.231q0 8.539 5.731 14.27 5.73 ' +
                '5.73 14.269 5.73h138.385q2.23-10.23 6.038-19.846 3.808-9.615 7.962-20.154H320q-8.539 ' +
                '0-14.269 5.731Q300-337.769 300-329.231ZM300-480q0 8.539 5.731 14.269Q311.461-460 ' +
                '320-460h243.231q19.692-13.846 38.807-23.462 19.116-9.615 ' +
                '41.039-15.077-4.384-1.23-10-1.346-5.615-.115-10-.115H320q-8.539 0-14.269 5.731Q300-488.539 ' +
                '300-480Zm0-150.769q0 8.538 5.731 14.269 5.73 5.731 14.269 5.731h320q8.539 0 ' +
                '14.269-5.731Q660-622.231 660-630.769q0-8.539-5.731-14.27-5.73-5.73-14.269-5.73H320q-8.539 ' +
                '0-14.269 5.73-5.731 5.731-5.731 14.27ZM720-75.384q-66.846 0-113.423-46.577T560-235.385q0-66.846 ' +
                '46.577-113.423T720-395.385q66.846 0 113.423 46.577T880-235.385q0 66.847-46.577 ' +
                '113.424Q786.846-75.384 720-75.384Z' })));
};

const DateRangeIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { viewBox: '0 -960 960 960', "data-testid": 'dateRangeIcon' }),
    React.createElement("path", { d: 'M320-404.615q-12.385 0-21.577-9.193-9.192-9.192-9.192-21.577 0-12.384 9.192-21.577 ' +
            '9.192-9.192 21.577-9.192 12.385 0 21.577 9.192 9.192 9.193 9.192 21.577 0 ' +
            '12.385-9.192 21.577-9.192 9.193-21.577 9.193Zm160 0q-12.385 ' +
            '0-21.577-9.193-9.192-9.192-9.192-21.577 0-12.384 9.192-21.577 9.192-9.192 21.577-9.192 ' +
            '12.385 0 21.577 9.192 9.192 9.193 9.192 21.577 0 12.385-9.192 21.577-9.192 9.193-21.577 ' +
            '9.193Zm160 0q-12.385 0-21.577-9.193-9.192-9.192-9.192-21.577 0-12.384 9.192-21.577 ' +
            '9.192-9.192 21.577-9.192 12.385 0 21.577 9.192 9.192 9.193 9.192 21.577 0 12.385-9.192 ' +
            '21.577-9.192 9.193-21.577 9.193ZM224.615-120Q197-120 178.5-138.5 160-157 ' +
            '160-184.615v-510.77Q160-723 178.5-741.5 197-760 224.615-760h70.769v-67.692q0-9.308 ' +
            '6.116-15.424 6.115-6.115 15.423-6.115t15.423 6.115q6.115 6.116 6.115 ' +
            '15.424V-760h286.154v-69.231q0-8.538 5.731-14.269t14.27-5.731q8.538 0 14.269 5.731t5.731 ' +
            '14.269V-760h70.769Q763-760 781.5-741.5 800-723 800-695.385v510.77Q800-157 781.5-138.5 ' +
            '763-120 735.385-120h-510.77Zm0-40h510.77q9.23 0 16.923-7.692Q760-175.385 ' +
            '760-184.615v-350.77H200v350.77q0 9.23 7.692 16.923Q215.385-160 ' +
            '224.615-160ZM200-575.385h560v-120q0-9.23-7.692-16.923Q744.615-720 ' +
            '735.385-720h-510.77q-9.23 0-16.923 7.692Q200-704.615 200-695.385v120Zm0 ' +
            '0V-720v144.615Z' })));

const CheckBoxSolidIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'checkBoxSolidIcon' }),
    React.createElement("path", { d: 'M5.625 20C5.15833 20 4.771 19.846 4.463 19.538C4.15433 19.2293 4 ' +
            '18.8417 4 18.375V5.625C4 5.15833 4.15433 4.771 4.463 4.463C4.771 ' +
            '4.15433 5.15833 4 5.625 4H18.375C18.8417 4 19.2293 4.15433 19.538 ' +
            '4.463C19.846 4.771 20 5.15833 20 5.625V18.375C20 18.8417 19.846 ' +
            '19.2293 19.538 19.538C19.2293 19.846 18.8417 20 18.375 20H5.625Z', fill: props.fill }),
    React.createElement("path", { d: 'M10.6297 15.3333L7.8335 12.5371L8.63472 11.7359L10.6297 ' +
            '13.7308L15.6939 8.66663L16.4952 9.46785L10.6297 15.3333Z', fill: "white" })));

const KidIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'kidIcon' }),
    React.createElement("path", { d: 'M14.4 11.45C14.1333 11.45 13.9083 11.3583 13.725 11.175C13.5417 10.9917 13.45 10.7667 13.45 ' +
            '10.5C13.45 10.2333 13.5377 10.0083 13.713 9.825C13.8877 9.64167 14.1083 9.55 14.375 ' +
            '9.55C14.6417 9.55 14.8667 9.64167 15.05 9.825C15.2333 10.0083 15.325 10.2333 15.325 ' +
            '10.5C15.325 10.7667 15.2333 10.9917 15.05 11.175C14.8667 11.3583 14.65 11.45 14.4 ' +
            '11.45ZM9.625 11.45C9.35833 11.45 9.13333 11.3583 8.95 11.175C8.76667 10.9917 8.675 ' +
            '10.7667 8.675 10.5C8.675 10.2333 8.76667 10.0083 8.95 9.825C9.13333 9.64167 9.35 ' +
            '9.55 9.6 9.55C9.86667 9.55 10.0917 9.64167 10.275 9.825C10.4583 10.0083 10.55 ' +
            '10.2333 10.55 10.5C10.55 10.7667 10.4627 10.9917 10.288 11.175C10.1127 11.3583 ' +
            '9.89167 11.45 9.625 11.45ZM12 16.225C11.2 16.225 10.4627 16.025 9.788 15.625C9.11267 ' +
            '15.225 8.56667 14.6833 8.15 14H15.85C15.4333 14.6833 14.8877 15.225 14.213 ' +
            '15.625C13.5377 16.025 12.8 16.225 12 16.225ZM12 20C10.8833 20 9.84167 19.7917 ' +
            '8.875 19.375C7.90833 18.9583 7.06267 18.3877 6.338 17.663C5.61267 16.9377 5.04167 ' +
            '16.0917 4.625 15.125C4.20833 14.1583 4 13.1167 4 12C4 10.8833 4.20833 9.84167 ' +
            '4.625 8.875C5.04167 7.90833 5.61267 7.06267 6.338 6.338C7.06267 5.61267 7.90833 ' +
            '5.04167 8.875 4.625C9.84167 4.20833 10.8833 4 12 4C13.1167 4 14.1583 4.20833 15.125 ' +
            '4.625C16.0917 5.04167 16.9377 5.61267 17.663 6.338C18.3877 7.06267 18.9583 7.90833 ' +
            '19.375 8.875C19.7917 9.84167 20 10.8833 20 12C20 13.1167 19.7917 14.1583 19.375 ' +
            '15.125C18.9583 16.0917 18.3877 16.9377 17.663 17.663C16.9377 18.3877 16.0917 18.9583 ' +
            '15.125 19.375C14.1583 19.7917 13.1167 20 12 20ZM12 19C13.9333 19 15.5833 18.3167 ' +
            '16.95 16.95C18.3167 15.5833 19 13.9333 19 12C19 10.0667 18.3167 8.41667 16.95 ' +
            '7.05C15.5833 5.68333 13.9333 5 12 5C11.8167 5 11.6333 5.00833 11.45 5.025C11.2667 ' +
            '5.04167 11.1 5.06667 10.95 5.1C10.9 5.21667 10.871 5.32067 10.863 5.412C10.8543 ' +
            '5.504 10.85 5.61667 10.85 5.75C10.85 6.18333 11 6.55 11.3 6.85C11.6 7.15 11.9667 ' +
            '7.3 12.4 7.3C12.5833 7.3 12.7293 7.275 12.838 7.225C12.946 7.175 13.0667 7.15 13.2 ' +
            '7.15C13.3167 7.15 13.4127 7.19567 13.488 7.287C13.5627 7.379 13.6 7.48333 13.6 ' +
            '7.6C13.6 7.83333 13.471 7.99167 13.213 8.075C12.9543 8.15833 12.6833 8.2 12.4 ' +
            '8.2C11.7333 8.2 11.1583 7.95833 10.675 7.475C10.1917 6.99167 9.95 6.41667 9.95 ' +
            '5.75V5.537C9.95 5.479 9.96667 5.4 10 5.3C8.55 5.73333 7.354 6.554 6.412 7.762C5.47067 ' +
            '8.97067 5 10.3833 5 12C5 13.9333 5.68333 15.5833 7.05 16.95C8.41667 18.3167 10.0667 ' +
            '19 12 19Z' })));

var RemoveCircleOutlineOutlined = {};

var _interopRequireDefault$1 = interopRequireDefaultExports;
Object.defineProperty(RemoveCircleOutlineOutlined, "__esModule", {
  value: true
});
var default_1$1 = RemoveCircleOutlineOutlined.default = void 0;
var _createSvgIcon$1 = _interopRequireDefault$1(requireCreateSvgIcon());
var _jsxRuntime$1 = require$$2$1;
default_1$1 = RemoveCircleOutlineOutlined.default = (0, _createSvgIcon$1.default)( /*#__PURE__*/(0, _jsxRuntime$1.jsx)("path", {
  d: "M7 11v2h10v-2zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'RemoveCircleOutlineOutlined');

const NotStartedIcon = default_1$1;

const FilterOutlinedIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "FilterOutlinedIcon" }),
    React.createElement("path", { d: 'M11.7954 19C11.5761 19 11.3931 18.9266 11.2463 18.7798C11.0995 18.633 11.0262 ' +
            '18.45 11.0262 18.2308V12.6539L5.63001 5.83077C5.49539 5.65127 5.47711 5.46794 ' +
            '5.57518 5.28077C5.67326 5.09359 5.83 5 6.04538 5H18.0069C18.2223 5 18.379 5.09359 ' +
            '18.4771 5.28077C18.5752 5.46794 18.5569 5.65127 18.4223 5.83077L13.0262 ' +
            '12.6539V18.2308C13.0262 18.45 12.9528 18.633 12.806 18.7798C12.6592 18.9266 ' +
            '12.4762 19 12.2569 19H11.7954ZM12.0262 12.3L16.9762 6H7.07616L12.0262 12.3Z' })));

const FilterSolidIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "FilterSolidIcon" }),
    React.createElement("path", { d: "M11.7695 18.9999C11.5503 18.9999 11.3673 18.9265 11.2205 18.7797C11.0737\n    18.6329 11.0003 18.4499 11.0003 18.2307V12.6537L5.60413 5.83065C5.46951 5.65115\n    5.45123 5.46782 5.5493 5.28065C5.64738 5.09347 5.80412 4.99988 6.0195\n     4.99988H17.9811C18.1964 4.99988 18.3532 5.09347 18.4513 5.28065C18.5493 5.46782\n     18.531 5.65115 18.3964 5.83065L13.0003 12.6537V18.2307C13.0003 18.4499 12.9269\n     18.6329 12.7801 18.7797C12.6333 18.9265 12.4503 18.9999 12.2311 18.9999H11.7695Z" })));

var CheckCircle = {};

var _interopRequireDefault = interopRequireDefaultExports;
Object.defineProperty(CheckCircle, "__esModule", {
  value: true
});
var default_1 = CheckCircle.default = void 0;
var _createSvgIcon = _interopRequireDefault(requireCreateSvgIcon());
var _jsxRuntime = require$$2$1;
default_1 = CheckCircle.default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), 'CheckCircle');

const CheckCircleFilledIcon = (props) => (React.createElement(default_1, Object.assign({ "data-testid": 'CheckCircleFilledIcon' }, props)));

const VerifiedUserIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "VerifiedUserIcon" }),
        React.createElement("path", { d: 'M10.95 14.8577L15.9077 9.89998L15.1942 9.1865L10.95 13.4308L8.81155 ' +
                '11.2923L8.09808 12.0058L10.95 14.8577ZM12 20.9615C9.99102 20.3654 ' +
                '8.32211 19.1484 6.99327 17.3106C5.66442 15.4727 5 13.4025 5 ' +
                '11.1V5.69228L12 3.0769L19 5.69228V11.1C19 13.4025 18.3356 15.4727 ' +
                '17.0067 17.3106C15.6779 19.1484 14.009 20.3654 12 20.9615ZM12 ' +
                '19.9C13.7333 19.35 15.1667 18.25 16.3 16.6C17.4333 14.95 18 13.1166 ' +
                '18 11.1V6.37498L12 4.1442L6 6.37498V11.1C6 13.1166 6.56667 14.95 7.7 ' +
                '16.6C8.83333 18.25 10.2667 19.35 12 19.9Z' })));
};

const TouchAppIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "TouchAppIcon" }),
        React.createElement("path", { d: 'M11.1673 21C10.6237 21 10.1061 20.8872 9.61441 20.6616C9.12275 20.4359 ' +
                '8.71601 20.1077 8.39421 19.6769L3.65576 13.4058L3.91921 13.1173C4.08588 ' +
                '12.934 4.28395 12.8218 4.51344 12.7808C4.74294 12.7397 4.96153 12.7801 ' +
                '5.16921 12.9019L8.19229 14.3923V6.76923C8.19229 6.62756 8.24027 6.50881 ' +
                '8.33624 6.41298C8.4322 6.31714 8.55111 6.26923 8.69296 6.26923C8.83483 ' +
                '6.26923 8.95448 6.31714 9.05191 6.41298C9.14935 6.50881 9.19806 6.62756 ' +
                '9.19806 6.76923V16.0885L5.61924 14.3193L9.25769 19.125C9.48589 19.4212 ' +
                '9.76922 19.641 10.1077 19.7846C10.4461 19.9282 10.7993 20 11.1673 ' +
                '20H15.4808C16.1846 20 16.7804 19.7593 17.2683 19.2779C17.7561 18.7965 ' +
                '18 18.2039 18 17.5V13.9616C18 13.5583 17.8636 13.2204 17.5909 ' +
                '12.9476C17.3181 12.6749 16.9801 12.5385 16.5769 ' +
                '12.5385H11.9673V11.5385H16.5769C17.25 11.5385 17.8221 11.774 18.2933 ' +
                '12.2452C18.7644 12.7164 19 13.2885 19 13.9616V17.4987C19 18.4714 ' +
                '18.6554 19.2981 17.9662 19.9789C17.277 20.6596 16.4485 21 15.4808 ' +
                '21H11.1673ZM5.23266 8.76923C5.05446 8.46666 4.91985 8.14688 4.82884 ' +
                '7.8099C4.7378 7.47292 4.69229 7.12603 4.69229 6.76923C4.69229 5.65513 ' +
                '5.08043 4.70994 5.85671 3.93365C6.63299 3.15737 7.57819 2.76923 8.69229 ' +
                '2.76923C9.8064 2.76923 10.7516 3.15737 11.5279 3.93365C12.3042 4.70994 ' +
                '12.6923 5.65431 12.6923 6.76678C12.6923 7.12866 12.6468 7.47723 12.5558 ' +
                '7.8125C12.4647 8.14775 12.3301 8.46666 12.1519 8.76923L11.2923 ' +
                '8.26923C11.4256 8.03589 11.5256 7.79839 11.5923 7.55673C11.659 7.31506 ' +
                '11.6923 7.05256 11.6923 6.76923C11.6923 5.93589 11.4006 5.22756 10.8173 ' +
                '4.64423C10.234 4.06089 9.52562 3.76923 8.69229 3.76923C7.85895 3.76923 ' +
                '7.15062 4.06089 6.56729 4.64423C5.98395 5.22756 5.69229 5.93589 5.69229 ' +
                '6.76923C5.69229 7.05256 5.72562 7.31506 5.79229 7.55673C5.85895 7.79839 ' +
                '5.95895 8.03589 6.09229 8.26923L5.23266 8.76923Z' })));
};

const RealEstateAgentIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "RealEstateAgentIcon" }),
        React.createElement("path", { d: 'M19.5008 14.25V7.225L14.0008 3.375L8.50078 7.225V9.925H7.50078V6.75L14.0008 ' +
                '2.125L20.5008 6.75V14.25H19.5008ZM14.6008 ' +
                '7.9H15.4008V7.1H14.6008V7.9ZM12.6008 7.9H13.4008V7.1H12.6008V7.9ZM14.6008 ' +
                '9.9H15.4008V9.1H14.6008V9.9ZM12.6008 9.9H13.4008V9.1H12.6008V9.9ZM13.6508 ' +
                '21.075L6.05078 18.85V20.15H2.05078V12H8.40078L14.4508 14.225C14.8174 ' +
                '14.3583 15.1298 14.6 15.3878 14.95C15.6464 15.3 15.7758 15.75 15.7758 ' +
                '16.3H18.7758C19.3758 16.3 19.8384 16.5127 20.1638 16.938C20.4884 ' +
                '17.3627 20.6508 17.925 20.6508 18.625V18.875L13.6508 21.075ZM3.05078 ' +
                '19.15H5.05078V13H3.05078V19.15ZM13.6008 20.025L19.6008 18.175C19.5841 ' +
                '17.9083 19.5008 17.696 19.3508 17.538C19.2008 17.3793 19.0091 17.3 ' +
                '18.7758 17.3H14.0758C13.6258 17.3 13.1801 17.2707 12.7388 17.212C12.2968 ' +
                '17.154 11.8924 17.0583 11.5258 16.925L9.60078 16.3L9.95078 15.325L11.8508 ' +
                '15.975C12.1841 16.0917 12.5634 16.175 12.9888 16.225C13.4134 16.275 ' +
                '14.0091 16.3 14.7758 16.3C14.7758 16 14.7174 15.754 14.6008 15.562C14.4841 ' +
                '15.3707 14.3174 15.2333 14.1008 15.15L8.25078 13H6.05078V17.8L13.6008 ' +
                '20.025Z' })));
};

const QualifyIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "QualifyIcon" }),
        React.createElement("path", { d: 'M5.61538 20C5.15513 20 4.77083 19.8458 4.4625 19.5375C4.15417 ' +
                '19.2292 4 18.8449 4 18.3846V5.61537C4 5.15512 4.15417 4.77083 ' +
                '4.4625 4.4625C4.77083 4.15417 5.15513 4 5.61538 4H10.3154C10.241 ' +
                '3.47692 10.3705 3.01281 10.7038 2.60768C11.0372 2.20256 11.4692 ' +
                '2 12 2C12.5308 2 12.9628 2.20256 13.2962 2.60768C13.6295 3.01281 ' +
                '13.759 3.47692 13.6846 4H18.3846C18.8449 4 19.2292 4.15417 19.5375' +
                ' 4.4625C19.8458 4.77083 20 5.15512 20 5.61537V18.3846C20 18.8449 ' +
                '19.8458 19.2292 19.5375 19.5375C19.2292 19.8458 18.8449 20 18.3846 ' +
                '20H5.61538ZM12 4.4423C12.2167 4.4423 12.3958 4.37147 12.5375 ' +
                '4.2298C12.6792 4.08813 12.75 3.90897 12.75 3.6923C12.75 3.47563 ' +
                '12.6792 3.29647 12.5375 3.1548C12.3958 3.01313 12.2167 2.9423 ' +
                '12 2.9423C11.7833 2.9423 11.6042 3.01313 11.4625 3.1548C11.3208 ' +
                '3.29647 11.25 3.47563 11.25 3.6923C11.25 3.90897 11.3208 ' +
                '4.08813 11.4625 4.2298C11.6042 4.37147 11.7833 4.4423 12 ' +
                '4.4423ZM5 18.2346C5.9 17.3513 6.94583 16.6555 8.1375 ' +
                '16.1471C9.32917 15.6388 10.6167 15.3846 12 15.3846C13.3833 ' +
                '15.3846 14.6708 15.6388 15.8625 16.1471C17.0542 16.6555 18.1 ' +
                '17.3513 19 18.2346V5.61537C19 5.46154 18.9359 5.32052 18.8077' +
                ' 5.1923C18.6795 5.0641 18.5385 5 18.3846 5H5.61538C5.46154 5 ' +
                '5.32052 5.0641 5.1923 5.1923C5.0641 5.32052 5 5.46154 5' +
                ' 5.61537V18.2346ZM12 13.0769C12.8385 13.0769 13.5481 12.7865 ' +
                '14.1288 12.2058C14.7096 11.625 15 10.9154 15 10.0769C15 9.23846 ' +
                '14.7096 8.52884 14.1288 7.94807C13.5481 7.36731 12.8385 7.07693 ' +
                '12 7.07693C11.1615 7.07693 10.4519 7.36731 9.87115 7.94807C9.29038 ' +
                '8.52884 9 9.23846 9 10.0769C9 10.9154 9.29038 11.625 9.87115 ' +
                '12.2058C10.4519 12.7865 11.1615 13.0769 12 13.0769ZM5.88462 ' +
                '19H18.1154V18.8269C17.2359 18 16.2782 17.3862 15.2423 16.9856C14.2064 ' +
                '16.5849 13.1256 16.3846 12 16.3846C10.9 16.3846 9.82885 16.5817 ' +
                '8.78655 16.976C7.74423 17.3702 6.77692 17.9743 5.88462 18.7885V19ZM12 ' +
                '12.0769C11.4551 12.0769 10.9856 11.8798 10.5914 11.4856C10.1971 ' +
                '11.0913 10 10.6218 10 10.0769C10 9.53206 10.1971 9.06251 10.5914 ' +
                '8.66828C10.9856 8.27404 11.4551 8.07693 12 8.07693C12.5449 8.07693 ' +
                '13.0144 8.27404 13.4087 8.66828C13.8029 9.06251 14 9.53206 14 ' +
                '10.0769C14 10.6218 13.8029 11.0913 13.4087 11.4856C13.0144 11.8798 ' +
                '12.5449 12.0769 12 12.0769Z' })));
};

const PhotoCameraIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "PhotoCameraIcon" }),
        React.createElement("path", { d: 'M12 16.7308C13.0449 16.7308 13.9279 16.3702 14.649 15.6491C15.3702 14.9279 ' +
                '15.7308 14.0449 15.7308 13C15.7308 11.9551 15.3702 11.0721 14.649 ' +
                '10.351C13.9279 9.6298 13.0449 9.26922 12 9.26922C10.9551 9.26922 10.0721 ' +
                '9.6298 9.35095 10.351C8.6298 11.0721 8.26923 11.9551 8.26923 13C8.26923 ' +
                '14.0449 8.6298 14.9279 9.35095 15.6491C10.0721 16.3702 10.9551 16.7308 12 ' +
                '16.7308ZM12 15.7308C11.2231 15.7308 10.5737 15.4699 10.0519 14.9481C9.53013 ' +
                '14.4263 9.26923 13.7769 9.26923 13C9.26923 12.2231 9.53013 11.5737 10.0519 ' +
                '11.0519C10.5737 10.5301 11.2231 10.2692 12 10.2692C12.7769 10.2692 13.4263 ' +
                '10.5301 13.9481 11.0519C14.4699 11.5737 14.7308 12.2231 14.7308 13C14.7308 ' +
                '13.7769 14.4699 14.4263 13.9481 14.9481C13.4263 15.4699 12.7769 15.7308 12 ' +
                '15.7308ZM4.61538 20C4.15513 20 3.77083 19.8458 3.4625 19.5375C3.15417 19.2292 ' +
                '3 18.8449 3 18.3846V7.61537C3 7.15512 3.15417 6.77083 3.4625 6.4625C3.77083 ' +
                '6.15417 4.15513 6 4.61538 6H7.57308L9.42308 4H14.5769L16.4269 6H19.3846C19.8449 ' +
                '6 20.2292 6.15417 20.5375 6.4625C20.8458 6.77083 21 7.15512 21 ' +
                '7.61537V18.3846C21 18.8449 20.8458 19.2292 20.5375 19.5375C20.2292 19.8458 ' +
                '19.8449 20 19.3846 20H4.61538ZM4.61538 19H19.3846C19.5641 19 19.7115 18.9423 ' +
                '19.8269 18.8269C19.9423 18.7115 20 18.5641 20 18.3846V7.61537C20 7.43589 ' +
                '19.9423 7.28846 19.8269 7.17307C19.7115 7.05769 19.5641 7 19.3846 ' +
                '7H15.9885L14.1442 5H9.85577L8.01155 7H4.61538C4.43589 7 4.28846 7.05769 ' +
                '4.17308 7.17307C4.05769 7.28846 4 7.43589 4 7.61537V18.3846C4 18.5641 ' +
                '4.05769 18.7115 4.17308 18.8269C4.28846 18.9423 4.43589 19 4.61538 19Z' })));
};

const PersonCheckIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "PersonCheckIcon" }),
        React.createElement("path", { d: 'M17.55 11.2885L14.7115 8.44998L15.425 7.76151L17.55 9.88651L21.8 ' +
                '5.63651L22.5077 6.34998L17.55 11.2885ZM9 11.3846C8.175 11.3846 ' +
                '7.46875 11.0909 6.88125 10.5034C6.29375 9.91586 6 9.20961 6 ' +
                '8.38461C6 7.55959 6.29375 6.85333 6.88125 6.26583C7.46875 5.67833 ' +
                '8.175 5.38458 9 5.38458C9.825 5.38458 10.5313 5.67833 11.1188 ' +
                '6.26583C11.7063 6.85333 12 7.55959 12 8.38461C12 9.20961 11.7063 ' +
                '9.91586 11.1188 10.5034C10.5313 11.0909 9.825 11.3846 9 11.3846ZM2 ' +
                '18.6154V16.9692C2 16.5564 2.12019 16.1702 2.36057 15.8106C2.60096 ' +
                '15.4509 2.92436 15.1718 3.33078 14.9731C4.27436 14.5205 5.21858 ' +
                '14.1811 6.16345 13.9548C7.10833 13.7285 8.05385 13.6154 9 ' +
                '13.6154C9.94615 13.6154 10.8917 13.7285 11.8366 13.9548C12.7814 ' +
                '14.1811 13.7256 14.5205 14.6692 14.9731C15.0756 15.1718 15.399 ' +
                '15.4509 15.6394 15.8106C15.8798 16.1702 16 16.5564 16 ' +
                '16.9692V18.6154H2ZM3 17.6154H15V16.9692C15 16.7474 14.9285 ' +
                '16.5391 14.7856 16.3442C14.6426 16.1493 14.4449 15.9846 14.1923 ' +
                '15.85C13.3692 15.4513 12.5206 15.1458 11.6464 14.9336C10.7722 ' +
                '14.7215 9.89008 14.6154 9 14.6154C8.10992 14.6154 7.22778 ' +
                '14.7215 6.3536 14.9336C5.4794 15.1458 4.63077 15.4513 3.8077 ' +
                '15.85C3.55513 15.9846 3.35737 16.1493 3.21442 16.3442C3.07148 ' +
                '16.5391 3 16.7474 3 16.9692V17.6154ZM9 10.3846C9.55 10.3846 ' +
                '10.0208 10.1888 10.4125 9.79711C10.8042 9.40544 11 8.93461 11 ' +
                '8.38461C11 7.83461 10.8042 7.36378 10.4125 6.97211C10.0208 6.58044 ' +
                '9.55 6.38461 9 6.38461C8.45 6.38461 7.97917 6.58044 7.5875 ' +
                '6.97211C7.19583 7.36378 7 7.83461 7 8.38461C7 8.93461 7.19583 ' +
                '9.40544 7.5875 9.79711C7.97917 10.1888 8.45 10.3846 9 10.3846Z' })));
};

const PersonAlertIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "PersonAlertIcon" }),
        React.createElement("path", { d: 'M20.0007 10.7308C19.7938 10.7308 19.6202 10.6608 19.4798 10.5209C19.3394 ' +
                '10.3809 19.2692 10.2075 19.2692 10.0007C19.2692 9.79381 19.3392 ' +
                '9.62018 19.4791 9.4798C19.6191 9.33942 19.7925 9.26922 19.9993 ' +
                '9.26922C20.2062 9.26922 20.3798 9.33919 20.5202 9.47912C20.6606 ' +
                '9.61906 20.7308 9.79246 20.7308 9.99933C20.7308 10.2062 20.6608 ' +
                '10.3798 20.5209 10.5202C20.3809 10.6606 20.2075 10.7308 20.0007 ' +
                '10.7308ZM19.5 7.5V3.5H20.5V7.5H19.5ZM9 11.3846C8.175 11.3846 ' +
                '7.46875 11.0909 6.88125 10.5034C6.29375 9.91588 6 9.20963 6 ' +
                '8.38463C6 7.55961 6.29375 6.85335 6.88125 6.26585C7.46875 5.67835 ' +
                '8.175 5.3846 9 5.3846C9.825 5.3846 10.5313 5.67835 11.1188 ' +
                '6.26585C11.7063 6.85335 12 7.55961 12 8.38463C12 9.20963 ' +
                '11.7063 9.91588 11.1188 10.5034C10.5313 11.0909 9.825 11.3846 9 ' +
                '11.3846ZM2 18.6154V16.9692C2 16.5564 2.12019 16.1702 2.36057 ' +
                '15.8106C2.60096 15.451 2.92436 15.1718 3.33078 14.9731C4.27436 ' +
                '14.5205 5.21858 14.1811 6.16345 13.9548C7.10833 13.7285 8.05385 ' +
                '13.6154 9 13.6154C9.94615 13.6154 10.8917 13.7285 11.8366 ' +
                '13.9548C12.7814 14.1811 13.7256 14.5205 14.6692 14.9731C15.0756 ' +
                '15.1718 15.399 15.451 15.6394 15.8106C15.8798 16.1702 16 16.5564 ' +
                '16 16.9692V18.6154H2ZM3 17.6154H15V16.9692C15 16.7474 14.9285 ' +
                '16.5391 14.7856 16.3442C14.6426 16.1494 14.4449 15.9846 14.1923 ' +
                '15.85C13.3692 15.4513 12.5206 15.1458 11.6464 14.9337C10.7722 ' +
                '14.7215 9.89008 14.6154 9 14.6154C8.10992 14.6154 7.22778 ' +
                '14.7215 6.3536 14.9337C5.4794 15.1458 4.63077 15.4513 3.8077 ' +
                '15.85C3.55513 15.9846 3.35737 16.1494 3.21442 16.3442C3.07148 ' +
                '16.5391 3 16.7474 3 16.9692V17.6154ZM9 10.3846C9.55 10.3846 ' +
                '10.0208 10.1888 10.4125 9.79713C10.8042 9.40546 11 8.93463 11 ' +
                '8.38463C11 7.83463 10.8042 7.36379 10.4125 6.97213C10.0208 ' +
                '6.58046 9.55 6.38463 9 6.38463C8.45 6.38463 7.97917 6.58046 ' +
                '7.5875 6.97213C7.19583 7.36379 7 7.83463 7 8.38463C7 8.93463 ' +
                '7.19583 9.40546 7.5875 9.79713C7.97917 10.1888 8.45 10.3846 9 10.3846Z' })));
};

const PaymentsIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "PaymentsIcon" }),
        React.createElement("path", { d: 'M13.5001 12.4231C12.936 12.4231 12.4616 12.2308 12.077 11.8462C11.6924 ' +
                '11.4616 11.5001 10.9872 11.5001 10.4231C11.5001 9.859 11.6924 9.38464 ' +
                '12.077 9.00002C12.4616 8.61541 12.936 8.4231 13.5001 8.4231C14.0642 ' +
                '8.4231 14.5385 8.61541 14.9232 9.00002C15.3078 9.38464 15.5001 9.859 ' +
                '15.5001 10.4231C15.5001 10.9872 15.3078 11.4616 14.9232 ' +
                '11.8462C14.5385 12.2308 14.0642 12.4231 13.5001 12.4231ZM7.30778 ' +
                '15.6154C6.86355 15.6154 6.48326 15.4572 6.16691 15.1409C5.85056 ' +
                '14.8245 5.69238 14.4443 5.69238 14V6.84617C5.69238 6.40194 5.85056 ' +
                '6.02165 6.16691 5.7053C6.48326 5.38895 6.86355 5.23077 7.30778 ' +
                '5.23077H19.6924C20.1366 5.23077 20.5169 5.38895 20.8333 ' +
                '5.7053C21.1496 6.02165 21.3078 6.40194 21.3078 6.84617V14C21.3078 ' +
                '14.4443 21.1496 14.8245 20.8333 15.1409C20.5169 15.4572 20.1366 ' +
                '15.6154 19.6924 15.6154H7.30778ZM8.30778 14.6154H18.6924C18.6924 ' +
                '14.168 18.8506 13.7869 19.1669 13.4721C19.4833 13.1574 19.8636 13 ' +
                '20.3078 13V7.84617C19.8603 7.84617 19.4793 7.688 19.1645 7.37165C18.8498 ' +
                '7.05532 18.6924 6.67503 18.6924 6.2308H8.30778C8.30778 6.67823 8.14961 ' +
                '7.05932 7.83326 7.37407C7.51691 7.68881 7.13662 7.84617 6.69238 ' +
                '7.84617V13C7.13983 13 7.52093 13.1582 7.83566 13.4745C8.15041 ' +
                '13.7909 8.30778 14.1712 8.30778 14.6154ZM18.3463 18.6154H4.30776C3.86352 ' +
                '18.6154 3.48324 18.4572 3.16691 18.1409C2.85056 17.8245 2.69238 17.4443 ' +
                '2.69238 17V8.19232H3.69238V17C3.69238 17.1539 3.75648 17.2949 3.88468 ' +
                '17.4231C4.0129 17.5513 4.15392 17.6154 4.30776 ' +
                '17.6154H18.3463V18.6154ZM7.30778 14.6154H6.69238V6.2308H7.30778C7.14112 ' +
                '6.2308 6.99688 6.29169 6.87508 6.41348C6.75328 6.53527 6.69238 6.67951 ' +
                '6.69238 6.84617V14C6.69238 14.1667 6.75328 14.3109 6.87508 ' +
                '14.4327C6.99688 14.5545 7.14112 14.6154 7.30778 14.6154Z' })));
};

const MoneyAltIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "MoneyAltIcon" }),
        React.createElement("path", { d: 'M11.475 18.625H12.475V17.45C13.1917 17.3833 13.8793 17.121 14.538 ' +
                '16.663C15.196 16.2043 15.525 15.5 15.525 14.55C15.525 13.85 15.3123 ' +
                '13.254 14.887 12.762C14.4623 12.2707 13.65 11.8083 12.45 11.375C11.3333 ' +
                '10.9917 10.625 10.6623 10.325 10.387C10.025 10.1123 9.875 9.71667 ' +
                '9.875 9.2C9.875 8.68333 10.071 8.25833 10.463 7.925C10.8543 7.59167 ' +
                '11.3833 7.425 12.05 7.425C12.55 7.425 12.9707 7.54167 13.312 ' +
                '7.775C13.654 8.00833 13.9333 8.3 14.15 8.65L15 8.3C14.7667 7.81667 ' +
                '14.425 7.41667 13.975 7.1C13.525 6.78333 13.0417 6.6 12.525 ' +
                '6.55V5.375H11.525V6.55C10.6583 6.7 10 7.029 9.55 7.537C9.1 ' +
                '8.04567 8.875 8.6 8.875 9.2C8.875 9.91667 9.104 10.4917 9.562 ' +
                '10.925C10.0207 11.3583 10.7833 11.7667 11.85 12.15C12.9333 ' +
                '12.55 13.6583 12.9083 14.025 13.225C14.3917 13.5417 14.575 ' +
                '13.9833 14.575 14.55C14.575 15.25 14.3167 15.754 13.8 16.062C13.2833 ' +
                '16.3707 12.7333 16.525 12.15 16.525C11.5667 16.525 11.046 16.3583 ' +
                '10.588 16.025C10.1293 15.6917 9.75833 15.2167 9.475 14.6L8.6 ' +
                '14.975C8.88333 15.6583 9.26667 16.1917 9.75 16.575C10.2333 ' +
                '16.9583 10.8083 17.2333 11.475 17.4V18.625ZM12 21C10.75 21 ' +
                '9.57933 20.7627 8.488 20.288C7.396 19.8127 6.446 19.1707 5.638 ' +
                '18.362C4.82933 17.554 4.18733 16.604 3.712 15.512C3.23733 14.4207 3 ' +
                '13.25 3 12C3 10.75 3.23733 9.579 3.712 8.487C4.18733 7.39567 4.82933 ' +
                '6.44567 5.638 5.637C6.446 4.829 7.396 4.18733 8.488 3.712C9.57933 ' +
                '3.23733 10.75 3 12 3C13.25 3 14.421 3.23733 15.513 3.712C16.6043 ' +
                '4.18733 17.5543 4.829 18.363 5.637C19.171 6.44567 19.8127 7.39567 ' +
                '20.288 8.487C20.7627 9.579 21 10.75 21 12C21 13.25 20.7627 14.4207 ' +
                '20.288 15.512C19.8127 16.604 19.171 17.554 18.363 18.362C17.5543 ' +
                '19.1707 16.6043 19.8127 15.513 20.288C14.421 20.7627 13.25 21 12 ' +
                '21ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 ' +
                '14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 ' +
                '14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 ' +
                '9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 ' +
                '20 12 20Z' })));
};

const FamilyHomeIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "FamilyHomeIcon" }),
        React.createElement("path", { d: 'M11.9998 4.26923L21.5767 11.4423L20.9536 12.2346L18.9998 ' +
                '10.7692V20H4.99978V10.7692L3.04593 12.2346L2.42285 11.4423L11.9998 ' +
                '4.26923ZM8.50363 12.4684C8.50363 13.1369 8.86324 13.8494 9.58245 ' +
                '14.6058C10.3017 15.3622 11.1075 16.1475 11.9998 16.9616C12.9177 16.1475 ' +
                '13.7363 15.3627 14.4556 14.6073C15.1748 13.8519 15.5344 13.1405 15.5344 ' +
                '12.4733C15.5344 11.9193 15.3445 11.4583 14.9647 11.0904C14.5849 10.7224 ' +
                '14.1291 10.5385 13.5974 10.5385C13.2682 10.5385 12.9693 10.6067 12.7008 ' +
                '10.7433C12.4322 10.8798 12.1985 11.0513 11.9998 11.2577C11.8267 11.0513 ' +
                '11.6007 10.8798 11.3219 10.7433C11.0431 10.6067 10.7512 10.5385 10.4465 ' +
                '10.5385C9.91314 10.5385 9.456 10.7214 9.07505 11.0872C8.6941 11.453 ' +
                '8.50363 11.9134 8.50363 12.4684ZM17.9998 19V10L11.9998 5.5L5.99978 ' +
                '10V19H17.9998Z' })));
};

const EmojiPeopleIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "EmojiPeopleIcon" }),
        React.createElement("path", { d: 'M9.80762 21.5V8.33269C8.56018 8.09936 7.52718 7.50224 6.70859 ' +
                '6.54134C5.88999 5.58044 5.423 4.46409 5.30762 3.19229H6.30764C6.43584 ' +
                '4.39614 6.92654 5.40223 7.77974 6.21057C8.63296 7.0189 9.62303 7.42307 ' +
                '10.7499 7.42307H13.2499C13.6346 7.42307 13.9602 7.47948 14.2269 ' +
                '7.59229C14.4935 7.70511 14.7634 7.89806 15.0365 8.17114L19.273 ' +
                '12.4077L18.5653 13.1154L14.1923 ' +
                '8.74232V21.5H13.1922V15.6154H10.8076V21.5H9.80762ZM11.9999 ' +
                '5.76924C11.5269 5.76924 11.1265 5.60546 10.799 5.27789C10.4714 ' +
                '4.95034 10.3076 4.55003 10.3076 4.07694C10.3076 3.60386 10.4714 ' +
                '3.20354 10.799 2.87597C11.1265 2.54842 11.5269 2.38464 11.9999 ' +
                '2.38464C12.473 2.38464 12.8734 2.54842 13.2009 2.87597C13.5285 ' +
                '3.20354 13.6922 3.60386 13.6922 4.07694C13.6922 4.55003 13.5285 ' +
                '4.95034 13.2009 5.27789C12.8734 5.60544 12.473 5.76924 11.9999 5.76924Z' })));
};

const ApplicationSendIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "ApplicationSendIcon" }),
        React.createElement("path", { d: 'M18 20.2885L17.2923 19.575L19.3673 17.5H12.5V16.5H19.3673L17.2923 14.4192L18 ' +
                '13.7115L21.2885 17L18 20.2885ZM20 11.7115H19V5.61536C19 5.46152 18.9359 ' +
                '5.3205 18.8077 5.19228C18.6795 5.06408 18.5385 4.99998 18.3846 ' +
                '4.99998H16V7.23076H8V4.99998H5.61538C5.46154 4.99998 5.32052 5.06408 5.1923 ' +
                '5.19228C5.0641 5.3205 5 5.46152 5 5.61536V18.3846C5 18.5384 5.0641 18.6795 ' +
                '5.1923 18.8077C5.32052 18.9359 5.46154 19 5.61538 19H10.5V20H5.61538C5.16794 ' +
                '20 4.78685 19.8426 4.4721 19.5279C4.15737 19.2131 4 18.832 4 18.3846V5.61536C4 ' +
                '5.16792 4.15737 4.78683 4.4721 4.47208C4.78685 4.15735 5.16794 3.99998 5.61538 ' +
                '3.99998H10.2519C10.3455 3.60895 10.5532 3.28042 10.875 3.01441C11.1968 ' +
                '2.74837 11.5718 2.61536 12 2.61536C12.4359 2.61536 12.8138 2.74837 13.1337 ' +
                '3.01441C13.4535 3.28042 13.6603 3.60895 13.7538 3.99998H18.3846C18.8321 ' +
                '3.99998 19.2132 4.15735 19.5279 4.47208C19.8426 4.78683 20 5.16792 20 ' +
                '5.61536V11.7115ZM12 5.23076C12.232 5.23076 12.4247 5.15415 12.5779 ' +
                '5.00093C12.7311 4.84773 12.8077 4.65511 12.8077 4.42306C12.8077 4.19101 ' +
                '12.7311 3.99838 12.5779 3.84518C12.4247 3.69196 12.232 3.61536 12 ' +
                '3.61536C11.768 3.61536 11.5753 3.69196 11.4221 3.84518C11.2689 3.99838 ' +
                '11.1923 4.19101 11.1923 4.42306C11.1923 4.65511 11.2689 4.84773 ' +
                '11.4221 5.00093C11.5753 5.15415 11.768 5.23076 12 5.23076Z' })));
};

const AddAPhotoIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "AddAPhotoIcon" }),
        React.createElement("path", { d: 'M3.61538 20C3.15513 20 2.77083 19.8458 2.4625 19.5375C2.15417 19.2292 2 ' +
                '18.8449 2 18.3846V7.61538C2 7.15513 2.15417 6.77083 2.4625 6.4625C2.77083 ' +
                '6.15417 3.15513 6 3.61538 6H6.57308L8.42308 4H13.6154V5H8.85577L7.01155 ' +
                '7H3.61538C3.43589 7 3.28846 7.05769 3.17307 7.17307C3.05769 7.28846 3 ' +
                '7.43589 3 7.61538V18.3846C3 18.5641 3.05769 18.7115 3.17307 18.8269C3.28846 ' +
                '18.9423 3.43589 19 3.61538 19H18.3846C18.5641 19 18.7115 18.9423 18.8269 ' +
                '18.8269C18.9423 18.7115 19 18.5641 19 18.3846V10.3846H20V18.3846C20 18.8449 ' +
                '19.8458 19.2292 19.5375 19.5375C19.2292 19.8458 18.8449 20 18.3846 ' +
                '20H3.61538ZM19 7V5H17V4H19V2H20V4H22V5H20V7H19ZM11 16.7308C12.0449 16.7308 ' +
                '12.9279 16.3702 13.649 15.6491C14.3702 14.9279 14.7308 14.0449 14.7308 ' +
                '13C14.7308 11.9551 14.3702 11.0721 13.649 10.351C12.9279 9.6298 12.0449 ' +
                '9.26922 11 9.26922C9.95513 9.26922 9.07212 9.6298 8.35095 10.351C7.6298 ' +
                '11.0721 7.26923 11.9551 7.26923 13C7.26923 14.0449 7.6298 14.9279 8.35095 ' +
                '15.6491C9.07212 16.3702 9.95513 16.7308 11 16.7308ZM11 15.7308C10.2231 ' +
                '15.7308 9.57373 15.4699 9.05193 14.9481C8.53013 14.4263 8.26923 13.7769 ' +
                '8.26923 13C8.26923 12.2231 8.53013 11.5737 9.05193 11.0519C9.57373 ' +
                '10.5301 10.2231 10.2692 11 10.2692C11.7769 10.2692 12.4263 10.5301 ' +
                '12.9481 11.0519C13.4699 11.5737 13.7308 12.2231 13.7308 13C13.7308 13.7769 ' +
                '13.4699 14.4263 12.9481 14.9481C12.4263 15.4699 11.7769 15.7308 11 15.7308Z' })));
};

const ArrowBackIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "ArrowBackIcon" }),
    React.createElement("path", { d: 'M8.90386 17.3077L3.59616 12L8.90386 6.69229L9.61156 ' +
            '7.39999L5.51156 11.5H20.4039V12.5H5.51156L9.61156 ' +
            '16.6L8.90386 17.3077Z' })));

const MenuIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "MenuIcon" }),
    React.createElement("path", { d: 'M3.5 17.275V16.275H20.5V17.275H3.5ZM3.5 ' +
            '12.5V11.5H20.5V12.5H3.5ZM3.5 ' +
            '7.72501V6.72501H20.5V7.72501H3.5Z' })));

const ContractIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "ContractIcon" }),
    React.createElement("path", { d: 'M6 21C5.4359 21 4.96154 20.8077 4.57692 20.4231C4.19231 20.0385 4 ' +
            '19.5641 4 19V16.2308H7V3H20V19C20 19.5641 19.8077 20.0385 19.4231 ' +
            '20.4231C19.0385 20.8077 18.5641 21 18 21H6ZM18 20C18.2833 20 18.5208 ' +
            '19.9042 18.7125 19.7125C18.9042 19.5208 19 19.2833 19 ' +
            '19V4H8V16.2308H17V19C17 19.2833 17.0958 19.5208 17.2875 ' +
            '19.7125C17.4792 19.9042 17.7167 20 18 20ZM9.38463 ' +
            '8.38463V7.38463H17.6154V8.38463H9.38463ZM9.38463 ' +
            '11.1538V10.1539H17.6154V11.1538H9.38463ZM6 20H16V17.2308H5V19C5 ' +
            '19.2833 5.09583 19.5208 5.2875 19.7125C5.47917 19.9042 5.71667 ' +
            '20 6 20ZM6 20H5H16H6Z' })));

const LogoutIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "LogoutIcon" }),
    React.createElement("path", { d: 'M5.8002 20.5C5.3502 20.5 4.97086 20.346 4.6622 20.038C4.3542 ' +
            '19.7293 4.2002 19.3417 4.2002 18.875V5.125C4.2002 4.65833 ' +
            '4.3542 4.271 4.6622 3.963C4.97086 3.65433 5.3502 3.5 5.8002 ' +
            '3.5H12.2252V4.5H5.8002C5.6502 4.5 5.51286 4.56267 5.3882 ' +
            '4.688C5.26286 4.81267 5.2002 4.95833 5.2002 5.125V18.875C5.2002 ' +
            '19.0417 5.26286 19.1873 5.3882 19.312C5.51286 19.4373 5.6502 ' +
            '19.5 5.8002 19.5H12.2252V20.5H5.8002ZM16.2752 15.55L15.5752 ' +
            '14.825L17.8752 12.5H9.2252V11.5H17.8752L15.5752 9.175L16.2752 ' +
            '8.45L19.8002 12L16.2752 15.55Z' })));

const ExpandLessIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'expandLessIcon' }),
    React.createElement("path", { d: 'M7.4002 14.7L6.7002 14L12.0002 8.67499L17.3002 14L16.6002 ' +
            '14.7L12.0002 10.1L7.4002 14.7Z' })));

const ReportsIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'ReportsIcon' }),
    React.createElement("path", { d: 'M17.225 8.775H18.775V7.225H17.225V8.775ZM17.225 12.775H18.775V11.225H17.225V12.775ZM17.225 ' +
            '16.775H18.775V15.225H17.225V16.775ZM16 20V19H21V5H11.375V7.2L10.375 6.475V4H22V20H16ZM2 ' +
            '20V11.5L8 7.225L14 11.5V20H9.275V15.5H6.725V20H2ZM3 19H5.725V14.5H10.275V19H13V12L8 ' +
            '8.5L3 12V19Z' })));

const BuildingsIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'BuildingsIcon' }),
    React.createElement("path", { d: 'M3.5 20.5V19.2L4.5 18.2V20.5H3.5ZM7.5 20.5V15.2L8.5 ' +
            '14.2V20.5H7.5ZM11.5 20.5V14.2L12.5 15.225V20.5H11.5ZM15.5 20.5V15.225L16.5 ' +
            '14.225V20.5H15.5ZM19.5 20.5V11.2L20.5 10.2V20.5H19.5ZM3.5 ' +
            '14.625V13.2L10 6.70001L14 10.7L20.5 4.20001V5.62501L14 12.125L10 8.12501L3.5 14.625Z' })));

const FortressLogo = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { width: "32", height: "32", viewBox: "0 0 32 32" }),
    React.createElement("path", { d: "M7.26579 1.92603H10.1515V4.79502H7.26579V1.92603Z", fill: props.color }),
    React.createElement("path", { d: "M7.26579 5.54098H10.1515V8.40998H7.26579V5.54098Z", fill: props.color }),
    React.createElement("path", { d: "M10.1963 9.14952H7.31051V12.0185H10.1963V9.14952Z", fill: props.color }),
    React.createElement("path", { d: "M7.26579 12.7708H10.1515V15.6398H7.26579V12.7708Z", fill: props.color }),
    React.createElement("path", { d: "M6.52175 12.7708H3.636V15.6398H6.52175V12.7708Z", fill: props.color }),
    React.createElement("path", { d: "M7.26579 19.9815H10.1515V22.8505H7.26579V19.9815Z", fill: props.color }),
    React.createElement("path", { d: "M6.52175 16.373H3.636V19.242H6.52175V16.373Z", fill: props.color }),
    React.createElement("path", { d: "M3.68096 19.9815H6.56671V22.8505H3.68096V19.9815Z", fill: props.color }),
    React.createElement("path", { d: "M10.1515 23.5964H7.26579V26.4654H10.1515V23.5964Z", fill: props.color }),
    React.createElement("path", { d: "M7.26579 27.2049H10.1515V30.0739H7.26579V27.2049Z", fill: props.color }),
    React.createElement("path", { d: "M13.7875 5.52177H10.9018V8.39076H13.7875V5.52177Z", fill: props.color }),
    React.createElement("path", { d: "M10.9018 27.2049H13.7875V30.0739H10.9018V27.2049Z", fill: props.color }),
    React.createElement("path", { d: "M17.4171 5.52177H14.5313V8.39076H17.4171V5.52177Z", fill: props.color }),
    React.createElement("path", { d: "M14.5313 12.7708H17.4171V15.6398H14.5313V12.7708Z", fill: props.color }),
    React.createElement("path", { d: "M17.4171 20.0198H14.5313V22.8888H17.4171V20.0198Z", fill: props.color }),
    React.createElement("path", { d: "M14.5313 23.5964H17.4171V26.4654H14.5313V23.5964Z", fill: props.color }),
    React.createElement("path", { d: "M17.4171 27.1731H14.5313V30.0421H17.4171V27.1731Z", fill: props.color }),
    React.createElement("path", { d: "M18.1673 5.52177H21.0531V8.39076H18.1673V5.52177Z", fill: props.color }),
    React.createElement("path", { d: "M21.0981 12.7708H18.2124V15.6398H21.0981V12.7708Z", fill: props.color }),
    React.createElement("path", { d: "M7.26579 16.373H10.1515V19.242H7.26579V16.373Z", fill: props.color }),
    React.createElement("path", { d: "M21.0531 19.9815H18.1673V22.8505H21.0531V19.9815Z", fill: props.color }),
    React.createElement("path", { d: "M18.2124 23.5964H21.0981V26.4654H18.2124V23.5964Z", fill: props.color }),
    React.createElement("path", { d: "M21.0531 1.92603H18.1673V4.79502H21.0531V1.92603Z", fill: props.color }),
    React.createElement("path", { d: "M21.8484 5.52177H24.7341V8.39076H21.8484V5.52177Z", fill: props.color }),
    React.createElement("path", { d: "M24.689 12.7708H21.8033V15.6398H24.689V12.7708Z", fill: props.color }),
    React.createElement("path", { d: "M21.8033 16.373H24.689V19.242H21.8033V16.373Z", fill: props.color }),
    React.createElement("path", { d: "M24.689 19.9815H21.8033V22.8505H24.689V19.9815Z", fill: props.color }),
    React.createElement("path", { d: "M21.8033 27.2049H24.689V30.0739H21.8033V27.2049Z", fill: props.color }),
    React.createElement("path", { d: "M28.319 5.52177H25.4333V8.39076H28.319V5.52177Z", fill: props.color }),
    React.createElement("path", { d: "M25.4333 9.14952H28.319V12.0185H25.4333V9.14952Z", fill: props.color }),
    React.createElement("path", { d: "M28.319 12.7708H25.4333V15.6398H28.319V12.7708Z", fill: props.color }),
    React.createElement("path", { d: "M29.1142 16.373H32V19.242H29.1142V16.373Z", fill: props.color }),
    React.createElement("path", { d: "M6.52175 5.52177H3.636V8.39076H6.52175V5.52177Z", fill: props.color }),
    React.createElement("path", { d: "M0 16.373H2.88575V19.242H0V16.373Z", fill: props.color })));

const FortressTextIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { width: "529", height: "72", viewBox: "0 0 529 72", "data-testid": 'FortressTextIcon' }),
    React.createElement("path", { d: 'M0.517578 1.42466H55.1196V18.2162H19.433V29.8685H51.699V45.8713H19.433V70.5752H0.517578V1.42466Z', fill: props.color }),
    React.createElement("path", { d: 'M96.3201 72C91.0615 72 86.1859 71.0587 81.6931 69.176C77.2004 67.2933 73.3458 64.7491 ' +
            '70.0784 61.518C66.8365 58.2869 64.2838 54.4961 62.4203 50.1456C60.5569 45.7951 59.6379 ' +
            '41.1392 59.6379 36.2035V36C59.6379 31.0643 60.5569 26.4085 62.4203 22.0071C64.2838 17.6311 ' +
            '66.862 13.8148 70.1805 10.5329C73.499 7.27632 77.4046 4.70672 81.8718 2.82403C86.3646 0.941344 ' +
            '91.2402 0 96.4987 0C101.757 0 106.633 0.941344 111.126 2.82403C115.618 4.70672 119.473 7.25088 ' +
            '122.74 10.482C125.982 13.7131 128.535 17.5039 130.398 21.8544C132.262 26.2049 133.181 30.8608 ' +
            '133.181 35.7965V36C133.181 40.9357 132.262 45.617 130.398 49.9929C128.535 54.3689 125.957 58.1852 ' +
            '122.638 61.4671C119.32 64.7237 115.414 67.2933 110.947 69.176C106.48 71.0587 101.604 72 96.3201 ' +
            '72ZM96.4732 54.6996C99.077 54.6996 101.451 54.1908 103.621 53.224C105.765 52.2318 107.603 50.9088 ' +
            '109.109 49.2297C110.615 47.5505 111.789 45.5915 112.632 43.3527C113.474 41.1138 113.908 38.7477 ' +
            '113.908 36.229V36.0254C113.908 33.5322 113.474 31.1406 112.632 28.9018C111.789 26.6629 110.59 24.6784 ' +
            '109.007 22.9739C107.45 21.2693 105.586 19.8954 103.442 18.8777C101.298 17.8601 98.9238 17.3512 96.2945 ' +
            '17.3512C93.6908 17.3512 91.3168 17.8601 89.1981 18.8269C87.0793 19.7936 85.2669 21.142 ' +
            '83.7098 22.8212C82.1781 24.5004 81.0039 26.4594 80.187 28.6982C79.3702 30.9371 78.9618 33.3032 ' +
            '78.9618 35.8219V36.0254C78.9618 38.5187 79.3957 40.9102 80.2381 43.1491C81.0805 45.388 82.2803 ' +
            '47.3724 83.8119 49.077C85.3435 50.7816 87.1814 52.1555 89.3257 ' +
            '53.1731C91.4955 54.1908 93.8695 54.6996 96.4732 54.6996Z', fill: props.color }),
    React.createElement("path", { d: 'M174.994 1.42466C180.253 1.42466 184.72 2.08615 188.345 3.40911C191.995 4.73208 ' +
            '194.931 6.56388 197.228 8.9554C201.261 12.8989 203.278 18.2925 203.278 ' +
            '25.06V25.2635C203.278 30.6063 202.001 35.0077 199.474 38.5187C196.947 42.0042 ' +
            '193.527 44.6755 189.238 46.5328L205.524 70.6515H183.673L169.914 ' +
            '49.6876H161.618V70.6515H142.703V1.42466H174.994ZM174.126 34.6261C177.368 34.6261 ' +
            '179.87 33.8883 181.631 32.4126C183.392 30.937 184.26 28.9271 184.26 26.4338V26.2303C184.26 23.4572 ' +
            '183.341 21.3964 181.529 20.048C179.717 18.6996 177.215 18.0126 174.024 18.0126H161.643V34.6261H174.126Z', fill: props.color }),
    React.createElement("path", { d: 'M228.703 18.2162H208.23V1.42466H268.091V18.2162H247.618V70.6006H228.703V18.2162Z', fill: props.color }),
    React.createElement("path", { d: 'M306.815 1.42466C312.073 1.42466 316.541 2.08615 320.165 3.40911C323.816 4.73208 326.751 ' +
            '6.56388 329.049 8.9554C333.082 12.8989 335.099 18.2925 335.099 25.06V25.2635C335.099 30.6063 ' +
            '333.822 35.0077 331.295 38.5187C328.768 42.0042 325.347 44.6755 321.059 46.5328L337.345 ' +
            '70.6515H315.494L301.735 49.6876H293.439V70.6515H274.523V1.42466H306.815ZM305.947 ' +
            '34.6261C309.189 34.6261 311.69 33.8883 313.452 32.4126C315.213 30.937 316.081 28.9271 ' +
            '316.081 26.4338V26.2303C316.081 23.4572 315.162 21.3964 313.35 20.048C311.537 18.6996 ' +
            '309.036 18.0126 305.845 18.0126H293.464V34.6261H305.947Z', fill: props.color }),
    React.createElement("path", { d: 'M344.927 ' +
            '1.42466H399.733V17.7328H363.561V28.2148H396.312V43.3271H363.561V54.2925H400.218V70.6006H344.927V1.42466Z', fill: props.color }),
    React.createElement("path", { d: 'M437.41 71.7966C431.31 71.7966 425.489 70.8298 420.001 68.9217C414.513 66.9881 409.637 ' +
            '64.1132 405.425 60.2715L415.968 47.4998C422.784 53.0461 430.161 55.7938 438.1 ' +
            '55.7938C440.627 55.7938 442.567 55.3867 443.894 54.5726C445.222 53.7584 445.885 ' +
            '52.5881 445.885 51.0616V50.8581C445.885 50.1457 445.732 49.4842 445.4 48.9245C445.069 ' +
            '48.3648 444.481 47.8305 443.588 47.2963C442.72 46.762 441.546 46.2531 440.065 ' +
            '45.7697C438.61 45.2609 436.696 44.7521 434.373 44.2432C430.722 43.3782 427.353 ' +
            '42.4623 424.239 41.4447C421.124 40.427 418.393 39.104 416.096 37.5012C413.798 35.8984 ' +
            '411.96 33.8885 410.633 31.4715C409.305 29.08 408.642 26.1033 408.642 22.5415V22.3379C408.642 ' +
            '19.1068 409.229 16.1556 410.454 13.4588C411.654 10.762 413.415 8.42133 415.713 6.46232C418.01 ' +
            '4.50331 420.792 2.95137 424.06 1.88282C427.302 0.788825 430.978 0.254548 435.088 0.254548C440.933 ' +
            '0.254548 446.166 1.04324 450.736 2.59519C455.33 4.14713 459.466 6.46232 463.167 9.51533L453.697 ' +
            '23.1012C450.582 20.8623 447.366 19.1577 444.098 18.0129C440.806 16.868 437.64 16.2828 434.603 ' +
            '16.2828C432.331 16.2828 430.62 16.7153 429.497 17.5549C428.348 18.4199 427.787 19.463 427.787 ' +
            '20.7097V20.9132C427.787 21.7019 427.966 22.3888 428.323 22.974C428.68 23.5591 429.293 24.1189 ' +
            '430.186 24.6023C431.054 25.0856 432.254 25.5945 433.786 26.0779C435.317 26.5613 437.257 27.0701 ' +
            '439.58 27.6044C443.486 28.4694 447.009 29.4616 450.174 30.6065C453.314 31.7514 455.994 33.1507 ' +
            '458.215 34.8044C460.41 36.4581 462.12 38.4425 463.295 40.7832C464.469 43.1238 465.056 45.897 ' +
            '465.056 49.1281V49.3316C465.056 52.8934 464.392 56.0482 463.065 58.7959C461.738 61.5436 459.874' +
            ' 63.9097 457.449 65.8433C455.05 67.7768 452.165 69.2524 448.77 70.2701C445.324 71.2878 441.571 ' +
            '71.7966 437.41 71.7966Z', fill: props.color }),
    React.createElement("path", { d: 'M500.385 71.7966C494.284 71.7966 488.464 70.8298 482.976 68.9217C477.488 66.9881 ' +
            '472.612 64.1132 468.4 60.2715L478.943 47.4998C485.758 53.0461 493.136 55.7938 ' +
            '501.074 55.7938C503.602 55.7938 505.542 55.3867 506.869 54.5726C508.197 53.7584 ' +
            '508.86 52.5881 508.86 51.0616V50.8581C508.86 50.1457 508.707 49.4842 508.375 ' +
            '48.9245C508.043 48.3648 507.456 47.8305 506.563 47.2963C505.695 46.762 504.521 ' +
            '46.2531 503.04 45.7697C501.585 45.2609 499.671 44.7521 497.348 44.2432C493.697 ' +
            '43.3782 490.328 42.4623 487.213 41.4447C484.099 40.427 481.368 39.104 479.07 ' +
            '37.5012C476.773 35.8984 474.935 33.8885 473.608 31.4715C472.28 29.08 471.617 ' +
            '26.1033 471.617 22.5415V22.3379C471.617 19.1068 472.204 16.1556 473.429 13.4588C474.629 ' +
            '10.762 476.39 8.42133 478.687 6.46232C480.985 4.50331 483.767 2.95137 487.035 ' +
            '1.88282C490.302 0.814266 493.953 0.254548 498.062 0.254548C503.908 0.254548 509.141 ' +
            '1.04324 513.71 2.59519C518.305 4.14713 522.441 6.46232 526.142 9.51533L516.671 ' +
            '23.1012C513.557 20.8623 510.341 19.1577 507.073 18.0129C503.78 16.868 500.615 ' +
            '16.2828 497.577 16.2828C495.305 16.2828 493.595 16.7153 492.472 17.5549C491.323 ' +
            '18.4199 490.762 19.463 490.762 20.7097V20.9132C490.762 21.7019 490.94 22.3888 491.298 ' +
            '22.974C491.655 23.5591 492.268 24.1189 493.161 24.6023C494.029 25.0856 495.229 25.5945 ' +
            '496.76 26.0779C498.292 26.5613 500.232 27.0701 502.555 27.6044C506.461 28.4694 509.983 ' +
            '29.4616 513.149 30.6065C516.289 31.7514 518.969 33.1507 521.19 34.8044C523.385 36.4581 ' +
            '525.095 38.4425 526.27 40.7832C527.444 43.1238 528.031 45.897 528.031 49.1281V49.3316C528.031 ' +
            '52.8934 527.367 56.0482 526.04 58.7959C524.712 61.5436 522.849 63.9097 520.424 65.8433C518.024 ' +
            '67.7768 515.14 69.2524 511.745 70.2701C508.324 71.2878 504.546 71.7966 500.385 71.7966Z', fill: props.color })));

const AvatarIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'AvatarIcon' }),
    React.createElement("path", { d: 'M6.2 17.475C7.05 16.875 7.95 16.396 8.9 16.038C9.85 15.6793 ' +
            '10.8833 15.5 12 15.5C13.1167 15.5 14.15 15.6793 15.1 16.038C16.05 ' +
            '16.396 16.95 16.875 17.8 17.475C18.4667 16.7917 19 15.9873 19.4 ' +
            '15.062C19.8 14.1373 20 13.1167 20 12C20 9.78333 19.221 7.89567 ' +
            '17.663 6.337C16.1043 4.779 14.2167 4 12 4C9.78333 4 7.896 4.779 ' +
            '6.338 6.337C4.77933 7.89567 4 9.78333 4 12C4 13.1167 4.2 14.1373 ' +
            '4.6 15.062C5 15.9873 5.53333 16.7917 6.2 17.475ZM12 12.5C11.15 12.5 ' +
            '10.4377 12.2123 9.863 11.637C9.28767 11.0623 9 10.35 9 9.5C9 8.65 ' +
            '9.28767 7.93733 9.863 7.362C10.4377 6.78733 11.15 6.5 12 6.5C12.85 ' +
            '6.5 13.5623 6.78733 14.137 7.362C14.7123 7.93733 15 8.65 15 9.5C15 ' +
            '10.35 14.7123 11.0623 14.137 11.637C13.5623 12.2123 12.85 12.5 12 ' +
            '12.5ZM12 21C10.75 21 9.575 20.7667 8.475 20.3C7.375 19.8333 6.421 ' +
            '19.196 5.613 18.388C4.80433 17.5793 4.16667 16.625 3.7 15.525C3.23333 ' +
            '14.425 3 13.25 3 12C3 10.75 3.23333 9.575 3.7 8.475C4.16667 7.375 ' +
            '4.80433 6.42067 5.613 5.612C6.421 4.804 7.375 4.16667 8.475 3.7C9.575 ' +
            '3.23333 10.75 3 12 3C13.25 3 14.425 3.23333 15.525 3.7C16.625 4.16667 ' +
            '17.5793 4.804 18.388 5.612C19.196 6.42067 19.8333 7.375 20.3 8.475C20.7667 ' +
            '9.575 21 10.75 21 12C21 13.25 20.7667 14.425 20.3 15.525C19.8333 16.625 ' +
            '19.196 17.5793 18.388 18.388C17.5793 19.196 16.625 19.8333 15.525 ' +
            '20.3C14.425 20.7667 13.25 21 12 21Z' })));

const InactiveIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'InactiveIcon' }),
    React.createElement("path", { d: 'M12.0034 21C10.7588 21 9.58872 20.7638 8.4931 20.2915C7.39748 19.8192 ' +
            '6.44444 19.1782 5.63397 18.3685C4.82352 17.5588 4.18192 16.6066 3.70915 ' +
            '15.512C3.23638 14.4174 3 13.2479 3 12.0034C3 10.7588 3.23616 9.58872 3.70848 ' +
            '8.4931C4.18081 7.39748 4.82183 6.44444 5.63153 5.63398C6.44123 4.82353 7.39337 ' +
            '4.18192 8.48795 3.70915C9.58255 3.23638 10.7521 3 11.9966 3C13.2412 3 14.4113 ' +
            '3.23616 15.5069 3.70847C16.6025 4.18081 17.5556 4.82182 18.366 5.63152C19.1765 ' +
            '6.44122 19.8181 7.39337 20.2908 8.48795C20.7636 9.58255 21 10.7521 21 11.9966C21 ' +
            '13.2412 20.7638 14.4113 20.2915 15.5069C19.8192 16.6025 19.1782 17.5556 18.3685 ' +
            '18.366C17.5588 19.1765 16.6066 19.8181 15.512 20.2909C14.4174 20.7636 13.2479 21 ' +
            '12.0034 21ZM12 20C12.9764 20 13.9167 19.8285 14.8208 19.4856C15.7249 19.1426 ' +
            '16.5462 18.6449 17.2846 17.9923L6.0077 6.71537C5.36795 7.45384 4.8734 8.27513 ' +
            '4.52405 9.17923C4.17468 10.0833 4 11.0236 4 12C4 14.2333 4.775 16.125 6.325 ' +
            '17.675C7.875 19.225 9.76667 20 12 20ZM17.9923 17.2846C18.6449 16.5462 19.1426 ' +
            '15.7249 19.4856 14.8208C19.8285 13.9167 20 12.9764 20 12C20 9.76667 19.225 7.875 ' +
            '17.675 6.325C16.125 4.775 14.2333 4 12 4C11.0191 ' +
            '4 10.0745 4.16827 9.16622 4.5048C8.25797 4.84135 7.44102 5.34232 6.71537 6.0077L17.9923 17.2846Z' })));

const ReorderIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'ReorderIcon' }),
        React.createElement("path", { d: 'M4 18V17H20V18H4ZM4 14.3269V13.3269H20V14.3269H4ZM4 10.6731V9.67307H20V10.6731H4ZM4 7V6H20V7H4Z' })));
};

const AddHomeWorkIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "AddHomeWorkIcon" }),
    React.createElement("path", { d: 'M2 20V11.5L8 7.23075L14.2885 11.7115C14.1705 11.8295 14.058 11.9516 13.951 12.0779 ' +
            'C13.8439 12.2042 13.7314 12.3263 13.6135 12.4442L8 8.48845L3 12V19H5.73078V14.5H10.2692 ' +
            'V20H9.26923V15.5H6.73077V20H2ZM22 4V12.5673C21.8449 12.434 21.6872 12.317 21.5269 12.2163 ' +
            'C21.3667 12.1157 21.191 12.0186 21 11.925V5H11.3846V7.18845L10.3846 6.46922V4H22ZM17.2308 ' +
            '8.76922H18.7692V7.23078H17.2308V8.76922ZM18 22C16.8859 22 15.9407 21.6119 15.1644 20.8356 ' +
            'C14.3881 20.0593 14 19.1141 14 18C14 16.8859 14.3881 15.9407 15.1644 15.1644C15.9407 14.3881 ' +
            '16.8859 14 18 14C19.1141 14 20.0593 14.3881 20.8356 15.1644C21.6119 15.9407 22 16.8859 22 18 ' +
            'C22 19.1141 21.6119 20.0593 20.8356 20.8356C20.0593 21.6119 19.1141 22 18 22ZM17.6154 20.8846 ' +
            'H18.3846V18.3846H20.8846V17.6154H18.3846V15.1154H17.6154V17.6154H15.1154V18.3846H17.6154V20.8846Z' })));

const ContentCopyIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "transparent", d: 'M9.11538 17C8.65513 17 8.27083 16.8458 7.9625 16.5375C7.65417 ' +
                '16.2292 7.5 15.8449 7.5 15.3846V4.61537C7.5 4.15512 7.65417 ' +
                '3.77083 7.9625 3.4625C8.27083 3.15417 8.65513 3 9.11538 3H16.8846' +
                'C17.3449 3 17.7292 3.15417 18.0375 3.4625C18.3458 3.77083 18.5 ' +
                '4.15512 18.5 4.61537V15.3846C18.5 15.8449 18.3458 16.2292 18.0375 ' +
                '16.5375C17.7292 16.8458 17.3449 17 16.8846 17H9.11538ZM9.11538 16H16.8846' +
                'C17.0385 16 17.1795 15.9359 17.3077 15.8077C17.4359 15.6795 17.5 ' +
                '15.5385 17.5 15.3846V4.61537C17.5 4.46154 17.4359 4.32052 17.3077 ' +
                '4.1923C17.1795 4.0641 17.0385 4 16.8846 4H9.11538C8.96154 4 8.82052 ' +
                '4.0641 8.6923 4.1923C8.5641 4.32052 8.5 4.46154 8.5 4.61537V15.3846' +
                'C8.5 15.5385 8.5641 15.6795 8.6923 15.8077C8.82052 15.9359 8.96154 ' +
                '16 9.11538 16ZM6.11538 20C5.65513 20 5.27083 19.8458 4.9625 19.5375' +
                'C4.65417 19.2292 4.5 18.8449 4.5 18.3846V6.61537H5.5V18.3846C5.5 ' +
                '18.5385 5.5641 18.6795 5.6923 18.8077C5.8205 18.9359 5.96153 19 ' +
                '6.11538 19H14.8846V20H6.11538Z' })));
};

const AttachmentIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "AttachmentIcon" }),
        React.createElement("path", { d: 'M8.4615 17.173C6.94683 17.173 5.65792 16.6512 4.59475 15.6077C3.53158 ' +
                '14.5641 3 13.2877 3 11.7787C3 10.2699 3.53158 8.99048 4.59475 7.94048C5.65792 ' +
                '6.89048 6.94683 6.36548 8.4615 6.36548H17.1923C18.2499 6.36548 19.149 6.72923 ' +
                '19.8895 7.45673C20.6298 8.18423 21 9.07681 21 10.1345C21 11.1923 20.6298 12.085 ' +
                '19.8895 12.8125C19.149 13.54 18.2499 13.9037 17.1923 13.9037H8.923C8.33583 ' +
                '13.9037 7.83008 13.6989 7.40575 13.2892C6.98142 12.8796 6.76925 12.3802 6.76925 ' +
                '11.7912C6.76925 11.2022 6.97808 10.6956 7.39575 10.2712C7.81342 9.84673 8.3225 ' +
                '9.63448 8.923 9.63448H17.2308V10.6345H8.923C8.60383 10.6345 8.33175 10.7438 ' +
                '8.10675 10.9625C7.88175 11.1811 7.76925 11.4501 7.76925 11.7692C7.76925 ' +
                '12.0884 7.88175 12.3573 8.10675 12.576C8.33175 12.7945 8.60383 12.9037 ' +
                '8.923 12.9037H17.2115C17.9885 12.8999 18.6475 12.6328 19.1885 12.1025C19.7295 ' +
                '11.5721 20 10.9161 20 10.1345C20 9.35915 19.7263 8.70381 19.1788 8.16848C18.6314 ' +
                '7.63315 17.9693 7.36548 17.1923 7.36548H8.4615C7.22683 7.36148 6.17458 7.78898 ' +
                '5.30475 8.64798C4.43492 9.50698 4 10.5529 4 11.7857C4 13.0012 4.43492 14.0344 ' +
                '5.30475 14.8852C6.17458 15.7361 7.22683 16.1653 8.4615 16.173H17.2308V17.173H8.4615Z' })));
};

const BackHandIcon = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "BackHandIcon" }),
        React.createElement("path", { d: 'M13.4612 22.5646C12.1715 22.5646 10.9651 22.2553 9.84198 21.6367C8.71889 ' +
                '21.0181 7.81249 20.1569 7.12275 19.0531L3.32275 12.9453L3.62465 ' +
                '12.6434C3.80415 12.4601 4.01794 12.3562 4.266 12.3319C4.51409 12.3075 ' +
                '4.74198 12.3665 4.94968 12.5088L8.89198 15.1203V5.56458C8.89198 5.43508 ' +
                '8.9399 5.31937 9.03573 5.21745C9.13156 5.11553 9.25031 5.06458 9.39198 ' +
                '5.06458C9.52146 5.06458 9.63717 5.11553 9.7391 5.21745C9.84102 5.31937 ' +
                '9.89198 5.43508 9.89198 5.56458V17.0281L5.0766 13.7992L7.97083 ' +
                '18.4799C8.55416 19.4454 9.33452 20.2008 10.3119 20.7463C11.2893 ' +
                '21.2918 12.339 21.5646 13.4612 21.5646C15.2418 21.5646 16.7587 20.9444 ' +
                '18.012 19.704C19.2653 18.4636 19.892 16.9466 19.892 15.1531V6.06458C19.892 ' +
                '5.93509 19.9399 5.81938 20.0357 5.71745C20.1316 5.61553 20.2503 5.56458 ' +
                '20.392 5.56458C20.5215 5.56458 20.6372 5.61553 20.7391 5.71745C20.841 ' +
                '5.81938 20.892 5.93509 20.892 6.06458V15.1531C20.892 17.2168 20.1708 ' +
                '18.968 18.7285 20.4067C17.2861 21.8453 15.5304 22.5646 13.4612 22.5646ZM12.5651 ' +
                '12.0646V3.56458C12.5651 3.43508 12.613 3.31937 12.709 3.21745C12.805 ' +
                '3.11553 12.9239 3.06458 13.0657 3.06458C13.2076 3.06458 13.3263 3.11553 ' +
                '13.4218 3.21745C13.5173 3.31937 13.5651 3.43508 13.5651 ' +
                '3.56458V12.0646H12.5651ZM16.2381 12.0646V4.56458C16.2381 4.43508 16.2861 ' +
                '4.31937 16.3821 4.21745C16.478 4.11553 16.597 4.06458 16.7388 4.06458C16.8807 ' +
                '4.06458 16.9994 4.11553 17.0949 4.21745C17.1904 4.31937 17.2381 4.43508 ' +
                '17.2381 4.56458V12.0646H16.2381Z' })));
};

const RenewCircleIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'renewCircleIcon' }),
    React.createElement("path", { d: 'M12.0693 18.577L14.477 16.175L12.0693 13.773L11.4423 14.4L12.825 15.7828C12.0507 15.7866 ' +
            '11.3625 15.6955 10.7605 15.5095C10.1587 15.3237 9.67633 15.0493 9.3135 14.6865C8.94167 ' +
            '14.3147 8.66183 13.8929 8.474 13.4213C8.28617 12.9494 8.19225 12.4776 8.19225 12.0058C8.19225 ' +
            '11.7224 8.22333 11.4391 8.2855 11.1557C8.34767 10.8724 8.439 10.6038 8.5595 10.35L7.88275 ' +
            '9.75C7.68908 10.1025 7.54483 10.4678 7.45 10.8458C7.35517 11.2238 7.30775 11.6085 7.30775 ' +
            '12C7.30775 12.5942 7.42308 13.1805 7.65375 13.759C7.88458 14.3377 8.22567 14.8558 8.677 ' +
            '15.3135C9.12817 15.7712 9.72108 16.1112 10.4558 16.3337C11.1904 16.5561 11.9449 16.6692 ' +
            '12.7192 16.673L11.4423 17.95L12.0693 18.577ZM16.1365 14.25C16.3302 13.8975 16.4744 13.5323 ' +
            '16.5693 13.1543C16.6641 12.7763 16.7115 12.3915 16.7115 12C16.7115 11.4078 16.5971 10.8196 ' +
            '16.3682 10.2352C16.1394 9.65092 15.7962 9.13275 15.3385 8.68075C14.8937 8.22308 14.3017 7.884 ' +
            '13.5625 7.6635C12.8235 7.443 12.0693 7.33275 11.3 7.33275L12.577 6.05L11.95 5.423L9.54225 7.825L11.95 ' +
            '10.227L12.577 9.6L11.1885 8.2115C11.959 8.2115 12.6481 8.30542 13.2557 8.49325C13.8634 8.68108 ' +
            '14.3487 8.95692 14.7115 9.32075C15.0742 9.68442 15.3508 10.1027 15.5413 10.5755C15.7318 ' +
            '11.0485 15.827 11.5214 15.827 11.9943C15.827 12.2776 15.7959 12.5609 15.7337 12.8442C15.6716 ' +
            '13.1276 15.5802 13.3962 15.4595 13.65L16.1365 14.25ZM12.0033 21C10.7588 21 9.58867 20.7638 ' +
            '8.493 20.2915C7.3975 19.8192 6.4445 19.1782 5.634 18.3685C4.8235 17.5588 4.18192 16.6067 3.70925 ' +
            '15.512C3.23642 14.4175 3 13.2479 3 12.0033C3 10.7588 3.23617 9.58867 3.7085 8.493C4.18083 7.3975 ' +
            '4.82183 6.4445 5.6315 5.634C6.44117 4.8235 7.39333 4.18192 8.488 3.70925C9.5825 3.23642 ' +
            '10.7521 3 11.9967 3C13.2412 3 14.4113 3.23617 15.507 3.7085C16.6025 4.18083 17.5555 4.82183 ' +
            '18.366 5.6315C19.1765 6.44117 19.8181 7.39333 20.2908 8.488C20.7636 9.5825 21 10.7521 21 ' +
            '11.9967C21 13.2412 20.7638 14.4113 20.2915 15.507C19.8192 16.6025 19.1782 17.5555 18.3685 ' +
            '18.366C17.5588 19.1765 16.6067 19.8181 15.512 20.2908C14.4175 20.7636 13.2479 21 12.0033 ' +
            '21ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 ' +
            '19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 ' +
            '7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z' })));

const TimelapseIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "TimelapseIcon" }),
    React.createElement("path", { d: 'M12 17.5C13.5278 17.5 14.8264 16.9652 15.8958 15.8957C16.9653 14.8264 17.5 13.5278 17.5' +
            ' 12C17.5 10.5642 17.0224 9.32058 16.0673 8.26925C15.1121 7.21792 13.923 6.641 ' +
            '12.5 6.5385V12.2008L8.48075' +
            ' 16.2115C8.98725 16.6205 9.53883 16.9375 10.1355 17.1625C10.7323 17.3875 11.3538' +
            ' 17.5 12 17.5ZM12.0033 21C10.7587 ' +
            '21 9.58867 20.7638 8.493 20.2915C7.3975 19.8192 6.4445 19.1782 5.634 18.3685C4.8235' +
            ' 17.5588 4.18192 16.6067 3.70925 ' +
            '15.512C3.23642 14.4175 3 13.2479 3 12.0033C3 10.7587 3.23617 9.58867 3.7085 ' +
            '8.493C4.18083 7.3975 4.82183 6.4445 5.6315 5.634C6.44117' +
            ' 4.8235 7.39333 4.18192 8.488 3.70925C9.5825 3.23642 10.7521 3 11.9967 3C13.2413 ' +
            '3 14.4113 3.23617 15.507 3.7085C16.6025 4.18083 17.5555' +
            ' 4.82183 18.366 5.6315C19.1765 6.44117 19.8181 7.39333 20.2908 8.488C20.7636 9.5825 ' +
            '21 10.7521 21 11.9967C21 13.2413 20.7638 14.4113 20.2915' +
            ' 15.507C19.8192 16.6025 19.1782 17.5555 18.3685 18.366C17.5588 19.1765 16.6067 19.8181 ' +
            '15.512 20.2908C14.4175 20.7636 13.2479 21 12.0033 21ZM12' +
            ' 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 ' +
            '7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667' +
            ' 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 ' +
            '19.225 9.76667 20 12 20Z' })));

const RefreshIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "RefreshIcon" }),
    React.createElement("path", { d: 
        // eslint-disable-next-line max-len
        'M12.0386 19.5C9.94474 19.5 8.17132 18.7736 6.71832 17.3207C5.26516 15.8679 4.53857 14.0948 4.53857 12.0015C4.53857 9.90817 5.26516 8.13458 6.71832 6.68075C8.17132 5.22692 9.94474 4.5 12.0386 4.5C13.2077 4.5 14.3142 4.75992 15.3578 5.27975C16.4013 5.79975 17.2692 6.53342 17.9616 7.48075V4.5H19.4616V10.6152H13.3463V9.1155H17.2963C16.7693 8.15 16.0385 7.38942 15.1038 6.83375C14.1693 6.27792 13.1476 6 12.0386 6C10.3719 6 8.95524 6.58333 7.78857 7.75C6.62191 8.91667 6.03857 10.3333 6.03857 12C6.03857 13.6667 6.62191 15.0833 7.78857 16.25C8.95524 17.4167 10.3719 18 12.0386 18C13.3219 18 14.4802 17.6333 15.5136 16.9C16.5469 16.1667 17.2719 15.2 17.6886 14H19.2693C18.8155 15.632 17.9216 16.9567 16.5876 17.974C15.2536 18.9913 13.7372 19.5 12.0386 19.5Z' })));

/* eslint-disable max-len */
const TimeIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "TimeIcon" }),
    React.createElement("path", { d: `
                M15.6462 16.3539L16.3539 15.6462L12.5 11.7919V7H11.5V12.2077L15.6462 16.3539ZM12.0034 21C10.7588 21 9.58872 20.7638 8.4931 20.2915C7.39748 19.8192 6.44444 19.1782 5.63397 18.3685C4.82352 17.5588 4.18192 16.6066 3.70915 15.512C3.23638 14.4174 3 13.2479 3 12.0034C3 10.7588 3.23616 9.58872 3.70848 8.4931C4.18081 7.39748 4.82183 6.44444 5.63153 5.63398C6.44123 4.82353 7.39337 4.18192 8.48795 3.70915C9.58255 3.23638 10.7521 3 11.9966 3C13.2412 3 14.4113 3.23616 15.5069 3.70847C16.6025 4.18081 17.5556 4.82182 18.366 5.63152C19.1765 6.44122 19.8181 7.39337 20.2908 8.48795C20.7636 9.58255 21 10.7521 21 11.9966C21 13.2412 20.7638 14.4113 20.2915 15.5069C19.8192 16.6025 19.1782 17.5556 18.3685 18.366C17.5588 19.1765 16.6066 19.8181 15.512 20.2909C14.4174 20.7636 13.2479 21 12.0034 21ZM12 20C14.2167 20 16.1042 19.2208 17.6625 17.6625C19.2208 16.1042 20 14.2167 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 14.2167 4.77917 16.1042 6.3375 17.6625C7.89583 19.2208 9.78333 20 12 20Z
            ` })));

/* eslint-disable max-len */
const ApprovedWithConditionsIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "ApprovedWithConditionsIcon" }),
    React.createElement("path", { d: "M8.99925 16.7308C9.20608 16.7308 9.37975 16.6607 9.52025 16.5207C9.66058 16.3809 9.73075 16.2076 9.73075 16.0008C9.73075 15.7939 9.66075 15.6203 9.52075 15.4798C9.38092 15.3394 9.20758 15.2692 9.00075 15.2692C8.79392 15.2692 8.62025 15.3393 8.47975 15.4793C8.33942 15.6191 8.26925 15.7924 8.26925 15.9992C8.26925 16.2061 8.33925 16.3798 8.47925 16.5203C8.61908 16.6606 8.79242 16.7308 8.99925 16.7308ZM11.9993 16.7308C12.2061 16.7308 12.3798 16.6607 12.5203 16.5207C12.6606 16.3809 12.7308 16.2076 12.7308 16.0008C12.7308 15.7939 12.6608 15.6203 12.5208 15.4798C12.3809 15.3394 12.2076 15.2692 12.0008 15.2692C11.7939 15.2692 11.6203 15.3393 11.4798 15.4793C11.3394 15.6191 11.2692 15.7924 11.2692 15.9992C11.2692 16.2061 11.3393 16.3798 11.4793 16.5203C11.6191 16.6606 11.7924 16.7308 11.9993 16.7308ZM14.9992 16.7308C15.2061 16.7308 15.3798 16.6607 15.5203 16.5207C15.6606 16.3809 15.7308 16.2076 15.7308 16.0008C15.7308 15.7939 15.6608 15.6203 15.5208 15.4798C15.3809 15.3394 15.2076 15.2692 15.0008 15.2692C14.7939 15.2692 14.6203 15.3393 14.4798 15.4793C14.3394 15.6191 14.2693 15.7924 14.2693 15.9992C14.2693 16.2061 14.3392 16.3798 14.4792 16.5203C14.6191 16.6606 14.7924 16.7308 14.9992 16.7308ZM10.95 13.2885L15.8828 8.35L15.175 7.6365L10.9378 11.8865L8.81925 9.7615L8.1115 10.45L10.95 13.2885ZM12.0033 21C10.7587 21 9.58867 20.7638 8.493 20.2915C7.3975 19.8192 6.4445 19.1782 5.634 18.3685C4.8235 17.5588 4.18192 16.6067 3.70925 15.512C3.23642 14.4175 3 13.2479 3 12.0033C3 10.7587 3.23617 9.58867 3.7085 8.493C4.18083 7.3975 4.82183 6.4445 5.6315 5.634C6.44117 4.8235 7.39333 4.18192 8.488 3.70925C9.5825 3.23642 10.7521 3 11.9967 3C13.2413 3 14.4113 3.23617 15.507 3.7085C16.6025 4.18083 17.5555 4.82183 18.366 5.6315C19.1765 6.44117 19.8181 7.39333 20.2908 8.488C20.7636 9.5825 21 10.7521 21 11.9967C21 13.2413 20.7638 14.4113 20.2915 15.507C19.8192 16.6025 19.1782 17.5555 18.3685 18.366C17.5588 19.1765 16.6067 19.8181 15.512 20.2908C14.4175 20.7636 13.2479 21 12.0033 21ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" })));

/* eslint-disable max-len */
const CertHistoryIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "CertHistoryIcon" }),
    React.createElement("path", { d: "M19.675 20.3366L20.2212 19.7904L18.3846 17.9539V15.2308H17.6154V18.2769L19.675 20.3366ZM5.61538 20C5.16794 20 4.78685 19.8426 4.4721 19.5279C4.15737 19.2132 4 18.8321 4 18.3846V5.61537C4 5.16794 4.15737 4.78685 4.4721 4.4721C4.78685 4.15737 5.16794 4 5.61538 4H18.3846C18.8321 4 19.2132 4.15737 19.5279 4.4721C19.8426 4.78685 20 5.16794 20 5.61537V11.5654C19.8244 11.5051 19.6564 11.4561 19.4962 11.4183C19.3359 11.3804 19.1705 11.3429 19 11.3058V5.61537C19 5.46154 18.9359 5.32052 18.8077 5.1923C18.6795 5.0641 18.5385 5 18.3846 5H5.61538C5.46154 5 5.32052 5.0641 5.1923 5.1923C5.0641 5.32052 5 5.46154 5 5.61537V18.3846C5 18.5385 5.0641 18.6795 5.1923 18.8077C5.32052 18.9359 5.46154 19 5.61538 19H11.2808C11.3051 19.1872 11.3362 19.3609 11.3741 19.5212C11.4119 19.6814 11.4609 19.841 11.5212 20H5.61538ZM5 19V5V11.3058V11.2308V19ZM7.5 16.2692H11.4596C11.4968 16.0987 11.5471 15.9333 11.6106 15.7731C11.674 15.6128 11.7404 15.4449 11.8096 15.2692H7.5V16.2692ZM7.5 12.5H14.0808C14.409 12.2692 14.7324 12.0737 15.051 11.9135C15.3696 11.7532 15.7115 11.6276 16.0769 11.5365V11.5H7.5V12.5ZM7.5 8.73078H16.5V7.73078H7.5V8.73078ZM18 22.1154C16.8859 22.1154 15.9407 21.7273 15.1644 20.951C14.3881 20.1747 14 19.2295 14 18.1154C14 17.0013 14.3881 16.0561 15.1644 15.2798C15.9407 14.5035 16.8859 14.1154 18 14.1154C19.1141 14.1154 20.0593 14.5035 20.8356 15.2798C21.6119 16.0561 22 17.0013 22 18.1154C22 19.2295 21.6119 20.1747 20.8356 20.951C20.0593 21.7273 19.1141 22.1154 18 22.1154Z" })));

/* eslint-disable max-len */
const EmergencyHomeIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "EmergencyHomeIcon" }),
    React.createElement("path", { d: "M12.0001 20.775C11.7976 20.775 11.5979 20.7346 11.4011 20.6537C11.2043 20.5731 11.0251 20.4539 10.8636 20.2962L3.70385 13.1365C3.54618 12.975 3.42701 12.7958 3.34635 12.599C3.26551 12.4021 3.2251 12.2025 3.2251 12C3.2251 11.7975 3.26551 11.5968 3.34635 11.398C3.42701 11.1993 3.54618 11.0211 3.70385 10.8635L10.8636 3.70373C11.0251 3.54223 11.2043 3.42206 11.4011 3.34323C11.5979 3.26439 11.7976 3.22498 12.0001 3.22498C12.2026 3.22498 12.4033 3.26439 12.6021 3.34323C12.8008 3.42206 12.9789 3.54223 13.1366 3.70373L20.2963 10.8635C20.4578 11.0211 20.578 11.1993 20.6568 11.398C20.7357 11.5968 20.7751 11.7975 20.7751 12C20.7751 12.2025 20.7357 12.4021 20.6568 12.599C20.578 12.7958 20.4578 12.975 20.2963 13.1365L13.1366 20.2962C12.9789 20.4539 12.8008 20.5731 12.6021 20.6537C12.4033 20.7346 12.2026 20.775 12.0001 20.775ZM12.4423 19.5827L19.5828 12.4422C19.6854 12.3397 19.7366 12.1923 19.7366 12C19.7366 11.8076 19.6854 11.6602 19.5828 11.5577L12.4423 4.41723C12.3398 4.31473 12.1924 4.26348 12.0001 4.26348C11.8078 4.26348 11.6603 4.31473 11.5578 4.41723L4.41735 11.5577C4.31485 11.6602 4.2636 11.8076 4.2636 12C4.2636 12.1923 4.31485 12.3397 4.41735 12.4422L11.5578 19.5827C11.6603 19.6852 11.8078 19.7365 12.0001 19.7365C12.1924 19.7365 12.3398 19.6852 12.4423 19.5827ZM11.5001 13.173H12.5001V7.94223H11.5001V13.173ZM12.0001 15.4037C12.1681 15.4037 12.3127 15.3431 12.4338 15.222C12.555 15.101 12.6156 14.9565 12.6156 14.7885C12.6156 14.6205 12.555 14.4759 12.4338 14.3547C12.3127 14.2336 12.1681 14.173 12.0001 14.173C11.8321 14.173 11.6875 14.2336 11.5663 14.3547C11.4452 14.4759 11.3846 14.6205 11.3846 14.7885C11.3846 14.9565 11.4452 15.101 11.5663 15.222C11.6875 15.3431 11.8321 15.4037 12.0001 15.4037Z" })));

/* eslint-disable max-len */
const ErrorIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "ErrorIcon" }),
    React.createElement("path", { d: "M12 16.4615C12.1744 16.4615 12.3205 16.4026 12.4385 16.2846C12.5564 16.1667 12.6154 16.0205 12.6154 15.8462C12.6154 15.6718 12.5564 15.5257 12.4385 15.4077C12.3205 15.2897 12.1744 15.2308 12 15.2308C11.8256 15.2308 11.6795 15.2897 11.5615 15.4077C11.4436 15.5257 11.3846 15.6718 11.3846 15.8462C11.3846 16.0205 11.4436 16.1667 11.5615 16.2846C11.6795 16.4026 11.8256 16.4615 12 16.4615ZM11.5 13.1538H12.5V7.15385H11.5V13.1538ZM12.0034 21C10.7588 21 9.58872 20.7638 8.4931 20.2915C7.39748 19.8192 6.44444 19.1782 5.63397 18.3685C4.82352 17.5588 4.18192 16.6066 3.70915 15.512C3.23638 14.4174 3 13.2479 3 12.0033C3 10.7588 3.23616 9.58872 3.70848 8.4931C4.18081 7.39748 4.82183 6.44444 5.63153 5.63398C6.44123 4.82353 7.39337 4.18192 8.48795 3.70915C9.58255 3.23638 10.7521 3 11.9966 3C13.2412 3 14.4113 3.23616 15.5069 3.70848C16.6025 4.18081 17.5556 4.82182 18.366 5.63152C19.1765 6.44122 19.8181 7.39337 20.2908 8.48795C20.7636 9.58255 21 10.7521 21 11.9967C21 13.2412 20.7638 14.4113 20.2915 15.5069C19.8192 16.6025 19.1782 17.5556 18.3685 18.366C17.5588 19.1765 16.6066 19.8181 15.512 20.2908C14.4174 20.7636 13.2479 21 12.0034 21ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" })));

/* eslint-disable max-len */
const PendingIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "PendingIcon" }),
    React.createElement("path", { d: "M6.99775 13C7.27492 13 7.51125 12.903 7.70675 12.709C7.90225 12.515 8 12.2794 8 12.0022C8 11.7251 7.903 11.4888 7.709 11.2933C7.515 11.0977 7.27942 11 7.00225 11C6.72508 11 6.48875 11.097 6.29325 11.291C6.09775 11.485 6 11.7206 6 11.9978C6 12.2749 6.097 12.5112 6.291 12.7067C6.485 12.9023 6.72058 13 6.99775 13ZM11.9978 13C12.2749 13 12.5112 12.903 12.7067 12.709C12.9023 12.515 13 12.2794 13 12.0022C13 11.7251 12.903 11.4888 12.709 11.2933C12.515 11.0977 12.2794 11 12.0022 11C11.7251 11 11.4888 11.097 11.2933 11.291C11.0977 11.485 11 11.7206 11 11.9978C11 12.2749 11.097 12.5112 11.291 12.7067C11.485 12.9023 11.7206 13 11.9978 13ZM16.9977 13C17.2749 13 17.5113 12.903 17.7068 12.709C17.9023 12.515 18 12.2794 18 12.0022C18 11.7251 17.903 11.4888 17.709 11.2933C17.515 11.0977 17.2794 11 17.0023 11C16.7251 11 16.4888 11.097 16.2933 11.291C16.0977 11.485 16 11.7206 16 11.9978C16 12.2749 16.097 12.5112 16.291 12.7067C16.485 12.9023 16.7206 13 16.9977 13ZM12.0033 21C10.7587 21 9.58867 20.7638 8.493 20.2915C7.3975 19.8192 6.4445 19.1782 5.634 18.3685C4.8235 17.5588 4.18192 16.6067 3.70925 15.512C3.23642 14.4175 3 13.2479 3 12.0033C3 10.7587 3.23617 9.58867 3.7085 8.493C4.18083 7.3975 4.82183 6.4445 5.6315 5.634C6.44117 4.8235 7.39333 4.18192 8.488 3.70925C9.5825 3.23642 10.7521 3 11.9967 3C13.2413 3 14.4113 3.23617 15.507 3.7085C16.6025 4.18083 17.5555 4.82183 18.366 5.6315C19.1765 6.44117 19.8181 7.39333 20.2908 8.488C20.7636 9.5825 21 10.7521 21 11.9967C21 13.2413 20.7638 14.4113 20.2915 15.507C19.8192 16.6025 19.1782 17.5555 18.3685 18.366C17.5588 19.1765 16.6067 19.8181 15.512 20.2908C14.4175 20.7636 13.2479 21 12.0033 21ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" })));

/* eslint-disable max-len */
const UserNoIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": "UserNoIcon" }),
    React.createElement("path", { d: "M19.8326 21.2596L17.1883 18.6154H4.99986V16.9692C4.99986 16.5564 5.12005 16.1702 5.36043 15.8106C5.60082 15.451 5.92422 15.1718 6.33063 14.9731C7.20883 14.5513 8.08672 14.2301 8.96428 14.0096C9.84184 13.7891 10.7191 13.6654 11.596 13.6385H11.9133C12.0223 13.6385 12.128 13.6449 12.2306 13.6577L2.74023 4.16731L3.45371 3.45386L20.546 20.5462L19.8326 21.2596ZM5.99986 17.6154H16.1883L13.2845 14.7116C13.0588 14.6859 12.8447 14.6635 12.6422 14.6442C12.4396 14.625 12.2255 14.6154 11.9999 14.6154C11.105 14.6154 10.2217 14.7215 9.34986 14.9337C8.47806 15.1458 7.63063 15.4513 6.80756 15.85C6.55499 15.9846 6.35723 16.1494 6.21428 16.3442C6.07133 16.5391 5.99986 16.7474 5.99986 16.9692V17.6154ZM18.0922 15.1846C18.2037 15.2385 18.2922 15.3202 18.3576 15.4298C18.4229 15.5394 18.4576 15.6577 18.4614 15.7846L17.6883 15.0115C17.7575 15.0385 17.8258 15.0654 17.8931 15.0923C17.9604 15.1192 18.0268 15.15 18.0922 15.1846ZM13.6806 10.8692L12.9556 10.1442C13.2749 9.9686 13.5287 9.72277 13.7172 9.40673C13.9056 9.09072 13.9999 8.75002 13.9999 8.38463C13.9999 7.83463 13.804 7.3638 13.4124 6.97213C13.0207 6.58047 12.5499 6.38463 11.9999 6.38463C11.6345 6.38463 11.2938 6.47886 10.9777 6.66731C10.6617 6.85578 10.4159 7.10962 10.2402 7.42886L9.51523 6.70386C9.796 6.27821 10.1543 5.95192 10.5902 5.72501C11.0261 5.49807 11.496 5.38461 11.9999 5.38461C12.8306 5.38461 13.5383 5.67692 14.1229 6.26153C14.7076 6.84615 14.9999 7.55385 14.9999 8.38463C14.9999 8.88847 14.8864 9.35833 14.6595 9.79423C14.4326 10.2301 14.1063 10.5885 13.6806 10.8692Z" })));

const SkipIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'SkipIcon' }),
    React.createElement("path", { d: 'M6.78655 13.5H7.78655C7.90188 12.5167 8.34996 11.6875 9.1308 ' +
            '11.0125C9.91146 10.3375 10.8339 10 11.898 10C12.575 10 13.2969 ' +
            '10.2177 14.0635 10.653C14.8302 11.0882 15.4635 11.7038 15.9635 ' +
            '12.5H13.671V13.5H17.671V9.5H16.671V11.7808C16.0609 10.8398 ' +
            '15.3145 10.141 14.4318 9.6845C13.549 9.22817 12.7044 9 11.898 ' +
            '9C10.5455 9 9.39071 9.434 8.43355 10.302C7.47655 11.1698 ' +
            '6.92755 12.2358 6.78655 13.5ZM12.2513 21C11.0068 21 9.83671 ' +
            '20.7638 8.74105 20.2915C7.64555 19.8192 6.69255 19.1782 5.88205 ' +
            '18.3685C5.07155 17.5588 4.42996 16.6067 3.9573 15.512C3.48446 ' +
            '14.4175 3.24805 13.2479 3.24805 12.0033C3.24805 10.7587 3.48421 ' +
            '9.58867 3.95655 8.493C4.42888 7.3975 5.06988 6.4445 5.87955 ' +
            '5.634C6.68921 4.8235 7.64138 4.18192 8.73605 3.70925C9.83055 ' +
            '3.23642 11.0001 3 12.2448 3C13.4893 3 14.6594 3.23617 15.755 ' +
            '3.7085C16.8505 4.18083 17.8035 4.82183 18.614 5.6315C19.4245 ' +
            '6.44117 20.0661 7.39333 20.5388 8.488C21.0116 9.5825 21.248 ' +
            '10.7521 21.248 11.9967C21.248 13.2413 21.0119 14.4113 20.5395 ' +
            '15.507C20.0672 16.6025 19.4262 17.5555 18.6165 18.366C17.8069 ' +
            '19.1765 16.8547 19.8181 15.76 20.2908C14.6655 20.7636 13.496 ' +
            '21 12.2513 21ZM12.248 20C14.4814 20 16.373 19.225 17.923 ' +
            '17.675C19.473 16.125 20.248 14.2333 20.248 12C20.248 9.76667 ' +
            '19.473 7.875 17.923 6.325C16.373 4.775 14.4814 4 12.248 4C10.0147 ' +
            '4 8.12305 4.775 6.57305 6.325C5.02305 7.875 4.24805 9.76667 ' +
            '4.24805 12C4.24805 14.2333 5.02305 16.125 6.57305 17.675C8.12305 ' +
            '19.225 10.0147 20 12.248 20Z' })));

const RedoIcon = (props) => (React.createElement(SvgIcon, Object.assign({}, props, { "data-testid": 'RedoIcon' }),
    React.createElement("path", { d: 'M9.59024 18C8.28124 18 7.16299 17.5455 6.23549 16.6365C5.30799 ' +
            '15.7275 4.84424 14.6243 4.84424 13.327C4.84424 12.0295 5.30799 ' +
            '10.9295 6.23549 10.027C7.16299 9.12433 8.28124 8.673 9.59024 ' +
            '8.673H17.3325L14.3672 5.70775L15.075 5L19.248 9.173L15.075 ' +
            '13.3463L14.3672 12.6385L17.3325 9.673H9.59024C8.55307 9.673 ' +
            '7.6694 10.0256 6.93924 10.7307C6.20924 11.4359 5.84424 12.3013 ' +
            '5.84424 13.327C5.84424 14.3527 6.20924 15.2212 6.93924 15.9327C7.6694 ' +
            '16.6442 8.55307 17 9.59024 17H16.8442V18H9.59024Z' })));

exports.AddAPhotoIcon = AddAPhotoIcon;
exports.AddHomeWorkIcon = AddHomeWorkIcon;
exports.AddIcon = AddIcon;
exports.AddPropertyIcon = AddPropertyIcon$1;
exports.AlertCriticalIcon = AlertCriticalIcon;
exports.AlertIcon = AlertIcon;
exports.AlertInfoIcon = AlertInfoIcon;
exports.ApplicationIcon = ApplicationIcon;
exports.ApplicationSendIcon = ApplicationSendIcon;
exports.ApprovedWithConditionsIcon = ApprovedWithConditionsIcon;
exports.ArrowBackIcon = ArrowBackIcon;
exports.AssignmentIcon = AssignmentIcon;
exports.AttachmentIcon = AttachmentIcon;
exports.AvatarIcon = AvatarIcon;
exports.BackHandIcon = BackHandIcon;
exports.BalanceIcon = BalanceIcon;
exports.BetweenIcon = BetweenIcon;
exports.BoltIcon = BoltIcon;
exports.BuildingsIcon = ReportsIcon;
exports.CSVIcon = CSVIcon;
exports.CalEndIcon = CalEndIcon;
exports.CalMoveInIcon = CalMoveInIcon;
exports.CalMoveOutIcon = CalMoveOutIcon;
exports.CalStartIcon = CalStartIcon;
exports.CalculateIcon = CalculateIcon;
exports.CalendarIcon = CalendarIcon;
exports.CameraIcon = CameraIcon;
exports.CanceledStatusIcon = CanceledStatusIcon;
exports.CertHistoryIcon = CertHistoryIcon;
exports.CheckBoxSolidIcon = CheckBoxSolidIcon;
exports.CheckCircleFilledIcon = CheckCircleFilledIcon;
exports.CheckIcon = CheckIcon;
exports.CircleCheckIcon = CircleCheckIcon;
exports.CircleDeleteIcon = CircleDeleteIcon;
exports.CircleIcon = CircleIcon;
exports.CloseIcon = CloseIcon;
exports.CloudDownloadIcon = DownloadIcon;
exports.CommentConversationIcon = CommentConversationIcon;
exports.CommentDotsIcon = CommentDotsIcon;
exports.CommentWordsIcon = CommentWordsIcon;
exports.CompletedStatusIcon = CompletedStatusIcon;
exports.ContainsIcon = ContainsIcon;
exports.ContentCopyIcon = ContentCopyIcon;
exports.ContractIcon = ContractIcon;
exports.DateRangeIcon = DateRangeIcon;
exports.DeleteIcon = DeleteIcon;
exports.DoesNotContainIcon = DoesNotContainIcon;
exports.DoesNotEqualIcon = DoesNotEqualIcon;
exports.DownloadIcon = DownloadIcon;
exports.DriveIcon = DriveIcon;
exports.EmergencyHomeIcon = EmergencyHomeIcon;
exports.EmojiPeopleIcon = EmojiPeopleIcon;
exports.EndsWithIcon = EndsWithIcon;
exports.EqualsIcon = EqualsIcon;
exports.ErrorFilledIcon = ErrorFilledIcon;
exports.ErrorIcon = ErrorIcon;
exports.ExcelIcon = ExcelIcon;
exports.ExpandLessIcon = ExpandLessIcon;
exports.ExpandMoreIcon = ExpandMoreIcon;
exports.FamilyHomeIcon = FamilyHomeIcon;
exports.FileDescriptionIcon = FileDescriptionIcon;
exports.FilterIcon = FilterIcon;
exports.FilterOutlinedIcon = FilterOutlinedIcon;
exports.FilterSolidIcon = FilterSolidIcon;
exports.FloppyIcon = FloppyIcon;
exports.FolderIcon = FolderIcon;
exports.FolderOpenIcon = FolderOpenIcon;
exports.FortressLogo = FortressLogo;
exports.FortressTextIcon = FortressTextIcon;
exports.ForumIcon = ForumIcon;
exports.GarageIcon = GarageIcon;
exports.GreaterThanIcon = GreaterThanIcon;
exports.GreaterThanOrEqualToIcon = GreaterThanOrEqualToIcon;
exports.HandyManIcon = HandyManIcon;
exports.HeartIcon = HeartIcon;
exports.HeartPlusIcon = HeartPlusIcon;
exports.HelpIcon = HelpIcon;
exports.HomeHandIcon = HomeHandIcon;
exports.HomeIcon = HomeIcon;
exports.ImageIcon = ImageIcon;
exports.InProgressStatusIcon = InProgressStatusIcon;
exports.InactiveIcon = InactiveIcon;
exports.InsuranceIcon = InsuranceIcon;
exports.KidIcon = KidIcon;
exports.LateFeeIcon = LateFeeIcon;
exports.LaunchIcon = LaunchExternalIcon;
exports.LessThanIcon = LessThanIcon;
exports.LessThanOrEqualToIcon = LessThanOrEqualToIcon;
exports.LibraryIcon = LibraryIcon;
exports.ListIcon = AddPropertyIcon;
exports.LockIcon = LockIcon;
exports.LogoutIcon = LogoutIcon;
exports.MailIcon = MailIcon;
exports.MedicalServicesIcon = MedicalServicesIcon;
exports.MenuArrowLeft = MenuArrowLeft$1;
exports.MenuArrowRight = MenuArrowLeft;
exports.MenuIcon = MenuIcon;
exports.MinusIcon = MinusIcon;
exports.MoneyAltIcon = MoneyAltIcon;
exports.MoneyIcon = MoneyIcon;
exports.NewMessagesIcon = NewMessagesIcon;
exports.NotStartedIcon = NotStartedIcon;
exports.NotesIcon = NotesIcon;
exports.OnHoldStatusIcon = OnHoldStatusIcon;
exports.OpenStatusIcon = OpenStatusIcon;
exports.OverviewIcon = OverviewIcon;
exports.PDFIcon = PDFIcon;
exports.PaymentsIcon = PaymentsIcon;
exports.PencilIcon = PencilIcon;
exports.PendingIcon = PendingIcon;
exports.PeopleIcon = PeopleIcon;
exports.PersonAlertIcon = PersonAlertIcon;
exports.PersonCheckIcon = PersonCheckIcon;
exports.PhoneIcon = PhoneIcon;
exports.PhotoCameraIcon = PhotoCameraIcon;
exports.PlusIcon = PlusIcon;
exports.QualifyIcon = QualifyIcon;
exports.RealEstateAgentIcon = RealEstateAgentIcon;
exports.RedoIcon = RedoIcon;
exports.RefreshIcon = RefreshIcon;
exports.RenewCircleIcon = RenewCircleIcon;
exports.RenewIcon = RenewIcon;
exports.ReorderIcon = ReorderIcon;
exports.ReportsIcon = BuildingsIcon;
exports.SearchIcon = SearchIcon;
exports.SettingsIcon = SettingsIcon;
exports.SkipIcon = SkipIcon;
exports.SortAscendingIcon = SortAscendingIcon;
exports.SortDescendingIcon = SortDescendingIcon;
exports.SortIcon = SortIcon;
exports.TimeIcon = TimeIcon;
exports.TimelapseIcon = TimelapseIcon;
exports.TouchAppIcon = TouchAppIcon;
exports.TrashIcon = TrashIcon;
exports.UnCheckedIcon = UnCheckedIcon;
exports.UploadIcon = UploadIcon;
exports.UserIcon = UserIcon;
exports.UserNoIcon = UserNoIcon;
exports.VerifiedUserIcon = VerifiedUserIcon;
exports.VisibilityIcon = VisibilityIcon;
exports.VisibilityOffIcon = VisibilityOffIcon;
exports.ZoomInIcon = Icon;
